<!-- Loading screen while app initializes -->
<div v-if="app_initializing || language_loading || maintenance_mode"
  class="fixed inset-0 bg-gray-900/20 backdrop-blur-xl z-[9999] flex items-center justify-center">

  <div class="text-center z-[10]" v-if="app_initializing || language_loading">
    <div class="animate-spin rounded-full h-16 w-16 border-b-4 border-rose-500 mx-auto mb-6 soft_shadow"></div>
    <p class="text-gray-300 text-lg font-medium">Loading...</p>
  </div>

  <div class="text-center max-w-md mx-auto px-6  z-[8]" v-if="maintenance_mode">
    <div class="mb-6">
      <svg class="w-16 h-16 mx-auto text-amber-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z">
        </path>
      </svg>
      <h1 class="text-2xl font-bold text-white mb-2">{{ get_t('maintenance.title') }}</h1>
      <p class="text-gray-300 text-sm leading-relaxed">{{ get_t('maintenance.message') }}</p>
    </div>
    <div class="text-xs text-gray-500">
      {{ get_t('maintenance.footer') }}
    </div>
  </div>

</div>

<div v-if="comic_mode===false" v-show="mikogen_landing_visible" class="z-[199]" id="mikogen_landing">

  <div id="niji_lightbox" onclick="this.style.display='none'">
    <img id="niji_lightbox_img" src="" alt="Preview">
  </div>

  <header class="niji_hero_viewport">

    <div class="niji_panel niji_main_panel">
      <img src="./img/promo/masterpiece_lamia.webp" class="niji_zoom_1" alt="Quality">
      <div class="niji_text_gradient">
        <h1 class="niji_main_title text-7xl md:text-[9rem] font-black italic leading-[0.75] mb-6 tracking-tighter">{{
          get_t('mikogen_landing.main_title') }}</h1>
        <p class="text-lg md:text-xl tracking-[0.5em] text-indigo-400 font-bold uppercase">{{
          get_t('mikogen_landing.state_of_art') }}</p>
      </div>
    </div>

    <div class="niji_panel">
      <img src="./img/promo/extra_4.webp" class="niji_zoom_4" alt="Anime style" style="object-position: center 35%;">
      <div class="niji_text_gradient">
        <span class="niji_badge">{{ get_t('mikogen_landing.wide_range_badge') }}</span>
        <p class="text-2xl font-black italic">{{ get_t('mikogen_landing.wide_range_text') }}</p>
      </div>
    </div>

    <div class="niji_panel">
      <img src="./img/promo/extra_3.webp" class="niji_zoom_3" alt="Backgrounds">
      <div class="niji_text_gradient">
        <span class="niji_badge">{{ get_t('mikogen_landing.backgrounds_badge') }}</span>
        <p class="text-2xl font-black italic">{{ get_t('mikogen_landing.backgrounds_text') }}</p>
      </div>
    </div>

    <div class="niji_cta_container niji_reveal">
      <div class="niji_glass_card">
        <p class="text-xs tracking-[0.4em] mb-6 text-white/50 uppercase font-bold cta_upper_text">{{
          get_t('mikogen_landing.cta_upper_text') }}</p>
        <button @click="mikogen_landing_visible = false"
          class="niji_cta_btn bg-white text-black px-16 py-6 rounded-full font-black text-3xl hover:bg-indigo-600 hover:text-white transition-all transform hover:scale-105 active:scale-95 duration-300">
          {{ get_t('mikogen_landing.cta_button') }}
        </button>
        <div class="mt-8 flex justify-center items-center gap-4 text-[10px] font-bold tracking-[0.2em] text-indigo-300">
          <span>{{ get_t('mikogen_landing.high_definition') }}</span>
          <span class="w-1 h-1 bg-white/20 rounded-full"></span>
          <span>{{ get_t('mikogen_landing.ultra_fast') }}</span>
        </div>
      </div>
    </div>
  </header>

  <section class="niji_details_wrapper">
    <div class="text-center mb-24">
      <h2 class="text-4xl md:text-6xl font-black mb-8">{{ get_t('mikogen_landing.new_standard_title') }}</h2>
      <p class="text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
        {{ get_t('mikogen_landing.new_standard_description') }}
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-12 text-sm">
      <div class="border-t border-white/10 pt-8">
        <h3 class="text-indigo-400 font-black mb-4 uppercase tracking-widest">{{
          get_t('mikogen_landing.high_speed_title') }}</h3>
        <p class="text-gray-400 leading-relaxed">
          {{ get_t('mikogen_landing.high_speed_description') }}
        </p>
      </div>
      <div class="border-t border-white/10 pt-8">
        <h3 class="text-indigo-400 font-black mb-4 uppercase tracking-widest">{{
          get_t('mikogen_landing.high_cohesion_title') }}</h3>
        <p class="text-gray-400 leading-relaxed">
          {{ get_t('mikogen_landing.high_cohesion_description') }}
        </p>
      </div>
      <div class="border-t border-white/10 pt-8">
        <h3 class="text-indigo-400 font-black mb-4 uppercase tracking-widest">{{
          get_t('mikogen_landing.unbeatable_cost_title') }}</h3>
        <p class="text-gray-400 leading-relaxed">
          {{ get_t('mikogen_landing.unbeatable_cost_description') }}
        </p>
      </div>
    </div>

    <!-- Galería Secundaria con Lightbox -->
    <div class="mt-32 grid grid-cols-2 md:grid-cols-4 gap-6">
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_1.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 mt-12 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_2.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_3.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 mt-12 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_4.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
    </div>


    <div class="mt-24 grid grid-cols-2 md:grid-cols-4 gap-6">
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_5.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 mt-12 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_6.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_7.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
      <div class="rounded-2xl overflow-hidden aspect-[4/5] bg-zinc-900 mt-12 niji_gallery_img"
        @click="open_lightbox($event.currentTarget)">
        <img src="./img/promo/extra_8.webp" class="w-full h-full object-cover  transition duration-500" />
      </div>
    </div>


    <div class="mt-20 pt-5 border-t border-white/5">
      <p class="text-[13px] tracking-[0.02em]  text-white/25" v-html="get_t('mikogen_landing.demo_note')"></p>
    </div>

    <div class="mt-32 mb-6 px-4">
      <h2 class="text-3xl md:text-5xl font-black mb-12 text-center tracking-tight">{{
        get_t('mikogen_landing.model_showcase_title') }}</h2>

      <div class="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">

        <!-- Mikoniji V1.2 -->
        <div @click="show_model_info('mikoniji_semi_v10.safetensors')"
          class="group relative rounded-[2rem] overflow-hidden aspect-[4/3] md:aspect-[16/9] cursor-pointer border border-white/10 shadow-2xl hover:shadow-rose-500/20 transition-all duration-500">

          <!-- Background Image -->
          <img src="./img/promo/extra_6.webp"
            class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-100"
            alt="Semi-Realism Model">

          <!-- Gradient Overlay -->
          <div class="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-900/80 to-transparent"></div>

          <!-- Glow Effect -->
          <div
            class="absolute -bottom-1/2 -right-1/2 w-full h-full bg-rose-500/20 blur-[100px] group-hover:opacity-40 transition-opacity duration-500 opacity-0">
          </div>

          <div class="relative h-full flex flex-col justify-end p-8 md:p-10 z-10">
            <div class="transform transition-transform duration-500 group-hover:-translate-y-2">
              <div class="flex items-center gap-3 mb-3">
                <span
                  class="px-3 py-1 rounded-full bg-rose-500/20 border border-rose-500/30 text-rose-300 text-[10px] font-bold tracking-widest uppercase backdrop-blur-md">Semi
                  Realism</span>
              </div>
              <h3 class="text-3xl md:text-4xl font-black text-white italic tracking-tighter mb-3">{{
                available_models[1].display_name }}</h3>
              <p
                class="text-gray-400 text-sm md:text-base leading-relaxed mb-6 max-w-md line-clamp-2 group-hover:text-gray-300 transition-colors">
                {{ get_t('mikogen_landing.mikoniji_description') }}</p>

              <div
                class="flex items-center gap-3 text-white font-bold text-sm tracking-widest uppercase group-hover:gap-5 transition-all duration-300">
                <span>{{ get_t('mikogen_landing.view_more_examples') }}</span>
                <svg class="w-5 h-5 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3">
                  </path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Mikomic Anime V3 -->
        <div @click="show_model_info('mikomic_anime_base_v3.safetensors')"
          class="group relative rounded-[2rem] overflow-hidden aspect-[4/3] md:aspect-[16/9] cursor-pointer border border-white/10 shadow-2xl hover:shadow-purple-500/20 transition-all duration-500">

          <!-- Background Image -->
          <img src="./img/promo/extra_8.webp"
            class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-100"
            alt="Anime Model" style="object-position: 0 33%;">

          <!-- Gradient Overlay -->
          <div class="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-900/80 to-transparent"></div>

          <!-- Glow Effect -->
          <div
            class="absolute -bottom-1/2 -left-1/2 w-full h-full bg-purple-500/20 blur-[100px] group-hover:opacity-40 transition-opacity duration-500 opacity-0">
          </div>

          <div class="relative h-full flex flex-col justify-end p-8 md:p-10 z-10">
            <div class="transform transition-transform duration-500 group-hover:-translate-y-2">
              <div class="flex items-center gap-3 mb-3">
                <span
                  class="px-3 py-1 rounded-full bg-purple-500/20 border border-purple-500/30 text-purple-300 text-[10px] font-bold tracking-widest uppercase backdrop-blur-md">Anime
                  Style</span>
              </div>
              <h3 class="text-3xl md:text-4xl font-black text-white italic tracking-tighter mb-3">{{
                available_models[0].display_name }}</h3>
              <p
                class="text-gray-400 text-sm md:text-base leading-relaxed mb-6 max-w-md line-clamp-2 group-hover:text-gray-300 transition-colors">
                {{ get_t('mikogen_landing.mikomic_anime_description') }}</p>

              <div
                class="flex items-center gap-3 text-white font-bold text-sm tracking-widest uppercase group-hover:gap-5 transition-all duration-300">
                <span>{{ get_t('mikogen_landing.view_more_examples') }}</span>
                <svg class="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3">
                  </path>
                </svg>
              </div>
            </div>
          </div>
        </div>


      </div>

      <!-- Bottom CTA -->
      <div class="mt-24 mb-12 flex justify-center">
        <button @click="mikogen_landing_visible = false"
          class="group relative px-12 py-5 bg-white text-black rounded-full font-black text-xl hover:bg-rose-500 hover:text-white transition-all transform hover:scale-105 active:scale-95 duration-300 shadow-[0_0_40px_-10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_-5px_rgba(244,63,94,0.5)]">
          <span class="relative z-10 flex items-center gap-3">
            {{ get_t('mikogen_landing.cta_button') }}
            <svg class="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
            </svg>
          </span>
        </button>
      </div>

    </div>

  </section>

  <section class="text-center">

    <div class="flex justify-center gap-6 py-4 backdrop-blur-sm">
      <a href="#" @click.prevent="show_privacy_policy()"
        class="text-sm text-white/40 hover:text-rose-400 transition-colors">
        {{ get_t('menu.about_submenu.privacy_policy') }}
      </a>
      <a href="#" @click.prevent="show_terms_of_use()"
        class="text-sm text-white/40 hover:text-rose-400 transition-colors">
        {{ get_t('menu.about_submenu.terms_of_use') }}
      </a>
    </div>

  </section>

  <footer class="py-20 text-center border-t border-white/5">
    <p class="text-[11px] tracking-[0.5em] text-white/20 uppercase font-bold">{{ get_t('mikogen_landing.footer_text', {
      year: new Date().getFullYear() }) }}</p>
  </footer>

</div>

<!-- MIKOGEN GENERATOR UI -->
<div v-if="comic_mode===false && mikogen_generator_active" id="mikogen_generator_ui"
  class="flex flex-col min-h-screen bg-gray-950 custom-scrollbar">

  <!-- Mikogen Top Bar -->
  <div
    class="bg-gradient-to-r from-gray-950 via-gray-900 to-gray-950 border-b border-gray-700/50 p-1 sm:p-2 md:p-3 flex items-center justify-between relative shadow-xl z-[100]">
    <div class="flex items-center gap-2">
      <!-- Logo -->
      <div class="flex items-end gap-1 cursor-pointer select-none" @click="window.location.reload()">
        <img src="./img/logo_mobile.png" :alt="get_t('logo.alt_text')" class="h-6 sm:h-7 md:h-8 mb-0.5">
        <span
          class="text-white font-bold text-xl md:text-3xl tracking-tight leading-none hidden md:block ikogen_text">{{
          get_t('mikogen.logo_text') }}</span>
      </div>

      <!-- Mobile Hamburger Menu -->
      <button @click="toggle_mobile_menu" 
        class="md:hidden p-1.5 hover:bg-gray-700/50 rounded-lg transition-colors"
        :class="{ 'bg-gray-700/50': show_mobile_menu }">
        <svg class="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>

    <div class="flex items-center gap-2">
      <!-- Discord Link (always visible) -->
      <a href="https://discord.gg/mYmpYeMdDU" target="_blank" :title="get_t('mikogen.nav.discord')"
        class="hidden md:flex items-center justify-center w-8 h-8 md:w-9 md:h-9 bg-indigo-600/10 hover:bg-indigo-600/20 border border-indigo-500/20 hover:border-indigo-500/40 rounded-lg group transition-all duration-200 mr-2">
        <svg class="w-4 h-4 md:w-5 md:h-5 text-indigo-400 group-hover:text-indigo-300 transition-colors" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
        </svg>
      </a>

      <!-- Create Comics Link (always visible) -->
      <a href="https://mikomic.com" target="_blank"
        class="hidden md:flex items-center gap-1 md:gap-2 px-2 py-1 md:px-3 md:py-1.5 bg-rose-600/10 hover:bg-rose-600/20 border border-rose-500/20 hover:border-rose-500/40 rounded-lg group transition-all duration-200 mr-2">
        <i data-lucide="pencil"
          class="w-3 h-3 md:w-4 md:h-4 text-rose-400 group-hover:text-rose-300 transition-colors flex-shrink-0"></i>
        <span class="text-xs md:text-sm font-bold text-rose-100 group-hover:text-white truncate">{{ get_t('mikogen.nav.create_comics') }}</span>
      </a>

      <!-- Pricing Link (always visible) -->
      <button @click="show_pricing()"
        class="hidden md:flex items-center gap-1 md:gap-2 px-2 py-1 md:px-3 md:py-1.5 bg-gradient-to-r from-amber-500/10 to-amber-600/10 hover:from-amber-500/20 hover:to-amber-600/20 border border-amber-500/20 hover:border-amber-500/40 rounded-lg group transition-all duration-200">
        <i data-lucide="crown"
          class="w-3 h-3 md:w-4 md:h-4 text-amber-400 group-hover:text-amber-300 transition-colors flex-shrink-0"></i>
        <span class="text-xs md:text-sm font-bold text-amber-100 group-hover:text-white truncate">{{
          get_t('mikogen.nav.pricing') }}</span>
      </button>

      <!-- Auth buttons (desktop only) -->
      <div v-if="!user_data.email" class="flex items-center gap-2">
        <button @click="show_login_modal"
          class="px-3 py-1.5 md:px-4 md:py-1.5 text-xs md:text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-800 rounded-md transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
          </svg>
          {{ get_t('mikogen.nav.login') }}
        </button>
        <button @click="show_register_modal"
          class="px-3 py-1.5 md:px-4 md:py-1.5 text-xs md:text-sm font-bold text-white bg-gradient-to-r from-rose-600 to-rose-500 hover:from-rose-500 hover:to-rose-400 rounded-md shadow-lg shadow-rose-900/20 transition-all transform hover:scale-105 active:scale-95 flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
          </svg>
          {{ get_t('mikogen.nav.register') }}
        </button>
      </div>

      <!-- User info (logged in only) -->
      <div v-else class="flex items-center gap-2 md:gap-4">
        <!-- Credits Display -->
        <div class="flex items-center gap-1.5 md:gap-2 px-2 md:px-3 py-1.5 bg-gray-800/50 border border-gray-700/50 rounded-lg"
          :title="get_t('ai.available_credits')">
          <i data-lucide="zap" class="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400"></i>
          <span class="font-bold text-gray-200" :class="{
            'text-xs': ai_credits >= 1000000,
            'text-sm': ai_credits >= 10000 && ai_credits < 1000000,
            'text-base': ai_credits < 10000
          }">{{ ai_credits }}</span>
        </div>

        <!-- User Menu Trigger -->
        <div class="relative">
          <div
            class="flex items-center gap-3 px-3 py-1.5 bg-gray-800/50 border border-gray-700/50 rounded-lg hover:bg-gray-700/50 transition-colors cursor-pointer group"
            @click="toggle_user_menu">
            <div class="text-sm font-bold text-gray-200 group-hover:text-white transition-colors">{{
              user_data.display_name || user_data.email }}</div>

            <!-- Tier Badge -->
            <span class="px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-md border" :class="{
                                'bg-gray-800 text-gray-400 border-gray-700': user_data.tier === 'free',
                                'bg-amber-500/20 text-amber-400 border-amber-500/30': user_data.tier === 'premium',
                                'bg-purple-500/20 text-purple-400 border-purple-500/30': user_data.tier === 'creator_pro'
                            }">
              {{ user_data.tier === 'free' ? 'Free' : (user_data.tier === 'premium' ? 'Premium' : 'Creator Pro') }}
            </span>

            <i data-lucide="chevron-down" class="w-4 h-4 text-gray-400 group-hover:text-white transition-colors"></i>
          </div>

          <!-- User Dropdown Menu -->
          <div v-if="show_user_menu"
            class="absolute top-full right-0 mt-2 w-56 bg-[#1a1b26] border border-gray-700 rounded-lg shadow-2xl z-[200] overflow-hidden">
            <div class="p-3 border-b border-gray-700/50" v-if="user_data.email">
              <div class="font-medium text-white truncate">{{ user_data.display_name }}</div>
              <div class="text-xs text-gray-500 truncate">{{ user_data.email }}</div>
            </div>
            <div class="py-1 border-b border-gray-700/50">
              <a v-if="user_data && user_data.tier !== 'free'" href="#"
                @click.prevent="manage_subscription(); show_user_menu = false"
                class="block px-4 py-2 text-sm text-gray-200 hover:bg-gray-800/50 transition-colors flex items-center gap-2">
                <i data-lucide="credit-card" class="w-4 h-4"></i>
                {{ get_t('mikogen.nav.manage_subscription') }}
              </a>

              <!-- Cancel subscription -->
              <a v-if="user_data && user_data.tier !== 'free'" href="#"
                @click.prevent="handle_subscription_toggle(); show_user_menu = false"
                class="block px-4 py-2 text-sm text-gray-200 hover:bg-gray-800/50 transition-colors flex items-center gap-2">
                <i :data-lucide="user_data.cancel_at_period_end ? 'refresh-cw' : 'user-x'" class="w-4 h-4"></i>
                {{ user_data.cancel_at_period_end ? get_t('subscription.reactivate_subscription') :
                get_t('subscription.cancel_subscription') }}
              </a>

              <!-- Explore plans / Store -->
              <a href="#" @click.prevent="show_pricing(); show_user_menu = false"
                class="block px-4 py-2 text-sm text-amber-400 hover:bg-gray-800/50 transition-colors flex items-center gap-2">
                <i data-lucide="crown" class="w-4 h-4"></i>
                {{ get_t('pricing.explore_plans') }}
              </a>
            </div>

            <div class="px-3 py-2 border-b border-gray-700/50">
              <label class="block text-xs text-gray-400 mb-2 font-medium uppercase tracking-wider">
                {{ get_t('preferences.interface.language') }}
              </label>
              <select v-model="preferences.interface.language"
                class="w-full bg-gray-800 border border-gray-700 rounded-md py-1.5 px-2 text-sm text-white"
                @change="change_language(preferences.interface.language); show_user_menu = false">
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="cn">中文</option>
                <option value="jp">日本語</option>
                <option value="kr">한국어</option>
              </select>
            </div>

            <div class="py-1">
              <a href="#" @click.prevent="logout"
                class="block px-4 py-2 text-sm text-red-400 hover:bg-gray-800/50 transition-colors flex items-center gap-2">
                <i data-lucide="log-out" class="w-4 h-4"></i>
                {{ get_t('auth.sign_out') }}
              </a>
            </div>
          </div>
        </div>

        <!-- Close dropdown when clicking outside -->
        <div v-if="show_user_menu" @click.stop="show_user_menu = false" class="fixed inset-0 z-[190]"></div>
      </div>
    </div>

    <!-- Mobile Menu Dropdown -->
    <div v-if="show_mobile_menu"
      class="absolute top-full left-0 right-0 mt-0 bg-gray-900/98 backdrop-blur-lg border-b border-gray-700/50 shadow-2xl z-[150] md:hidden">
      <div class="p-4 space-y-2">
        <!-- Discord -->
        <a href="https://discord.gg/mYmpYeMdDU" target="_blank" 
          @click="show_mobile_menu = false"
          class="flex items-center gap-3 px-4 py-3 bg-indigo-600/10 hover:bg-indigo-600/20 border border-indigo-500/20 rounded-lg transition-all">
          <svg class="w-5 h-5 text-indigo-400" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
          </svg>
          <span class="text-sm font-bold text-indigo-100">{{ get_t('mikogen.nav.discord') }}</span>
        </a>

        <!-- Create Comics -->
        <a href="https://mikomic.com" target="_blank" 
          @click="show_mobile_menu = false"
          class="flex items-center gap-3 px-4 py-3 bg-rose-600/10 hover:bg-rose-600/20 border border-rose-500/20 rounded-lg transition-all">
          <i data-lucide="pencil" class="w-5 h-5 text-rose-400"></i>
          <span class="text-sm font-bold text-rose-100">{{ get_t('mikogen.nav.create_comics') }}</span>
        </a>

        <!-- Pricing -->
        <button @click="show_pricing(); show_mobile_menu = false"
          class="w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-amber-500/10 to-amber-600/10 hover:from-amber-500/20 hover:to-amber-600/20 border border-amber-500/20 rounded-lg transition-all">
          <i data-lucide="crown" class="w-5 h-5 text-amber-400"></i>
          <span class="text-sm font-bold text-amber-100">{{ get_t('mikogen.nav.pricing') }}</span>
        </button>
      </div>
    </div>
    <!-- Close mobile menu when clicking outside -->
    <div v-if="show_mobile_menu" @click="show_mobile_menu = false" class="fixed inset-0 z-[140]"></div>
  </div>

  <!-- Generator Content Placeholder -->
  <div v-if="ai_panel_ready"
    class="flex-1 bg-gradient-to-br from-gray-900 via-gray-850 to-gray-900 p-2 md:p-4 flex flex-col min-h-0 overflow-y-auto lg:overflow-hidden">

    <!-- MIKOGEN NEXT-GEN GRID LAYOUT -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:h-full lg:min-h-0 h-auto">

      <!-- LEFT BLOCK (Span 8): Models, Prompts, Settings -->
      <div class="col-span-1 lg:col-span-8 flex flex-col gap-4 lg:h-full lg:min-h-0 h-auto">

        <!-- ROW 1: HEADER (Models & Styles) -->
        <div
          class="bg-gray-800/50 rounded-xl p-3 md:p-4 border border-gray-700/50 flex flex-col md:flex-row gap-4 shadow-lg flex-shrink-0 overflow-x-auto">
          <!-- Model Selection -->
          <div class="flex-shrink-0">
            <h3 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">{{ get_t('ai.model_selection') }}
            </h3>

            <!-- Models (Unified View) -->
            <div class="flex gap-3 overflow-x-auto pb-2 -mx-3 px-3 md:mx-0 md:px-0 custom-scrollbar snap-x">
              <div v-for="model in available_models" :key="model.name"
                v-show="show_legacy_models || (!show_legacy_models && model.id===1)"
                @click="model.enabled ? handle_model_change(model.name) : null"
                class="relative group transition-all duration-200 overflow-hidden flex-shrink-0 rounded-xl border-2 shadow-md cursor-pointer"
                :class="[
                    model.enabled && ai_settings.model === model.name ? 'border-purple-500 bg-purple-500/10 ring-1 ring-purple-500/40' : 'border-gray-700 hover:border-gray-500 bg-gray-800'
                  ]" style="width: 100px;">
                <div class="aspect-[2/2.2] flex items-center justify-center relative">
                  <img :src="'./img/ai/models/' + model.id + '.webp'"
                    class="w-full h-full object-cover smooth-scaling transition-transform duration-500 group-hover:scale-110"
                    loading="lazy">
                  <div v-if="!model.enabled"
                    class="absolute inset-0 bg-black/70 flex items-center justify-center backdrop-blur-sm"><span
                      class="text-xs font-bold text-white uppercase tracking-widest">{{ get_t('ai.model_coming_soon')
                      }}</span></div>

                  <!-- Info Button (Restored) -->
                  <button @click.stop="show_model_info(model.name)"
                    class="absolute top-1 right-1 w-6 h-6 bg-black/40 hover:bg-purple-600 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/10 transition-colors z-10">
                    <i data-lucide="circle-help" class="w-3.5 h-3.5 text-white"></i>
                  </button>
                </div>
                <div class="p-1.5 bg-gray-900/90">
                  <p class="text-[9px] text-center font-bold text-gray-300 leading-tight">{{ model.display_name }}</p>
                </div>
              </div>

              <!-- New Variants (If legacy hidden) -->
              <div v-for="variant in model_variants" :key="variant.id" v-show="!show_legacy_models"
                @click="select_variant(variant.id)"
                class="relative group transition-all duration-200 overflow-hidden flex-shrink-0 rounded-xl border-2 shadow-md cursor-pointer"
                :class="[current_variant === variant.id ? 'border-purple-500 bg-purple-500/10 ring-1 ring-purple-500/40' : 'border-gray-700 hover:border-gray-500 bg-gray-800']"
                style="width: 100px;">
                <div class="aspect-[2/2.2] relative">
                  <img :src="'./img/ai/models2/' + variant.id + '.webp'"
                    class="w-full h-full object-cover smooth-scaling transition-transform duration-500 group-hover:scale-110"
                    loading="lazy">
                </div>
                <div class="p-1.5 bg-gray-900/90">
                  <p class="text-xs text-center font-bold text-gray-300 leading-tight">{{ variant.display_name }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="hidden md:block w-px bg-gradient-to-b from-transparent via-gray-600 to-transparent mx-2"></div>

          <!-- Style Selection -->
          <div class="flex-shrink-0">
            <h3 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">{{ get_t('ai.style_selection') }}
            </h3>
            <div class="flex gap-3 overflow-x-auto pb-2 -mx-3 px-3 md:mx-0 md:px-0 custom-scrollbar snap-x">
              <div v-for="style in filtered_styles" :key="style.id" @click="ai_settings.style = style.id"
                class="group cursor-pointer rounded-xl border-2 transition-all duration-200 overflow-hidden w-[100px] shadow-md"
                :class="ai_settings.style === style.id ? 'border-purple-500 bg-purple-500/10 ring-1 ring-purple-500/40' : 'border-gray-700 hover:border-gray-500 bg-gray-800'">
                <div class="aspect-[2/2.2] relative">
                  <img
                    :src="(ai_settings.model && ai_settings.model.includes('mikoniji_semi') ? './img/ai/style_niji_' : './img/ai/style_') + style.id + '.webp'"
                    class="w-full h-full object-cover object-top smooth-scaling transition-transform duration-500 group-hover:scale-110">
                </div>
                <div class="p-1.5 bg-gray-900/90">
                  <p class="text-xs text-gray-300 text-center font-bold leading-tight">{{ get_t('ai.' + style.name)
                    }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="hidden md:block w-px bg-gradient-to-b from-transparent via-gray-600 to-transparent mx-2"></div>

          <!-- Drag and Drop Metadata - Moved Here -->
          <div class="flex-shrink-0 flex-grow w-full md:w-auto flex flex-col">
            <h3 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">{{ get_t('ai.load_metadata') }}
            </h3>
            <div @drop="handle_ai_metadata_drop" @dragenter="handle_ai_drag_enter" @dragleave="handle_ai_drag_leave"
              @dragover="handle_ai_drag_over" @click="$refs.file_input_mikogen?.click()"
              class="flex-1 border border-dashed border-gray-600 hover:border-purple-500 hover:bg-purple-500/5 rounded-xl flex flex-col items-center justify-center p-2 text-center transition-all cursor-pointer group relative overflow-hidden bg-gray-900/50 min-h-[100px] md:min-h-0">
              <div
                class="absolute inset-0 bg-gradient-to-br from-transparent to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity">
              </div>
              <i data-lucide="image-plus"
                class="w-5 h-5 text-gray-500 group-hover:text-purple-400 mx-auto mb-1 transition-colors relative z-10"></i>
              <p
                class="text-xs font-bold text-gray-400 group-hover:text-gray-300 uppercase tracking-wide relative z-10 leading-tight">
                {{ get_t('ai.load_from_metadata') }}</p>
              <input ref="file_input_mikogen" type="file" accept="image/*" @change="handle_ai_metadata_drop"
                class="hidden">
            </div>
          </div>

        </div>

        <!-- ROW 2: CONTROLS & SETTINGS (Split Grid / Flex Grow) -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 lg:flex-1 lg:min-h-0 h-auto text-left">

          <!-- Col A: Prompts & Generator (Full Height) -->
          <div
            class="bg-gray-800/30 rounded-xl border border-gray-700/30 flex flex-col shadow-inner lg:h-full lg:min-h-0 lg:overflow-hidden h-full min-h-0">

            <!-- PROMPT SECTION -->
            <div
              class="px-4 py-3 flex justify-between items-center cursor-pointer border-b border-gray-700/50 bg-gray-800/50 rounded-t-xl hover:bg-gray-800 transition-colors flex-shrink-0"
              @click="mikogen_collapsed_sections.positive_prompt = !mikogen_collapsed_sections.positive_prompt">
              <span class="text-xs font-bold text-gray-300 uppercase tracking-wider">{{ get_t('ai.positive_prompt')
                }}</span>
              <div class="flex items-center gap-2">
                <button @click.stop="ai_prompts.positive = ''"
                  class="text-xs text-gray-500 hover:text-purple-400 transition-colors"
                  :title="get_t('ai.clear_prompt')"><i data-lucide="eraser" class="w-3.5 h-3.5"></i></button>
                <i :data-lucide="mikogen_collapsed_sections.positive_prompt ? 'chevron-down' : 'chevron-up'"
                  class="w-4 h-4 text-gray-400"></i>
              </div>
            </div>

            <!-- Scrollable Area Content (Flex 1 to grow) -->
            <div v-show="!mikogen_collapsed_sections.positive_prompt"
              class="p-4 space-y-4 animate-fade-in-down flex-1 flex flex-col min-h-0 overflow-y-auto custom-scrollbar">

              <!-- Positive Prompt (Expands to fill available space) -->
              <div class="flex flex-col flex-1 min-h-[400px] lg:min-h-[200px]">
                <div class="relative flex-1 group">
                  <textarea v-model="ai_prompts.positive"
                    class="w-full h-full bg-gray-800/80 border border-gray-600/50 rounded-xl px-4 py-3 text-gray-100 text-base lg:text-sm resize-none focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500/50 transition-all font-sans leading-relaxed custom-scrollbar shadow-inner"
                    :placeholder="sample_prompts.sample_pos_pro"></textarea>
                  <div
                    class="absolute bottom-2 right-2 flex gap-1 items-center bg-gray-900/80 px-2 py-1 rounded text-xs text-gray-500 font-mono">
                    {{ai_prompts.positive.length}} chars</div>
                </div>
              </div>

              <!-- Enhancements Toggles (Pill Style) - Pinned at bottom of flex container -->
              <div class="grid grid-cols-3 gap-2 p-1 bg-gray-800/50 rounded-lg border border-gray-700/50 flex-shrink-0">
                <button @click="ai_settings.use_enhanced_prompt = !ai_settings.use_enhanced_prompt"
                  class="py-2.5 rounded-md text-xs leading-tight font-medium flex flex-col items-center justify-center gap-1 transition-all"
                  :class="ai_settings.use_enhanced_prompt ? 'bg-gradient-to-r from-purple-600 to-purple-500 text-white shadow' : 'text-gray-400 hover:text-white hover:bg-gray-700'">
                  <i :data-lucide="ai_settings.use_enhanced_prompt ? 'zap' : 'zap-off'" class="w-3.5 h-3.5"></i>
                  {{ get_t('ai.enhanced_prompt') }}
                </button>

                <button @click="ai_settings.reinforce_background = !ai_settings.reinforce_background"
                  class="py-2.5 rounded-md text-xs leading-tight font-medium flex flex-col items-center justify-center gap-1 transition-all"
                  :class="ai_settings.reinforce_background ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30' : 'text-gray-400 hover:text-white hover:bg-gray-700'">
                  <i data-lucide="image" class="w-3.5 h-3.5"></i>
                  {{ get_t('ai.reinforce_background') }}
                </button>

                <div class="relative">
                  <button @click="ai_settings.use_prompt_hand_fixer = !ai_settings.use_prompt_hand_fixer"
                    class="w-full h-full py-2.5 rounded-md text-xs leading-tight font-medium flex flex-col items-center justify-center gap-1 transition-all"
                    :class="ai_settings.use_prompt_hand_fixer ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30' : 'text-gray-400 hover:text-white hover:bg-gray-700'">
                    <i data-lucide="hand" class="w-3.5 h-3.5"></i>
                    {{ get_t('ai.hand_fixer') }}
                  </button>
                  <button @click.stop="show_hand_fixer_warning"
                    class="absolute top-0.5 right-0.5 p-1 text-amber-500 hover:text-amber-300 animate-pulse"
                    :title="get_t('ai.hand_fixer_info')">
                    <i data-lucide="alert-triangle" class="w-3 h-3"></i>
                  </button>
                </div>
              </div>

              <!-- Anime Reinforce Slider -->
              <div class="px-1 flex-shrink-0">
                <div class="flex justify-between text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">
                  <span>{{ get_t('ai.reinforce_anime') }}</span>
                  <span class="text-purple-400">{{ ai_settings.reinforce_anime }}</span>
                </div>
                <input type="range" v-model.number="ai_settings.reinforce_anime" min="0" max="20" step="1"
                  class="w-full h-1.5 bg-gray-700 rounded-full appearance-none cursor-pointer slider-accent"
                  :style="`background: linear-gradient(to right, #a855f7 ${(ai_settings.reinforce_anime/20)*100}%, #ffffff ${(ai_settings.reinforce_anime/20)*100}%)`">
              </div>
            </div>

            <!-- NEGATIVE PROMPT SECTION -->
            <div
              class="px-4 py-3 flex justify-between items-center cursor-pointer border-y border-gray-700/50 bg-gray-800/50 hover:bg-gray-800 transition-colors flex-shrink-0"
              @click="mikogen_collapsed_sections.negative_prompt = !mikogen_collapsed_sections.negative_prompt">
              <span class="text-xs font-bold text-gray-300 uppercase tracking-wider">{{ get_t('ai.negative_prompt')
                }}</span>
              <i :data-lucide="mikogen_collapsed_sections.negative_prompt ? 'chevron-down' : 'chevron-up'"
                class="w-4 h-4 text-gray-400"></i>
            </div>

            <div v-show="!mikogen_collapsed_sections.negative_prompt" class="p-4 animate-fade-in-down flex-shrink-0">
              <!-- Negative Prompt System -->
              <div>
                <div class="bg-gray-800/40 rounded-xl p-3 border border-gray-700/30">
                  <!-- Mode Buttons -->
                  <div class="flex gap-1 p-0.5 bg-gray-900/50 rounded-lg mb-2">
                    <button @click="ai_settings.use_mikomic_negative = 4; handle_negative_prompt_change()"
                      class="flex-1 py-2.5 text-[10px] uppercase font-bold tracking-wider rounded-md transition-all"
                      :class="[1,4,5].includes(ai_settings.use_mikomic_negative) ? 'bg-purple-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800'">
                      {{ get_t('ai.custom_negative_mode') }}
                    </button>
                    <button @click="ai_settings.use_mikomic_negative = 2; handle_negative_prompt_change()"
                      class="flex-1 py-2.5 text-[10px] uppercase font-bold tracking-wider rounded-md transition-all"
                      :class="ai_settings.use_mikomic_negative === 2 ? 'bg-purple-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800'">
                      {{ get_t('ai.negative_modes.general') }}
                    </button>
                    <button @click="ai_settings.use_mikomic_negative = 3; handle_negative_prompt_change()"
                      class="flex-1 py-2.5 text-[10px] uppercase font-bold tracking-wider rounded-md transition-all"
                      :class="ai_settings.use_mikomic_negative === 3 ? 'bg-purple-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800'">
                      {{ get_t('ai.negative_modes.detailed') }}
                    </button>
                  </div>

                  <!-- Custom Input -->
                  <div v-show="[1,4,5].includes(ai_settings.use_mikomic_negative)" class="animate-fade-in-down">
                    <textarea v-model="ai_prompts.negative" rows="6"
                      class="w-full bg-gray-900 border border-gray-600/50 rounded-lg px-3 py-2 text-xs text-gray-300 resize-none focus:border-purple-500/50 focus:ring-1 focus:ring-purple-500/50 custom-scrollbar"
                      :placeholder="get_t('ai.custom_negative_placeholder')"></textarea>
                    <!-- Add to buttons -->
                    <div class="flex gap-2 mt-2 px-1" v-if="[1,4,5].includes(ai_settings.use_mikomic_negative)">
                      <button @click="toggle_add_general"
                        class="flex items-center gap-1.5 px-2 py-1.5 rounded transition-all border text-[10px] font-bold"
                        :class="ai_settings.use_mikomic_negative === 4 ? 'bg-purple-500/20 border-purple-500/40 text-purple-300' : 'bg-gray-800 border-gray-700 text-gray-500 hover:bg-gray-700 hover:text-gray-300'">
                        <i :data-lucide="ai_settings.use_mikomic_negative === 4 ? 'check' : 'plus'" class="w-3 h-3"></i>
                        {{ get_t('ai.add_to_general') }}
                      </button>

                      <button @click="toggle_add_detailed"
                        class="flex items-center gap-1.5 px-2 py-1.5 rounded transition-all border text-[10px] font-bold"
                        :class="ai_settings.use_mikomic_negative === 5 ? 'bg-purple-500/20 border-purple-500/40 text-purple-300' : 'bg-gray-800 border-gray-700 text-gray-500 hover:bg-gray-700 hover:text-gray-300'">
                        <i :data-lucide="ai_settings.use_mikomic_negative === 5 ? 'check' : 'plus'" class="w-3 h-3"></i>
                        {{ get_t('ai.add_to_detailed') }}
                      </button>
                    </div>
                    <!-- Quality warning for full custom mode -->
                    <div v-if="ai_settings.use_mikomic_negative === 1"  
                      class="mt-2 p-2 bg-red-900/20 border border-red-700/50 rounded text-xs text-red-400 flex items-start gap-2">
                      <i data-lucide="alert-triangle" class="w-3 h-3 text-red-400 mt-0.5 flex-shrink-0"></i>
                      {{ get_t('ai.quality_warning_custom_negative') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- GENERATE BUTTON (Moved Here) -->
            <div class="flex-shrink-0 p-4 border-t border-gray-700/30 bg-gray-800/20 rounded-b-xl">
              <button @click="generate_ai_image" :disabled="ai_generating"
                class="w-full py-4 px-4 rounded-xl font-bold text-base transition-all duration-200 transform active:scale-[0.98] shadow-lg shadow-purple-900/20 group relative overflow-hidden"
                :class="ai_generating ? 'bg-red-600/10 border border-red-500/50 text-red-100' : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white'">

                <div v-show="ai_generating" class="absolute inset-0 bg-red-500/10 animate-pulse"></div>

                <span v-if="ai_generating" class="flex items-center justify-center gap-3 relative z-10">
                  <i data-lucide="loader-2" class="animate-spin w-5 h-5"></i>
                  {{ ai_queue_status === 'queued' ? get_t('ai.queued_position') + ' ' + ai_queue_position :
                  get_t('ai.generating') }}
                </span>
                <span v-else class="flex items-center justify-center gap-2 relative z-10">
                  <i data-lucide="wand-2" class="w-5 h-5 group-hover:animate-pulse"></i>
                  {{ get_t('ai.generate') }}
                  <span
                    class="bg-black/20 px-1.5 py-0.5 rounded text-xs font-mono opacity-80 border border-white/10 group-hover:border-white/20">{{
                    get_generation_cost() }}</span>
                </span>
              </button>
              <div class="flex justify-between items-center mt-3 px-1">
                <span class="text-[10px] text-gray-500 font-bold uppercase tracking-wider">{{
                  get_t('ai.available_credits') }}</span>
                <span
                  class="text-xs font-mono font-bold text-purple-400 bg-purple-500/10 px-2 py-0.5 rounded border border-purple-500/20 shadow-sm">{{
                  get_available_ai_credits() }}</span>
              </div>
            </div>

          </div>

          <!-- Col B: Settings & Tools & Generate Button (Full Height) -->
          <div
            class="bg-gray-800/30 rounded-xl border border-gray-700/30 flex flex-col shadow-inner lg:h-full lg:min-h-0 lg:overflow-hidden h-auto">

            <!-- SCROLLABLE SETTINGS CONTAINER -->
            <div class="lg:flex-1 lg:overflow-y-auto custom-scrollbar lg:min-h-0 h-auto">
              <!-- SIZE PRESETS SECTION -->
              <div
                class="px-4 py-3 flex justify-between items-center cursor-pointer border-b border-gray-700/50 bg-gray-800/50 rounded-t-xl hover:bg-gray-800 transition-colors"
                @click="mikogen_collapsed_sections.size_presets = !mikogen_collapsed_sections.size_presets">
                <span class="text-xs font-bold text-gray-300 uppercase tracking-wider">{{ get_t('ai.size_presets')
                  }}</span>
                <div class="flex items-center gap-2">
                  <span
                    class="text-xs font-mono text-purple-400 bg-purple-500/10 px-1.5 py-0.5 rounded border border-purple-500/20">{{
                    ai_settings.width }}x{{ ai_settings.height }}</span>
                  <i :data-lucide="mikogen_collapsed_sections.size_presets ? 'chevron-down' : 'chevron-up'"
                    class="w-4 h-4 text-gray-400"></i>
                </div>
              </div>

              <div v-show="!mikogen_collapsed_sections.size_presets" class="p-4 space-y-4 animate-fade-in-down">
                <!-- Preset Buttons -->
                <div class="flex gap-2 bg-gray-800/50 p-1 rounded-lg">
                  <button @click="set_size_preset('16:9')"
                    class="flex-1 p-2 rounded hover:bg-gray-700 transition-all flex justify-center group"
                    :class="Math.abs((ai_settings.width/ai_settings.height) - (16/9)) < 0.1 || Math.abs((ai_settings.height/ai_settings.width) - (16/9)) < 0.1 ? 'bg-gray-700 ring-1 ring-gray-600' : ''">
                    <div
                      class="w-3.5 h-6 border-2 border-gray-500 rounded-[2px] group-hover:border-gray-300 transition-transform duration-300"
                      :class="!presets_rotated?'rotate-90':''"></div>
                  </button>
                  <button @click="set_size_preset('2:3')"
                    class="flex-1 p-2 rounded hover:bg-gray-700 transition-all flex justify-center group"
                    :class="Math.abs((ai_settings.width/ai_settings.height) - (2/3)) < 0.1 || Math.abs((ai_settings.height/ai_settings.width) - (2/3)) < 0.1 ? 'bg-gray-700 ring-1 ring-gray-600' : ''">
                    <div
                      class="w-4 h-6 border-2 border-gray-500 rounded-[2px] group-hover:border-gray-300 transition-transform duration-300"
                      :class="!presets_rotated?'rotate-90':''"></div>
                  </button>
                  <button @click="set_size_preset('1:1')"
                    class="flex-1 p-2 rounded hover:bg-gray-700 transition-all flex justify-center group"
                    :class="ai_settings.width === ai_settings.height ? 'bg-gray-700 ring-1 ring-gray-600' : ''">
                    <div
                      class="w-6 h-6 border-2 border-gray-500 rounded-[2px] group-hover:border-gray-300 transition-colors">
                    </div>
                  </button>
                  <div class="w-px bg-gray-700 my-1"></div>
                  <button @click="swap_dimensions"
                    class="px-3 rounded hover:bg-gray-700 text-gray-500 hover:text-gray-300 transition-colors"
                    :title="get_t('ai.swap_dimensions')"><i data-lucide="arrow-left-right" class="w-4 h-4"></i></button>
                </div>

                <!-- Inputs with validation -->
                <div class="grid grid-cols-2 gap-3">
                  <div class="relative">
                    <label class="absolute -top-1.5 left-2 bg-gray-800 px-1 text-xs font-bold text-gray-500">{{
                      get_t('ai.width') }}</label>
                    <input type="number" v-model.number="ai_settings.width" step="64" min="768" max="1536"
                      @blur="validate_dimension('width', $event)"
                      class="w-full bg-transparent border border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-300 font-mono focus:border-purple-500 focus:ring-1 focus:ring-purple-500 text-center">
                  </div>
                  <div class="relative">
                    <label class="absolute -top-1.5 left-2 bg-gray-800 px-1 text-xs font-bold text-gray-500">{{
                      get_t('ai.height') }}</label>
                    <input type="number" v-model.number="ai_settings.height" step="64" min="768" max="1536"
                      @blur="validate_dimension('height', $event)"
                      class="w-full bg-transparent border border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-300 font-mono focus:border-purple-500 focus:ring-1 focus:ring-purple-500 text-center">
                  </div>
                </div>
              </div>


              <!-- HIRES FIX SECTION -->
              <div
                class="px-4 py-3 flex justify-between items-center cursor-pointer border-y border-gray-700/50 bg-gray-800/50 hover:bg-gray-800 transition-colors"
                @click="mikogen_collapsed_sections.hires_fix = !mikogen_collapsed_sections.hires_fix">
                <span class="text-xs font-bold text-gray-300 uppercase tracking-wider">{{ get_t('ai.use_hires_fix')
                  }}</span>
                <div class="flex items-center gap-2">
                  <span v-if="ai_settings.use_hires_fix"
                    class="w-2 h-2 rounded-full bg-purple-500 shadow-[0_0_8px_rgba(168,85,247,0.5)]"></span>
                  <i :data-lucide="mikogen_collapsed_sections.hires_fix ? 'chevron-down' : 'chevron-up'"
                    class="w-4 h-4 text-gray-400"></i>
                </div>
              </div>

              <div v-show="!mikogen_collapsed_sections.hires_fix"
                class="p-4 space-y-4 animate-fade-in-down bg-gray-800/20">
                <!-- Main Toggle Switch Inside -->
                <div
                  class="flex items-center justify-between p-2 bg-gray-900/40 rounded-lg border border-gray-700/30 cursor-pointer hover:bg-gray-900/60 transition-colors"
                  @click="ai_settings.use_hires_fix = !ai_settings.use_hires_fix">
                  <span class="text-xs font-bold text-gray-400 uppercase tracking-wider">{{
                    get_t('ai.use_hires_fix') }}</span>
                  <div class="w-8 h-4 rounded-full p-0.5 transition-colors duration-300 flex items-center"
                    :class="ai_settings.use_hires_fix ? 'bg-purple-500' : 'bg-gray-700'">
                    <div class="w-3 h-3 bg-white rounded-full shadow-sm transform transition-transform duration-300"
                      :class="ai_settings.use_hires_fix ? 'translate-x-4' : 'translate-x-0'"></div>
                  </div>
                </div>

                <div v-if="ai_settings.use_hires_fix" class="space-y-4 animate-fade-in-down">
                  <div
                    class="bg-black/20 rounded p-2 flex justify-between items-center text-xs font-mono border border-white/5">
                    <span class="text-gray-400">{{ get_t('mikogen.nav.final_resolution') }}</span>
                    <span
                      class="text-purple-300 font-bold bg-purple-500/10 px-1.5 rounded">{{Math.round(ai_settings.width*1.29)}}
                      <span class="text-gray-600">x</span> {{Math.round(ai_settings.height*1.29)}}</span>
                  </div>

                  <div>
                    <div class="flex justify-between items-center mb-1 text-xs font-bold text-gray-500">
                      <span>{{ get_t('ai.hires_denoise') }}</span>
                      <span class="text-gray-300">{{ai_settings.hires_denoise.toFixed(2)}}</span>
                    </div>
                    <input type="range" v-model.number="ai_settings.hires_denoise" min="0.3" max="1" step="0.01"
                      class="w-full h-1.5 bg-gray-700 slider-accent rounded-full appearance-none"
                      :style="`background: linear-gradient(to right, #a855f7 ${((ai_settings.hires_denoise-0.3)/0.7)*100}%, #ffffff ${((ai_settings.hires_denoise-0.3)/0.7)*100}%)`">
                  </div>

                  <button @click="ai_settings.use_same_seed_for_hires = !ai_settings.use_same_seed_for_hires"
                    class="w-full py-2 rounded-lg border text-xs font-medium transition-all flex items-center justify-center gap-2"
                    :class="ai_settings.use_same_seed_for_hires ? 'bg-purple-500/20 border-purple-500/40 text-purple-300' : 'bg-gray-800 border-gray-700 text-gray-500 hover:text-white'">
                    <i :data-lucide="ai_settings.use_same_seed_for_hires ? 'link' : 'unlink'" class="w-3.5 h-3.5"></i>
                    {{ get_t('ai.use_same_seed_for_hires') }}
                  </button>
                </div>
              </div>


              <!-- ADVANCED SETTINGS SECTION -->
              <div
                class="px-4 py-3 flex justify-between items-center cursor-pointer border-y border-gray-700/50 bg-gray-800/50 hover:bg-gray-800 transition-colors"
                @click="mikogen_collapsed_sections.advanced_settings = !mikogen_collapsed_sections.advanced_settings">
                <span class="text-xs font-bold text-gray-300 uppercase tracking-wider">{{ get_t('ai.advanced_settings')
                  }}</span>
                <i :data-lucide="mikogen_collapsed_sections.advanced_settings ? 'chevron-down' : 'chevron-up'"
                  class="w-4 h-4 text-gray-400"></i>
              </div>

              <div v-show="!mikogen_collapsed_sections.advanced_settings" class="p-4 space-y-4 animate-fade-in-down">
                <!-- Seed -->
                <div class="flex gap-2 items-end">
                  <div class="flex-1">
                    <label class="text-xs font-bold text-gray-500 mb-1 block uppercase">{{ get_t('ai.seed')
                      }}</label>
                    <input type="number" v-model.number="ai_settings.seed"
                      class="w-full bg-gray-900 border border-gray-600/50 rounded-lg px-3 py-2 text-xs font-mono text-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
                      placeholder="-1 for random">
                  </div>
                  <button @click="randomize_seed()"
                    class="h-[34px] w-[34px] bg-gray-800 border border-gray-600/50 rounded-lg hover:bg-purple-600/20 hover:border-purple-500/50 hover:text-purple-400 text-gray-400 flex items-center justify-center transition-all"
                    :title="get_t('ai.random_seed')"><i data-lucide="shuffle" class="w-4 h-4"></i></button>
                </div>

                <!-- Steps & CFG -->
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <div class="flex justify-between text-xs font-bold text-gray-500 mb-1.5"><span>{{
                        get_t('ai.steps') }}</span><span class="text-gray-300">{{ai_settings.steps}}</span></div>
                    <input type="range" v-model.number="ai_settings.steps" min="20" max="32"
                      class="w-full h-1.5 bg-gray-700 slider-accent rounded-full appearance-none"
                      :style="`background: linear-gradient(to right, #a855f7 ${((ai_settings.steps-20)/12)*100}%, #ffffff ${((ai_settings.steps-20)/12)*100}%)`">
                  </div>
                  <div>
                    <div class="flex justify-between text-xs font-bold text-gray-500 mb-1.5"><span>{{
                        get_t('ai.cfg_scale') }}</span><span class="text-gray-300">{{ai_settings.cfg_scale}}</span>
                    </div>
                    <input type="range" v-model.number="ai_settings.cfg_scale" min="4" max="15" step="0.1"
                      class="w-full h-1.5 bg-gray-700 slider-accent rounded-full appearance-none"
                      :style="`background: linear-gradient(to right, #a855f7 ${((ai_settings.cfg_scale-4)/11)*100}%, #ffffff ${((ai_settings.cfg_scale-4)/11)*100}%)`">
                  </div>
                </div>

                <!-- Sampler & Scheduler -->
                <div class="space-y-3">
                  <div>
                    <label class="text-xs font-bold text-gray-500 mb-1 block">{{ get_t('ai.sampler') }}</label>
                    <select v-model="ai_settings.sampler"
                      class="w-full bg-gray-900 border border-gray-600/50 rounded-lg text-xs py-2 px-2 text-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-500 cursor-pointer">
                      <option v-for="s in available_samplers" :value="s.name">{{s.display_name}}</option>
                    </select>
                  </div>
                  <div>
                    <label class="text-xs font-bold text-gray-500 mb-1 block">{{ get_t('ai.scheduler') }}</label>
                    <select v-model="ai_settings.scheduler"
                      class="w-full bg-gray-900 border border-gray-600/50 rounded-lg text-xs py-2 px-2 text-gray-300 focus:border-purple-500 focus:ring-1 focus:ring-purple-500 cursor-pointer">
                      <option v-for="s in filtered_schedulers" :value="s.name" :disabled="s.disabled">{{s.display_name}}
                        {{s.recommended?'⭐':''}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>



          </div>

        </div> <!-- End Lower Left Controls -->

      </div> <!-- End Left Section -->


      <!-- RIGHT SECTION (Span 4): History & Preview -->
      <div class="col-span-1 lg:col-span-4 min-h-0 flex flex-col gap-4 lg:h-full h-auto">

        <!-- HISTORY SECTION (Collapsible) -->
        <div class="bg-gray-800/30 rounded-xl border border-gray-700/30 flex flex-col shadow-inner flex-shrink-0"
          style="max-height: 40vh;">
          <div
            class="px-4 py-3 flex justify-between items-center cursor-pointer border-b border-gray-700/50 bg-gray-800/50 hover:bg-gray-800 transition-colors"
            @click="toggle_generation_history">
            <h3 class="text-xs font-bold text-gray-300 uppercase tracking-widest flex items-center gap-2">
              <i data-lucide="history" class="w-4 h-4 text-purple-400"></i>
              {{ get_t('ai.generation_history') }}
            </h3>
            <div class="flex items-center gap-2">
              <span class="text-xs text-gray-500 font-mono">{{ history_total_images || generation_history.length }}/{{ get_tier_limit('history_images') }}</span>
              <i :data-lucide="show_generation_history ? 'chevron-up' : 'chevron-down'"
                class="w-4 h-4 text-gray-400"></i>
            </div>
          </div>

          <div v-show="show_generation_history"
            class="p-2 bg-gray-900/30 overflow-y-auto custom-scrollbar animate-fade-in-down"
            @scroll="handle_history_scroll">
            <div v-if="generation_history.length > 0">
              <div class="grid grid-cols-3 gap-2 mb-2">
                <div v-for="(image, index) in generation_history" :key="image.id || index"
                  class="aspect-[2/3] group relative rounded-md overflow-hidden border border-gray-700/50 transition-all shadow-md bg-gray-800"
                  :class="image.is_placeholder ? 'cursor-default' : 'cursor-pointer hover:border-purple-500 hover:shadow-purple-500/20'"
                  @click="!image.is_placeholder && view_history_image(image)">
                  
                  <!-- Placeholder -->
                  <div v-if="image.is_placeholder" class="w-full h-full flex items-center justify-center">
                    <i data-lucide="image" class="w-6 h-6 text-gray-600"></i>
                  </div>
                  
                  <!-- Real image -->
                  <template v-else>
                    <img :src="image.url"
                      class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy" :draggable="true" @dragstart="handle_history_image_dragstart($event, image)">
                    <!-- Action buttons at bottom - always visible on mobile, hover on desktop -->
                    <div class="absolute bottom-0 left-0 right-0 bg-black/60 p-2 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200">
                      <div class="flex gap-1 justify-center">
                        <button @click.stop="load_metadata_from_url(image.url)"
                          class="p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.load_metadata')">
                          <i data-lucide="file-input" class="w-3 h-3"></i>
                        </button>
                        <button @click.stop="download_history_image(image)"
                          class="p-1.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.download')">
                          <i data-lucide="download" class="w-3 h-3"></i>
                        </button>                        
                        <button @click.stop="confirm_delete_history_image(image)"
                          class="p-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.delete_image')">
                          <i data-lucide="trash-2" class="w-3 h-3"></i>
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

            </div>

            <!-- Empty State -->
            <div v-else class="flex flex-col items-center justify-center h-32 text-gray-600">
              <i data-lucide="image-off" class="w-6 h-6 text-gray-700 mb-2"></i>
              <p class="text-xs font-medium">{{ get_t('ai.no_history_images') }}</p>
            </div>

            <div v-if="history_loading" class="flex justify-center py-4">
              <i data-lucide="loader-2" class="w-4 h-4 animate-spin text-purple-500"></i>
            </div>
          </div>
        </div>

        <!-- PREVIEW WRAPPER (Flex-1 to fill space) -->
        <div
          class="lg:flex-1 w-full min-h-[350px] lg:min-h-0 flex flex-col bg-gray-800/20 rounded-xl border border-gray-700/30 overflow-hidden relative group backdrop-blur-sm shadow-xl">

          <!-- Main Image -->
          <div class="flex-1 flex items-center justify-center m-2 rounded-lg relative overflow-hidden">
            <img
              :src="ai_preview_image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgZmlsbD0ibm9uZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0iY2VudHJhbCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzM3NDE1MSIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjRweCIgZm9udC13ZWlnaHQ9IjkwMCIgbGV0dGVyLXNwYWNpbmc9IjAuMWVtIj5NSUtPR0VOCjwvdGV4dD48L3N2Zz4='"
              class="max-w-full max-h-full object-contain shadow-2xl transition-all duration-500 select-none"
              :class="ai_generating ? 'opacity-30 scale-95 blur-md grayscale' : 'opacity-100 scale-100'"
              @click="ai_preview_image && show_ai_image_fullscreen()">

            <!-- Generating Spinner -->
            <div v-if="ai_generating" class="absolute inset-0 flex flex-col items-center justify-center z-10">
              <div class="relative">
                <div class="absolute inset-0 bg-purple-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
                <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-500 relative z-10"></div>
              </div>
            </div>
          </div>

          <!-- Action Bar (Bottom) CLEANED -->
          <div v-if="ai_preview_image && !ai_generating"
            class="p-3 bg-gray-900/50 backdrop-blur border-t border-white/5 flex gap-2 justify-center flex-shrink-0">
            <button @click="discard_ai_image" :disabled="!is_generated_image"
              class="w-10 h-10 rounded-xl hover:bg-red-500/20 text-red-500 hover:text-red-400 flex items-center justify-center transition-colors disabled:opacity-30 disabled:cursor-not-allowed border border-transparent hover:border-red-500/30"
              :title="get_t('ai.discard')">
              <i data-lucide="trash-2" class="w-4 h-4"></i>
            </button>
            <button v-if="ai_preview_image" @click="load_metadata_from_url(ai_preview_image)"
              class="w-10 h-10 rounded-xl hover:bg-blue-500/20 text-blue-400 hover:text-blue-300 flex items-center justify-center transition-colors border border-transparent hover:border-blue-500/30"
              :title="get_t('ai.load_metadata')">
              <i data-lucide="file-input" class="w-4 h-4"></i>
            </button>
            <button @click="download_ai_image"
              class="flex-1 h-10 rounded-xl bg-gray-100 hover:bg-white text-gray-900 font-bold text-xs uppercase tracking-wider flex items-center justify-center gap-2 transition-colors shadow-lg shadow-white/5">
              <i data-lucide="download" class="w-4 h-4"></i>
              {{ get_t('ai.download') }}
            </button>
          </div>
        </div>
      </div>



    </div>

  </div>

</div>


<!-- Top main toolbar with logo and main menus -->
<div v-if="comic_mode===true" id="top_bar"
  class="bg-gradient-to-r from-gray-950 via-gray-900 to-gray-950 border-b border-gray-700/50 p-1 sm:p-2 md:p-3 flex items-center justify-between relative shadow-xl z-[100]">
  <div class="flex items-center">
    <!-- Logo -->
    <img src="./img/logo_mobile.png" :alt="get_t('logo.alt_text')"
      class="h-5 sm:h-6 md:h-8 ml-0.5 sm:ml-1 md:ml-2 mr-0.5 sm:mr-1 md:mr-2">

    <!-- Mobile hamburger button (visible only on mobile) -->
    <button @click="toggle_mobile_menu" class="md:hidden p-2 hover:bg-gray-700 rounded-md transition-colors"
      :class="{ 'bg-gray-700': show_mobile_menu }">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
      </svg>
    </button>

    <!-- Desktop menu (hidden on mobile) -->
    <div class="hidden md:flex space-x-1">
      <!-- File Menu Button -->
      <div class="relative">
        <button @click.stop="toggle_dropdown_menu('file')" class="px-3 py-1 hover:bg-gray-700 rounded-md text-sm"
          :class="{ 'bg-gray-700': show_file_menu }">
          {{ get_t('menu.file') }}
        </button>
        <!-- File Dropdown Menu -->
        <div v-if="show_file_menu"
          class="absolute left-0 mt-2 w-48 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 rounded-md shadow-lg z-[110] border border-gray-700/50"
          @click.stop>
          <ul class="py-1">
            <li>
              <a href="#" @click.prevent="confirm_new_document(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                <span>{{ get_t('menu.file_submenu.new') }}</span>
                <span class="text-xs text-gray-400">Ctrl+Alt+N</span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="open_document(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                <span>{{ get_t('menu.file_submenu.open') }}</span>
                <span class="text-xs text-gray-400">Ctrl+O</span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="!show_welcome_screen ? (save_document(), close_all_menus()) : null"
                :class="show_welcome_screen ? 'block px-4 py-2 text-sm text-gray-500 cursor-not-allowed flex justify-between' : 'block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between'">
                <span>{{ get_t('menu.file_submenu.save') }}</span>
                <span class="text-xs text-gray-400">Ctrl+S</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="!show_welcome_screen ? (save_document(true), close_all_menus()) : null"
                :class="show_welcome_screen ? 'block px-4 py-2 text-sm text-gray-500 cursor-not-allowed' : 'block px-4 py-2 text-sm text-white hover:bg-rose-600'">
                {{ get_t('menu.file_submenu.save_as') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="!show_welcome_screen ? (show_export_modal(), close_all_menus()) : null"
                :class="show_welcome_screen ? 'block px-4 py-2 text-sm text-gray-500 cursor-not-allowed flex justify-between' : 'block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between'">
                <span>{{ get_t('menu.file_submenu.export') }}</span>
                <span class="text-xs text-gray-400">Ctrl+E</span>
              </a>
            </li>


            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="show_preferences(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.file_submenu.preferences') }}
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="show_download_tool_confirmation(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.file_submenu.download_thumbnails') }}
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <!-- Recent Files -->
            <li v-if="recent_files.length > 0">
              <div class="px-4 py-2 text-xs text-gray-400 uppercase tracking-wide">{{
                get_t('menu.file_submenu.recent_files') }}</div>
            </li>
            <li v-for="file in recent_files.slice(0, 5)" :key="file.name">
              <a href="#" @click.prevent="open_from_recent_with_auth_check(file); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 truncate" :title="file.name">
                {{ file.name }}
              </a>
            </li>
            <li v-if="recent_files.length > 0">
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="close_document(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.file_submenu.close') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- Edit Menu Button -->
      <div class="relative">
        <button class="px-3 py-1 rounded-md text-sm"
          @click.stop="!show_welcome_screen ? toggle_dropdown_menu('edit') : null"
          :class="show_welcome_screen ? 'text-gray-500 cursor-not-allowed' : 'hover:bg-gray-700'"
          :disabled="show_welcome_screen">
          {{ get_t('menu.edit') }}
        </button>
        <!-- Menú desplegable de Editar -->
        <div v-show="show_edit_menu && !show_welcome_screen"
          class="absolute left-0 mt-2 w-48 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 rounded-md shadow-lg z-[110] border border-gray-700/50"
          @click.stop>
          <ul class="py-1">
            <li>
              <a href="#" @click.prevent="cut_selected_object(); close_all_menus()"
                :class="selected_object ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
                class="block px-4 py-2 text-sm flex justify-between">
                {{ get_t('menu.edit_submenu.cut') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.cut') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="copy_selected_object(); close_all_menus()"
                :class="selected_object ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
                class="block px-4 py-2 text-sm flex justify-between">
                {{ get_t('menu.edit_submenu.copy') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.copy') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="paste_copied_object(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.edit_submenu.paste') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.paste') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="delete_selected_object(); close_all_menus()"
                :class="selected_object ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
                class="block px-4 py-2 text-sm flex justify-between">
                {{ get_t('menu.edit_submenu.delete') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.delete') }}</span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="handle_copy_style(); close_all_menus()"
                class="block px-4 py-2 text-sm flex justify-between"
                :class="can_copy_style(selected_object) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'">
                <span class="flex items-center gap-2">
                  {{ get_t('menu.edit_submenu.copy_style') }}
                  <span class="text-amber-400">✨</span>
                </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="handle_paste_style(); close_all_menus()"
                class="block px-4 py-2 text-sm flex justify-between"
                :class="can_paste_style(selected_object) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'">
                <span class="flex items-center gap-2">
                  {{ get_t('menu.edit_submenu.paste_style') }}
                  <span class="text-amber-400">✨</span>
                </span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="deselect_all(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.edit_submenu.deselect_all') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="select_global_layers(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.edit_submenu.select_global_layers') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- Image Menu Button -->
      <div class="relative">
        <button class="px-3 py-1 rounded-md text-sm"
          @click.stop="!show_welcome_screen ? toggle_dropdown_menu('image') : null"
          :class="show_welcome_screen ? 'text-gray-500 cursor-not-allowed' : 'hover:bg-gray-700'"
          :disabled="show_welcome_screen">
          {{ get_t('menu.image') }}
        </button>
        <!-- Image Dropdown Menu -->
        <div v-show="show_image_menu && !show_welcome_screen"
          class="absolute left-0 mt-2 w-48 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 rounded-md shadow-lg z-[110] border border-gray-700/50"
          @click.stop>
          <ul class="py-1">
            <li>
              <a href="#" @click.prevent="flip_selected_image_horizontal"
                class="block px-4 py-2 text-sm hover:bg-rose-600"
                :class="(!selected_object || selected_object.getAttr('object_type') !== 'image') ? 'text-gray-500 cursor-not-allowed' : 'text-white'">
                {{ get_t('menu.image_submenu.flip_horizontal') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="flip_selected_image_vertical"
                class="block px-4 py-2 text-sm hover:bg-rose-600"
                :class="(!selected_object || selected_object.getAttr('object_type') !== 'image') ? 'text-gray-500 cursor-not-allowed' : 'text-white'">
                {{ get_t('menu.image_submenu.flip_vertical') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- View Menu Button -->
      <div class="relative">
        <button class="px-3 py-1 rounded-md text-sm"
          @click.stop="!show_welcome_screen ? toggle_dropdown_menu('view') : null"
          :class="show_welcome_screen ? 'text-gray-500 cursor-not-allowed' : 'hover:bg-gray-700'"
          :disabled="show_welcome_screen">
          {{ get_t('menu.view') }}
        </button>
        <!-- View Dropdown Menu -->
        <div v-show="show_view_menu && !show_welcome_screen"
          class="absolute left-0 mt-2 w-48 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 rounded-md shadow-lg z-[110] border border-gray-700/50"
          @click.stop>
          <ul class="py-1">
            <li>
              <a href="#" @click.prevent="toggle_fullscreen(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.view_submenu.fullscreen') }}
                <span class="text-gray-400 ml-2">F11</span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="zoom_in(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.view_submenu.zoom_in') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.zoom_in') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="zoom_out(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.view_submenu.zoom_out') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.zoom_out') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="reset_position_and_zoom(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.view_submenu.fit_zoom') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.fit_zoom') }}</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="fit_zoom_to_panel(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between">
                {{ get_t('menu.view_submenu.fit_zoom_to_panel') }}
                <span class="text-gray-400 ml-2">{{ get_t('hotkeys.fit_zoom_to_panel') }}</span>
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="toggle_pages_navigation(); close_all_menus()"
                :class="is_mkc2_container && container_pages && container_pages.length > 0 ? 'block px-4 py-2 text-sm text-white hover:bg-rose-600 flex justify-between' : 'block px-4 py-2 text-sm text-gray-500 cursor-not-allowed flex justify-between'">
                {{ get_t('menu.view_submenu.pages_navigation') }}
                <span class="text-gray-400 ml-2">V</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- Tutorials Menu Button (Direct) -->
      <div class="relative">
        <button class="px-3 py-1 rounded-md text-sm hover:bg-gray-700" @click.stop="show_tutorials_modal()">
          {{ get_t('menu.tutorials') }}
        </button>
      </div>
      <!-- About Menu Button -->
      <div class="relative">
        <button class="px-3 py-1 rounded-md text-sm hover:bg-gray-700" @click.stop="toggle_dropdown_menu('about')">
          {{ get_t('menu.about') }}
        </button>
        <!-- About Dropdown Menu -->
        <div v-show="show_about_menu"
          class="absolute left-0 mt-2 w-56 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 rounded-md shadow-lg z-[110] border border-gray-700/50"
          @click.stop>
          <ul class="py-1">
            <!-- <li>
              <a href="#" @click.prevent="show_version_info(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.about_submenu.version_info') }}
              </a>
            </li> -->
            <li>
              <a href="#" @click.prevent="show_privacy_policy(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.about_submenu.privacy_policy') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="show_terms_of_use(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.about_submenu.terms_of_use') }}
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="show_about_mikomic(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.about_submenu.about_mikomic') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="show_contact_support(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
                {{ get_t('menu.about_submenu.contact_support') }}
              </a>
            </li>
            <li>
              <hr class="border-t border-gray-600 my-1">
            </li>
            <li>
              <a href="#" @click.prevent="open_discord(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex items-center gap-2">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0190 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9554 2.4189-2.1568 2.4189Z" />
                </svg>
                {{ get_t('menu.about_submenu.discord') }}
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="open_twitter(); close_all_menus()"
                class="block px-4 py-2 text-sm text-white hover:bg-rose-600 flex items-center gap-2">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" />
                </svg>
                {{ get_t('menu.about_submenu.x') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="flex items-center gap-2">
    <!-- Auth buttons (desktop only) -->
    <div v-if="!user_data.email" class="flex items-center gap-2">
      <button @click="show_login_modal"
        class="px-3 py-1 text-sm bg-rose-600 hover:bg-rose-700 rounded-md text-white transition-colors">
        {{ get_t('auth.sign_in') }}
      </button>
      <button @click="show_register_modal"
        class="px-3 py-1 text-sm border border-gray-600 hover:border-gray-500 rounded-md text-gray-300 hover:text-white transition-colors">
        {{ get_t('auth.sign_up') }}
      </button>
    </div>

    <!-- User menu (desktop only) -->
    <div v-else class="flex items-center gap-3 cursor-pointer" @click="toggle_user_menu">
      <!-- Upgrade button for free users and premium users (to Creator Pro) -->
      <button v-if="user_data && (user_data.tier === 'free' || user_data.tier === 'premium')" @click="show_pricing()"
        class="px-3 py-2 text-sm text-white rounded-lg font-medium transition-all duration-200 shadow-lg flex items-center gap-2"
        :class="user_data.tier === 'premium' ? 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500 shadow-blue-500/25' : 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 shadow-amber-500/25'">
        <i data-lucide="crown" class="w-4 h-4"></i>
        {{ get_t('pricing.upgrade_now') }}
      </button>

      <div
        class="flex items-center gap-2 px-3 py-2 rounded-xl bg-gradient-to-r from-gray-800/50 to-gray-700/50 border border-gray-600/30 relative">
        <i data-lucide="user" class="w-4 h-4 text-gray-300"></i>
        <button class="flex items-center gap-2 text-sm font-medium text-gray-200 hover:text-white transition-colors">
          <span>{{ user_data.display_name || user_data.email }}</span>
          <i data-lucide="chevron-down" class="w-4 h-4"></i>
        </button>
        <!-- Tier badge -->
        <span v-if="user_data && user_data.tier !== 'free'" class="px-2 py-0.5 text-xs font-medium rounded-full" :class="{
                'bg-amber-500/20 text-amber-400': user_data.tier === 'premium',
                'bg-purple-500/20 text-purple-400': user_data.tier === 'creator_pro'
              }">
          {{ user_data.tier === 'premium' ? 'Premium' : 'Creator Pro' }}
        </span>

        <!-- User dropdown menu -->
        <div v-if="show_user_menu" @click.stop
          class="absolute top-full right-0 mt-2 w-64 bg-gray-800 border border-gray-600/50 rounded-lg shadow-2xl z-[200] overflow-hidden">
          <div class="p-3 border-b border-gray-600/50">
            <div class="text-sm font-medium text-white">{{ user_data.display_name || user_data.email }}</div>
            <div class="text-xs text-gray-400">{{ user_data.email }}</div>
          </div>



          <!-- Subscription management -->
          <div v-if="user_data && user_data.tier !== 'free'" class="border-t border-gray-600/50 p-2">
            <!-- Always show manage subscription for payment/billing settings -->
            <button @click="manage_subscription(); show_user_menu = false"
              class="w-full px-3 py-2 text-left text-sm text-gray-200 hover:text-white hover:bg-gray-700/50 rounded-md transition-colors flex items-center gap-2 mb-1">
              <i data-lucide="credit-card" class="w-4 h-4"></i>
              {{ get_t('pricing.manage_subscription') }}
            </button>

            <!-- If user has scheduled downgrade, show additional cancel options -->
            <div v-if="user_data.has_scheduled_downgrade">
              <button @click="handle_scheduled_change_cancellation(); show_user_menu = false"
                class="w-full px-3 py-2 text-left text-sm text-gray-200 hover:text-white hover:bg-gray-700/50 rounded-md transition-colors flex items-center gap-2 mb-1">
                <i data-lucide="x-circle" class="w-4 h-4"></i>
                {{ get_t(schedule_key) }}
              </button>
            </div>

            <button @click="handle_subscription_toggle(); show_user_menu = false"
              class="w-full px-3 py-2 text-left text-sm text-gray-200 hover:text-white hover:bg-gray-700/50 rounded-md transition-colors flex items-center gap-2">
              <i :data-lucide="user_data.cancel_at_period_end ? 'refresh-cw' : 'user-x'" class="w-4 h-4"></i>
              {{ user_data.cancel_at_period_end ? get_t('subscription.reactivate_subscription') :
              get_t('subscription.cancel_subscription') }}
            </button>

          </div>

          <!-- Upgrade option for free users and premium users (to Creator Pro) -->
          <div v-if="user_data && (user_data.tier === 'free' || user_data.tier === 'premium')"
            class="border-t border-gray-600/50 p-2">
            <button @click="show_pricing(); show_user_menu = false"
              class="w-full px-3 py-2 text-left text-sm rounded-md transition-colors flex items-center gap-2"
              :class="user_data.tier === 'premium' ? 'text-blue-400 hover:text-blue-300 hover:bg-blue-500/10' : 'text-amber-400 hover:text-amber-300 hover:bg-amber-500/10'">
              <i data-lucide="crown" class="w-4 h-4"></i>
              {{ get_t('pricing.upgrade_now') }}
            </button>
          </div>

          <div v-else class="border-t border-gray-600/50 p-2">
            <button @click="show_pricing(); show_user_menu = false"
              class="w-full px-3 py-2 text-left text-sm rounded-md transition-colors flex items-center gap-2 text-amber-400 hover:text-amber-300 hover:bg-amber-500/10">
              <i data-lucide="crown" class="w-4 h-4"></i>
              {{ get_t('pricing.explore_plans') }}
            </button>
          </div>

          <div class="border-t border-gray-600/50 p-2">
            <button @click="logout(); show_user_menu = false"
              class="w-full px-3 py-2 text-left text-sm text-gray-300 hover:text-white hover:bg-gray-700/50 rounded-md transition-colors flex items-center gap-2">
              <i data-lucide="log-out" class="w-4 h-4"></i>
              {{ get_t('auth.sign_out') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Close dropdown when clicking outside -->
    <div v-if="show_user_menu" @click="show_user_menu = false" class="fixed inset-0 z-[190]"></div>

    <button
      class="p-2 hover:bg-gray-700/50 rounded-xl flex items-center gap-1 transition-all duration-200 text-gray-300 hover:text-white"
      :title="get_t('help.button_title')" @click="show_tutorials_modal">
      <i data-lucide="help-circle" class="w-5 h-5"></i>
    </button>
  </div>
</div>

<!-- Mobile menu overlay -->
<div v-if="comic_mode===true && show_mobile_menu" @click="show_mobile_menu = false"
  class="fixed inset-0 bg-black/50 z-[150] sm:hidden">
</div>

<!-- Mobile menu sidebar -->
<div v-if="comic_mode===true" :class="show_mobile_menu ? 'translate-x-0' : '-translate-x-full'"
  class="fixed top-0 left-0 h-full w-80 bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 border-r border-gray-700/50 z-[160] transform transition-transform duration-300 ease-in-out md:hidden">
  <!-- Mobile menu header -->
  <div class="flex items-center justify-between p-4 border-b border-gray-700/50">
    <img src="./img/logo_mobile.png" :alt="get_t('logo.alt_text')" class="h-8">
    <button @click="show_mobile_menu = false" class="p-2 hover:bg-gray-700 rounded-md">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Mobile menu content -->
  <div class="p-4 space-y-4">
    <!-- File menu section -->
    <div>
      <h3 class="text-sm font-semibold text-gray-300 mb-2">{{ get_t('menu.file') }}</h3>
      <div class="space-y-1">
        <button @click="confirm_new_document(); show_mobile_menu = false"
          class="w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between">
          <span>{{ get_t('menu.file_submenu.new') }}</span>
          <span class="text-xs text-gray-400">Ctrl+Alt+N</span>
        </button>
        <button @click="open_document(); show_mobile_menu = false"
          class="w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between">
          <span>{{ get_t('menu.file_submenu.open') }}</span>
          <span class="text-xs text-gray-400">Ctrl+O</span>
        </button>
        <button @click="!show_welcome_screen ? (save_document(), show_mobile_menu = false) : null"
          :class="show_welcome_screen ? 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md flex justify-between' : 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between'">
          <span>{{ get_t('menu.file_submenu.save') }}</span>
          <span class="text-xs text-gray-400">Ctrl+S</span>
        </button>
        <button @click="!show_welcome_screen ? (save_document(true), show_mobile_menu = false) : null"
          :class="show_welcome_screen ? 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md' : 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md'">
          {{ get_t('menu.file_submenu.save_as') }}
        </button>
        <button @click="!show_welcome_screen ? (show_export_modal(), show_mobile_menu = false) : null"
          :class="show_welcome_screen ? 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md flex justify-between' : 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between'">
          <span>{{ get_t('menu.file_submenu.export') }}</span>
          <span class="text-xs text-gray-400">Ctrl+E</span>
        </button>
        <hr class="border-gray-700 my-2">
        <a href="./downloads/mkc_thumbnail_handler/MKCThumbnailHandler_Installer.exe"
          download="MKCThumbnailHandler_Installer.exe" @click="show_mobile_menu = false"
          class="block w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md">
          {{ get_t('menu.file_submenu.download_thumbnails') }}
        </a>
        <hr class="border-gray-700 my-2">
        <button @click="show_preferences(); show_mobile_menu = false"
          class="w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md">
          {{ get_t('menu.file_submenu.preferences') }}
        </button>
      </div>
    </div>

    <!-- Edit menu section -->
    <div v-if="!show_welcome_screen">
      <h3 class="text-sm font-semibold text-gray-300 mb-2">{{ get_t('menu.edit') }}</h3>
      <div class="space-y-1">
        <button @click="cut_selected_object(); show_mobile_menu = false"
          :class="selected_object ? 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between' : 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md flex justify-between'">
          <span>{{ get_t('menu.edit_submenu.cut') }}</span>
          <span class="text-xs text-gray-400">{{ get_t('hotkeys.cut') }}</span>
        </button>
        <button @click="copy_selected_object(); show_mobile_menu = false"
          :class="selected_object ? 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between' : 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md flex justify-between'">
          <span>{{ get_t('menu.edit_submenu.copy') }}</span>
          <span class="text-xs text-gray-400">{{ get_t('hotkeys.copy') }}</span>
        </button>
        <button @click="paste_copied_object(); show_mobile_menu = false"
          class="w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between">
          <span>{{ get_t('menu.edit_submenu.paste') }}</span>
          <span class="text-xs text-gray-400">{{ get_t('hotkeys.paste') }}</span>
        </button>
        <button @click="delete_selected_object(); show_mobile_menu = false"
          :class="selected_object ? 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex justify-between' : 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md flex justify-between'">
          <span>{{ get_t('menu.edit_submenu.delete') }}</span>
          <span class="text-xs text-gray-400">{{ get_t('hotkeys.delete') }}</span>
        </button>
      </div>
    </div>

    <!-- Tutorials menu section -->
    <div>
      <h3 class="text-sm font-semibold text-gray-300 mb-2">{{ get_t('menu.tutorials') }}</h3>
      <div class="space-y-1">
        <button @click="show_tutorials_modal(); show_mobile_menu = false"
          class="w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md flex items-center gap-2">
          <i data-lucide="book-open" class="w-4 h-4"></i>
          <span>{{ get_t('menu.tutorials') }}</span>
        </button>
      </div>
    </div>

    <!-- Image menu section -->
    <div v-if="!show_welcome_screen">
      <h3 class="text-sm font-semibold text-gray-300 mb-2">{{ get_t('menu.image') }}</h3>
      <div class="space-y-1">
        <button @click="flip_selected_image_horizontal(); show_mobile_menu = false"
          :class="(!selected_object || selected_object.getAttr('object_type') !== 'image') ? 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md' : 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md'">
          {{ get_t('menu.image_submenu.flip_horizontal') }}
        </button>
        <button @click="flip_selected_image_vertical(); show_mobile_menu = false"
          :class="(!selected_object || selected_object.getAttr('object_type') !== 'image') ? 'w-full text-left px-3 py-2 text-sm text-gray-500 cursor-not-allowed rounded-md' : 'w-full text-left px-3 py-2 text-sm text-white hover:bg-gray-700 rounded-md'">
          {{ get_t('menu.image_submenu.flip_vertical') }}
        </button>
      </div>
    </div>


  </div>
</div>

<!-- Secondary toolbar for context-specific tools -->
<div v-if="comic_mode===true" v-show="!show_welcome_screen" id="context_toolbar"
  class="bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 border-r border-gray-700/50 border-b py-1 px-3 flex items-center gap-4">
  <!-- Standard file operations - always visible -->
  <div class="flex items-center gap-2">
    <button class="p-1.5 ml-1 hover:bg-gray-700 rounded-md" :title="get_t('toolbar.toggle')" @click="toggle_toolbar()">
      <i data-lucide="panel-left" class="w-5 h-5"></i>
    </button>
  </div>

  <div class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->

  <div class="flex items-center gap-2">
    <button @click="undo()" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('menu.edit_submenu.undo')">
      <i data-lucide="undo-2" class="w-5 h-5"></i>
    </button>
    <button @click="redo()" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('menu.edit_submenu.redo')">
      <i data-lucide="redo-2" class="w-5 h-5"></i>
    </button>
    <button @click="deselect_all()" class="p-1.5 hover:bg-gray-700 rounded-md"
      :title="get_t('menu.edit_submenu.deselect_all')">
      <i data-lucide="scan" class="w-5 h-5"></i>
    </button>
    <button @click="select_global_layers()" class="p-1.5 hover:bg-gray-700 rounded-md"
      :title="get_t('menu.edit_submenu.select_global_layers')">
      <i data-lucide="layers" class="w-5 h-5"></i>
    </button>
  </div>

  <!-- Zoom and Pan controls - only visible when zoom or hand tools are active -->
  <div v-if="active_tool === 'zoom' || active_tool === 'hand'" class="flex items-center gap-3" v-lucide>
    <div class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->


    <button @click="zoom_in()" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('zoom.zoom_in')">
      <i data-lucide="zoom-in" class="w-5 h-5"></i>
    </button>

    <button @click="zoom_out()" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('zoom.zoom_out')">
      <i data-lucide="zoom-out" class="w-5 h-5"></i>
    </button>

    <button @click="reset_zoom_to_100_percent()" class="p-1.5 hover:bg-gray-700 rounded-md"
      :title="get_t('zoom.reset_zoom')">
      <i data-lucide="maximize" class="w-5 h-5"></i>
    </button>

    <button @click="reset_position_and_zoom()" class="p-1.5 hover:bg-gray-700 rounded-md"
      :title="get_t('zoom.fit_canvas')">
      <i data-lucide="move" class="w-5 h-5"></i>
    </button>

    <div class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->

    <button @click="fit_zoom_to_panel()" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('view.fit_panel')">
      <i data-lucide="focus" class="w-5 h-5"></i>
    </button>

    <div class="flex items-center ml-2">
      <span class="text-sm">{{ get_t('zoom.label') }}: {{ get_current_zoom() }}%</span>
    </div>
  </div>

  <!-- Select panel control - only visible when select panel tool is active -->
  <div v-if="active_tool === 'select_panel' || active_tool === 'select'" class="flex items-center gap-3" v-lucide>

    <!-- <button v-if="selected_panel" @click.stop="load_image_to_selected_panel(this)" class="p-1.5 hover:bg-gray-700 rounded-md" title="Add to panel">
      <i data-lucide="file-plus" class="w-5 h-5"></i>
    </button> -->

    <div v-if="selected_panel && selected_panel.getAttr('is_global') != true"
      class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->

    <button v-if="selected_panel && selected_panel.getAttr('is_global') != true" @click.stop="toggle_divider()"
      class="p-1.5 hover:bg-gray-700 rounded-md"
      :class="{ 'bg-rose-900 text-white hover:bg-rose-900': active_subtool === 'divider'}"
      :title="get_t('panel.divide_panel')">
      <i data-lucide="scissors" class="w-5 h-5"></i>
    </button>


    <div v-if="active_subtool === 'divider'" class="flex items-center gap-3">
      <div class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->

      <span class="text-sm">{{ get_t('panel.divider_width') }}</span>
      <input type="range" v-model="divider_width" min="1" max="80" class="w-32 accent-rose-600"
        @input="update_divider_width(divider_width)">
      <span class="text-sm">{{divider_width}}px</span>
    </div>

  </div>

  <!-- Añadir controles específicos para bocadillos en la barra de contexto -->
  <div v-if="active_tool === 'add_balloon'" class="flex items-center gap-3" v-lucide>
    <div class="h-5 w-px bg-gradient-to-b from-transparent via-gray-500 to-transparent"></div> <!-- Separator -->

    <div class="flex items-center gap-2">
      <button @click="set_balloon_type('speech')" class="p-1.5 rounded-md"
        :class="{'bg-rose-900': active_balloon_type === 'speech', 'hover:bg-gray-700': active_balloon_type !== 'speech'}"
        :title="get_t('balloon.speech_balloon')">
        <i data-lucide="message-circle" class="w-5 h-5"></i>
      </button>

      <button @click="set_balloon_type('rectangular')" class="p-1.5 rounded-md"
        :class="{'bg-rose-900': active_balloon_type === 'rectangular', 'hover:bg-gray-700': active_balloon_type !== 'rectangular'}"
        :title="get_t('balloon.rectangular_balloon')">
        <i data-lucide="square" class="w-5 h-5"></i>
      </button>

      <button @click="set_balloon_type('thought')" class="p-1.5 rounded-md"
        :class="{'bg-rose-900': active_balloon_type === 'thought', 'hover:bg-gray-700': active_balloon_type !== 'thought'}"
        :title="get_t('balloon.thought_bubble')">
        <i data-lucide="cloud" class="w-5 h-5"></i>
      </button>

      <button @click="set_balloon_type('shout')" class="p-1.5 rounded-md"
        :class="{'bg-rose-900': active_balloon_type === 'shout', 'hover:bg-gray-700': active_balloon_type !== 'shout'}"
        :title="get_t('balloon.shout_balloon')">
        <i data-lucide="zap" class="w-5 h-5"></i>
      </button>
    </div>
  </div>

</div>

<!-- Main content area -->
<div v-if="comic_mode===true" class="flex-1 flex overflow-hidden">
  <!-- Left sidebar - Tools -->
  <div v-show="!show_welcome_screen" id="left_bar"
    class="bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 border-r border-gray-700/50 flex flex-col p-3 transition-all duration-300 shadow-lg backdrop-blur-sm"
    :class="toolbar_expanded ? 'w-52' : 'w-16'">

    <!-- Herramientas de selección -->
    <div class="mb-4">
      <div v-if="toolbar_expanded" class="text-xs font-medium text-gray-400 mb-2 px-1">{{
        get_t('tools.categories.selection') }}</div>
      <div class="space-y-2">
        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'select', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'select', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('select')" :title="get_t('tools.select_elements')">
          <i data-lucide="mouse-pointer" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.select_elements') }}</span>
        </button>

        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'select_panel', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'select_panel', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('select_panel')" :title="get_t('tools.edit_layout')">
          <i data-lucide="panels-right-bottom"
            class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.edit_layout') }}</span>
        </button>

        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'add_panel', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'add_panel', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('add_panel')" :title="get_t('tools.add_panel')">
          <i data-lucide="plus-square" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.add_panel') }}</span>
        </button>
      </div>
    </div>

    <!-- Herramientas de navegación -->
    <div class="mb-4">
      <div v-if="toolbar_expanded" class="text-xs font-medium text-gray-400 mb-2 px-1">{{
        get_t('tools.categories.navigation') }}</div>
      <div class="space-y-2">
        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'zoom', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'zoom', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('zoom')" :title="get_t('tools.zoom_tool')">
          <i data-lucide="zoom-in" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.zoom_tool') }}</span>
        </button>

        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'hand', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'hand', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('hand')" :title="get_t('tools.hand_tool')">
          <i data-lucide="hand" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.hand_tool') }}</span>
        </button>
      </div>
    </div>
    <!-- Herramientas de contenido -->
    <div class="mb-4">
      <div v-if="toolbar_expanded" class="text-xs font-medium text-gray-400 mb-2 px-1">{{
        get_t('tools.categories.content') }}</div>
      <div class="space-y-2">
        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'add_text', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'add_text', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('add_text')" :title="get_t('tools.add_text')">
          <i data-lucide="type" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.add_text') }}</span>
        </button>

        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'add_balloon', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'add_balloon', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('add_balloon')" :title="get_t('tools.add_speech_balloon')">
          <i data-lucide="message-circle" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.add_balloon') }}</span>
        </button>

        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-600/25': active_tool === 'add_pointer', 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': active_tool !== 'add_pointer', 
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('add_pointer')" :title="get_t('tools.add_tail')">
          <i data-lucide="navigation" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('tools.add_tail') }}</span>
        </button>
      </div>
    </div>

    <!-- Herramientas de galería -->
    <div class="mb-4">
      <div v-if="toolbar_expanded" class="text-xs font-medium text-gray-400 mb-2 px-1">{{
        get_t('tools.categories.gallery') }}</div>
      <div class="space-y-2">
        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-gray-700 hover:to-gray-650 border border-gray-600/30 hover:border-gray-500/50': true, 
            'justify-center': !toolbar_expanded 
          }" @click.stop="show_gallery()" :title="get_t('gallery.open_gallery')">
          <i data-lucide="sparkles" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('gallery.open_gallery') }}</span>
        </button>
      </div>
    </div>

    <!-- AI Tools Category -->
    <div class="mb-4">
      <div v-if="toolbar_expanded" class="text-xs font-medium text-gray-400 mb-2 px-1">{{
        get_t('tools.categories.ai') }}</div>
      <div class="space-y-2">

        <!-- AI Generation Tool -->
        <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 border border-purple-500/50 hover:border-purple-400/60': ai_generation_active,
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-purple-800/30 hover:to-purple-750/30 border border-gray-600/30 hover:border-purple-500/50': !ai_generation_active,
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('ai_generation')" :title="get_t('ai.generation_panel')">
          <div
            class="flex items-center justify-center w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110">
            <span class="text-xs font-bold">IA</span>
          </div>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('ai.generation_panel') }}</span>
        </button>

        <!-- AI Library Tool -->
        <!-- <button class="w-full p-3 rounded-lg flex items-center transition-all duration-200 group" :class="{ 
            'bg-gradient-to-r from-gray-800 to-gray-750 hover:from-purple-800/30 hover:to-purple-750/30 border border-gray-600/30 hover:border-purple-500/50': true,
            'justify-center': !toolbar_expanded 
          }" @click.stop="change_tool('ai_library')" :title="get_t('ai.library_modal_title')">
          <i data-lucide="library" class="w-5 h-5 flex-shrink-0 transition-transform group-hover:scale-110"></i>
          <span v-if="toolbar_expanded" class="ml-3 text-sm font-medium">{{ get_t('ai.library_modal_title') }}</span>
        </button> -->
      </div>
    </div>

  </div>

  <!-- Main canvas area -->
  <div class="flex-1 relative overflow-hidden bg-gradient-to-br from-gray-900 via-gray-850 to-gray-900">
    <!-- Canvas container without external margin - always visible -->
    <div class="comic-editor-container h-full w-full"
      :style="{ paddingBottom: is_mkc2_container && container_pages && container_pages.length > 0 && show_pages_navigation ? '120px' : '0px' }">
      <!-- Canvas wrapper - quitamos el transform:scale que existía antes -->
      <div id="canvas_wrapper" class="relative h-full w-full">
        <!-- Canvas container with margin -->
        <div class="canvas-container h-full w-full">
          <canvas id="comic_canvas" class="h-full w-full"></canvas>
        </div>
      </div>
    </div>

    <!-- Pages navigation bar (MKC2 containers only) - POSITIONED BETWEEN SIDEBARS -->
    <div v-if="is_mkc2_container && container_pages && container_pages.length > 0 && show_pages_navigation"
      id="pages_navigation"
      class="absolute bottom-0 left-0 right-0 bg-gray-900/95 border-t border-gray-700/50 backdrop-blur-sm"
      style="height: 120px;">
      <div class="h-full flex items-center justify-center py-6 px-6">
        <div class="flex items-center gap-4 max-w-full overflow-x-auto overflow-y-hidden navigation-scrollbar">
          <!-- Page thumbnails -->
          <div v-for="(page, index) in container_pages" :key="'page_' + index" @click="switch_to_page(index)"
            class="flex-shrink-0 relative cursor-pointer group transition-all duration-200 my-4">
            <!-- Delete button - only visible on hover and when there's more than 1 page -->
            <button v-if="container_pages.length > 1" @click.stop="confirm_delete_page(index)"
              class="absolute top-1 right-1 w-4 h-4 bg-red-600/80 hover:bg-red-600 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10"
              :title="get_t('pages.delete_page')">
              <i data-lucide="x" class="w-2.5 h-2.5 text-white"></i>
            </button>

            <div class="w-20 h-20 rounded-lg border-2 transition-all duration-200 overflow-hidden shadow-lg p-1.5"
              :class="index === current_page_index 
                   ? 'border-rose-500 bg-rose-500/10 shadow-rose-500/20' 
                   : 'border-gray-600 bg-gray-800 hover:border-rose-400 hover:bg-rose-500/5'">
              <img v-if="page.thumbnail" :src="'data:image/png;base64,' + page.thumbnail"
                class="w-full h-full object-cover" :alt="'Page ' + (index + 1)">
              <div v-else class="w-full h-full bg-gray-700 flex items-center justify-center">
                <div class="text-center">
                  <i data-lucide="image" class="w-5 h-5 text-gray-500 mx-auto mb-1"></i>
                  <div class="text-xs text-gray-400">{{ index + 1 }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add new page button -->
          <button @click="add_new_page"
            class="flex-shrink-0 w-20 h-20 bg-gray-800 hover:bg-gray-700 border-2 border-dashed border-gray-600 hover:border-rose-400 rounded-lg transition-all duration-200 flex flex-col items-center justify-center group shadow-lg my-4"
            :title="get_t('pages.add_new_page')">
            <i data-lucide="plus" class="w-5 h-5 text-gray-500 group-hover:text-rose-400 transition-colors"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Welcome Screen -->
    <div v-if="comic_mode===true" v-show="show_welcome_screen" id="welcome_screen"
      class="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-850 to-gray-900 z-[90] overflow-y-auto overflow-x-hidden scrollbar_hidden md:scrollbar-thin md:scrollbar-track-gray-800 md:scrollbar-thumb-gray-600">
      <div class="w-full px-8 py-8 pt-24 pb-16">
        <!-- Logo and title -->
        <div class="text-center mb-12">
          <img src="./img/logo_mobile.png" :alt="get_t('logo.alt_text')" class="h-16 mx-auto mb-4">
          <h1 class="text-3xl font-bold text-white mb-2">{{ get_t('welcome.title') }}</h1>
          <p class="text-gray-400">{{ get_t('welcome.subtitle') }}</p>
        </div>

        <!-- Main panels grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-5xl mx-auto">

          <!-- Recent Files Panel (Top Left - Auto height) -->
          <div
            class="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 border border-gray-700/50 hover:border-rose-500/50 transition-all duration-300 group min-h-80 flex flex-col"
            :class="{ 'opacity-50': should_disable_recent_files() }">
            <div class="flex items-center mb-4">
              <div class="p-3 bg-rose-600/20 rounded-lg mr-4 group-hover:bg-rose-600/30 transition-colors">
                <i data-lucide="clock" class="w-6 h-6 text-rose-400"></i>
              </div>
              <h3 class="text-lg font-semibold text-white">{{ get_t('welcome.recent_files') }}</h3>
            </div>
            <p class="text-gray-400 text-sm mb-4">{{ get_t('welcome.recent_files_desc') }}</p>

            <!-- Browser compatibility warning -->
            <div v-if="should_disable_recent_files()"
              class="mb-4 p-3 bg-red-900/20 border border-red-500/30 rounded-lg">
              <div class="flex items-start space-x-2">
                <i data-lucide="alert-triangle" class="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0"></i>
                <div>
                  <p class="text-red-400 text-sm font-medium mb-1">{{ get_t('browser.recent_files_disabled') }}</p>
                  <p class="text-red-300 text-xs">{{ get_browser_compatibility_message().message }}</p>
                  <a v-if="get_browser_compatibility_message().link" :href="get_browser_compatibility_message().link"
                    target="_blank"
                    class="text-red-400 text-xs underline hover:text-red-300 transition-colors mt-1 inline-block">
                    {{ get_t('browser.enable_filesystem_guide') }}
                  </a>
                </div>
              </div>
            </div>

            <div v-if="!should_disable_recent_files() && recent_files.length > 0" class="flex-1">
              <div class="grid grid-cols-5 gap-2">
                <div v-for="file in recent_files.slice(0, 10)" :key="file.name"
                  class="group/file bg-gray-800/40 hover:bg-gray-700/60 rounded-lg border border-gray-700/30 hover:border-rose-500/30 transition-all duration-200 cursor-pointer p-2 flex flex-col relative"
                  :title="file.name">
                  <!-- Remove button - only visible on hover -->
                  <button @click.stop="remove_from_recent_files(file.name)"
                    class="absolute top-1 right-1 w-4 h-4 bg-red-600/80 hover:bg-red-600 rounded-full flex items-center justify-center opacity-0 group-hover/file:opacity-100 transition-opacity duration-200 z-10"
                    :title="get_t('actions.remove_from_recent')">
                    <i data-lucide="x" class="w-2.5 h-2.5 text-white"></i>
                  </button>

                  <!-- Clickable area for opening file -->
                  <div @click.stop="open_from_recent_with_auth_check(file)" class="flex flex-col h-full">
                    <div
                      class="aspect-[3/4] bg-gray-600/30 rounded flex items-center justify-center overflow-hidden mb-2">
                      <!-- Show thumbnail if available -->
                      <img v-if="file.thumbnail" :src="file.thumbnail" :alt="file.name"
                        class="w-full h-full object-contain rounded" />
                      <!-- Fallback icon -->
                      <div v-else class="flex flex-col items-center justify-center text-gray-400 h-full">
                        <i data-lucide="file-text" class="w-4 h-4 mb-1 text-rose-400"></i>
                        <span class="text-[10px] text-center">{{ get_t('welcome.no_preview') }}</span>
                      </div>
                    </div>
                    <div class="text-center">
                      <p
                        class="text-[10px] font-medium text-gray-200 group-hover/file:text-white transition-colors truncate leading-tight">
                        {{ file.name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="should_disable_recent_files()" class="flex items-center justify-center flex-1">
              <div class="text-center">
                <div class="w-10 h-10 bg-red-700/20 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <i data-lucide="alert-triangle" class="w-5 h-5 text-red-400"></i>
                </div>
                <p class="text-xs text-red-400 font-medium mb-1">{{ get_t('browser.recent_files_disabled') }}</p>
                <p class="text-xs text-red-300">{{ get_t('browser.recent_files_disabled_desc') }}</p>
              </div>
            </div>
            <div v-else class="flex items-center justify-center flex-1">
              <div class="text-center">
                <div class="w-10 h-10 bg-gray-700/50 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <i data-lucide="clock" class="w-5 h-5 text-gray-500"></i>
                </div>
                <p class="text-xs text-gray-500">{{ get_t('welcome.no_recent_files') }}</p>
              </div>
            </div>
          </div>

          <!-- Templates Panel (Top Right - Auto height) -->
          <div
            class="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 border border-gray-700/50 hover:border-purple-500/50 transition-all duration-300 cursor-pointer group min-h-80">
            <div class="flex items-center mb-4">
              <div class="p-3 bg-purple-600/20 rounded-lg mr-4 group-hover:bg-purple-600/30 transition-colors">
                <i data-lucide="layout-template" class="w-6 h-6 text-purple-400"></i>
              </div>
              <h3 class="text-lg font-semibold text-white">{{ get_t('welcome.templates') }}</h3>
            </div>
            <p class="text-gray-400 text-sm mb-4">{{ get_t('welcome.templates_desc') }}</p>

            <div v-if="loading_templates" class="flex items-center justify-center h-48">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-400"></div>
            </div>

            <div v-else-if="templates.length > 0" class="flex flex-col">
              <!-- Templates grid - 4 columns for smaller cards, no fixed height -->
              <div class="grid grid-cols-4 gap-2 mb-3">
                <div v-for="template in templates.slice(0, 4)" :key="template.id"
                  @click="is_template_premium(template.id) && !user_data.is_premium ? show_premium_modal('premium', get_t('premium.premium_required')) : load_template(template.id)"
                  class="group bg-gradient-to-br from-gray-700/30 to-gray-800/30 rounded-lg border border-gray-600/30 hover:border-purple-500/50 transition-all duration-300 cursor-pointer hover:shadow-lg hover:shadow-purple-500/10 flex flex-col p-2 relative"
                  :class="{ 'opacity-60': is_template_premium(template.id) && !user_data.is_premium }">
                  <!-- Premium Badge -->
                  <div v-if="is_template_premium(template.id)" class="absolute top-1 right-1 z-10">
                    <div
                      class="flex items-center justify-center w-4 h-4 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full shadow-lg">
                      <i data-lucide="sparkles" class="w-2 h-2 text-white"></i>
                    </div>
                  </div>

                  <!-- Premium Overlay (for non-premium users) -->
                  <div v-if="is_template_premium(template.id) && !user_data.is_premium"
                    class="absolute inset-0 bg-black/40 backdrop-blur-[1px] rounded-lg flex items-center justify-center z-20">
                    <div class="text-center">
                      <i data-lucide="lock" class="w-4 h-4 text-amber-400 mx-auto mb-1"></i>
                      <p class="text-xs text-amber-400 font-medium">{{ get_t('premium.required') }}</p>
                    </div>
                  </div>
                  <div
                    class="aspect-[3/4] bg-gray-600/30 rounded-md flex items-center justify-center overflow-hidden mb-2">
                    <!-- Show thumbnail if available -->
                    <img v-if="template.thumbnail" :src="template.thumbnail" :alt="template.name"
                      class="w-full h-full object-contain rounded-md" />
                    <!-- Fallback icon -->
                    <div v-else class="flex flex-col items-center justify-center text-gray-400 h-full">
                      <i data-lucide="image" class="w-4 h-4 mb-1"></i>
                      <span class="text-xs">{{ get_t('welcome.template_preview') }}</span>
                    </div>
                  </div>
                  <div class="text-center">
                    <h4
                      class="font-medium text-white group-hover:text-purple-300 transition-colors text-xs leading-tight truncate">
                      {{ template.name }}</h4>
                  </div>
                </div>
              </div>

              <!-- Browse button - always visible outside scroll -->
              <button @click="show_templates_browser()"
                class="w-full px-3 py-2 text-sm text-purple-400 hover:text-purple-300 hover:bg-purple-500/10 rounded-lg transition-colors border border-purple-500/20 hover:border-purple-500/40 flex-shrink-0">
                {{ get_t('welcome.browse_more_templates') }}
              </button>
            </div>

            <div v-else class="flex items-center justify-center h-48">
              <div class="text-center">
                <i data-lucide="layout-template" class="w-12 h-12 text-gray-500 mx-auto mb-2"></i>
                <p class="text-sm text-gray-500">{{ get_t('welcome.no_templates') }}</p>
              </div>
            </div>
          </div>

          <!-- Subscribe Panel (Bottom Left - Shorter) -->
          <div @click="show_pricing()"
            class="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 border border-gray-700/50 hover:border-amber-500/50 transition-all duration-300 cursor-pointer group h-64">
            <div class="flex items-center mb-4">
              <div class="p-3 bg-amber-600/20 rounded-lg mr-4 group-hover:bg-amber-600/30 transition-colors">
                <i data-lucide="crown" class="w-6 h-6 text-amber-400"></i>
              </div>
              <h3 class="text-lg font-semibold text-white">{{ get_t('pricing.explore_plans') }}</h3>
            </div>
            <p class="text-gray-400 text-sm mb-6">{{ get_t('pricing.unlock_features') }}</p>
            <div class="flex items-center justify-center h-32">
              <button
                class="w-full px-3 py-2 text-sm text-amber-300 hover:text-amber-200 hover:bg-amber-400/10 rounded-lg transition-colors border border-amber-400/20 hover:border-amber-400/40">
                {{ get_t('pricing.view_plans') }}
              </button>
            </div>
          </div>

          <!-- Tutorials Panel (Bottom Right - Shorter - Previously Templates position) -->
          <div @click="show_tutorials_modal()"
            class="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 border border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 cursor-pointer group h-64">
            <div class="flex items-center mb-4">
              <div class="p-3 bg-blue-600/20 rounded-lg mr-4 group-hover:bg-blue-600/30 transition-colors">
                <i data-lucide="book-open" class="w-6 h-6 text-blue-400"></i>
              </div>
              <h3 class="text-lg font-semibold text-white">{{ get_t('welcome.tutorials') }}</h3>
            </div>
            <p class="text-gray-400 text-sm mb-6">{{ get_t('welcome.tutorials_desc') }}</p>

            <div class="flex items-center justify-center h-32">

              <button
                class="w-full px-3 py-2 text-sm text-blue-300 hover:text-blue-200 hover:bg-blue-400/10 rounded-lg transition-colors border border-blue-400/20 hover:border-blue-400/40 flex-shrink-0">
                {{ get_t('help.open_tutorials') }}
              </button>

            </div>

          </div>
        </div>

        <!-- Quick actions -->
        <div class="flex justify-center gap-4 mt-8">
          <button @click="confirm_new_document()"
            class="px-6 py-3 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-medium transition-colors">
            {{ get_t('welcome.new_document') }}
          </button>
          <button @click="open_document()"
            class="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors">
            {{ get_t('welcome.open_document') }}
          </button>
        </div>
      </div>

      <!-- Legal links - Fixed at bottom of screen -->
      <div
        class="absolute bottom-0 left-0 right-0 flex justify-center gap-6 py-4 bg-gradient-to-t from-gray-900/80 to-transparent backdrop-blur-sm">
        <a href="#" @click.prevent="show_privacy_policy()"
          class="text-sm text-gray-400 hover:text-rose-400 transition-colors">
          {{ get_t('menu.about_submenu.privacy_policy') }}
        </a>
        <a href="#" @click.prevent="show_terms_of_use()"
          class="text-sm text-gray-400 hover:text-rose-400 transition-colors">
          {{ get_t('menu.about_submenu.terms_of_use') }}
        </a>
      </div>
    </div>

    <!-- Floating toolbar for image editing -->
    <div v-if="selected_image && !show_welcome_screen" id="image_toolbar"
      class="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-gray-800 via-gray-750 to-gray-800 rounded-xl shadow-2xl border border-gray-600/50 backdrop-blur-md p-4 flex items-center gap-6 z-10">
      <!-- Zoom controls -->
      <div class="flex items-center gap-2">
        <button @click="zoom_image(0.9)" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('zoom.zoom_out')">
          <i data-lucide="zoom-out" class="w-5 h-5"></i>
        </button>

        <button @click="zoom_image(1.1)" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('zoom.zoom_in')">
          <i data-lucide="zoom-in" class="w-5 h-5"></i>
        </button>
      </div>

      <!-- Rotation controls -->
      <div class="flex items-center gap-2">
        <button @click="rotate_image(-15)" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('image.rotate_left')">
          <i data-lucide="rotate-ccw" class="w-5 h-5"></i>
        </button>

        <input type="range" min="-180" max="180" v-model="image_rotation" @input="update_image_rotation"
          class="w-32 accent-rose-600" :title="get_t('image.rotation')">

        <button @click="rotate_image(15)" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('image.rotate_right')">
          <i data-lucide="rotate-cw" class="w-5 h-5"></i>
        </button>
      </div>

      <!-- Divider -->
      <div class="h-8 w-px bg-gray-600 mx-1"></div>

      <!-- Reset controls -->
      <div class="flex items-center gap-2">
        <button @click="reset_image_size" class="p-1.5 hover:bg-gray-700 rounded-md" :title="get_t('image.reset_size')">
          <i data-lucide="maximize" class="w-5 h-5"></i>
        </button>

        <button @click="reset_image_rotation" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('image.reset_rotation')">
          <i data-lucide="refresh-cw" class="w-5 h-5"></i>
        </button>
      </div>

      <!-- Divider -->
      <div class="h-8 w-px bg-gray-600 mx-1"></div>

      <!-- Delete control -->
      <button @click="delete_selected_image" class="p-1.5 hover:bg-red-900 rounded-md text-rose-400"
        :title="get_t('image.delete_image')">
        <i data-lucide="trash-2" class="w-5 h-5"></i>
      </button>
    </div>

    <!-- Añadir controles cuando un bocadillo está seleccionado -->
    <div v-if="(selected_object_is_balloon || active_subtool === 'node_editor' || balloon_edit_mode_active) && 
          (selected_object_array.length == 1 || balloon_edit_mode_active) && !show_welcome_screen" id="balloon_toolbar"
      ref="balloon_toolbar" class="absolute" :style="{
        left: balloon_toolbar_position.x + 'px',
        top: balloon_toolbar_position.y + 'px'
      }">


      <div v-if="active_subtool != 'node_editor' && !balloon_edit_mode_active"
        class="rounded-lg shadow-lg p-3 flex items-center gap-4 z-10 backdrop-blur-sm bg-gray-900/80 border border-gray-600">
        <!-- Botón para editar texto -->
        <button @click="edit_balloon_text(selected_object)" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('balloon.edit_text')">
          <i data-lucide="type" class="w-5 h-5"></i>
        </button>

        <!-- Botón para alternar modo de edición de forma -->
        <button @click="toggle_balloon_edit_mode(selected_object)" class="p-1.5 rounded-md"
          :class="{'bg-rose-900': selected_object_editing_mode, 'hover:bg-gray-700': !selected_object_editing_mode}"
          :title="get_t('balloon.edit_shape')">
          <i data-lucide="tangent" class="w-5 h-5"></i>
        </button>

        <!-- Tail button -->
        <button @click="change_tool('add_pointer')" class="p-1.5 rounded-md"
          :class="{'bg-rose-900': selected_object_editing_mode, 'hover:bg-gray-700': !selected_object_editing_mode}"
          :title="get_t('balloon.tail_tool')">
          <i data-lucide="navigation" class="w-5 h-5"></i>
        </button>

        <!-- Divider -->
        <div class="h-8 w-px bg-gray-600 mx-1"></div>

        <!-- Naturalize balloon button -->
        <!-- <button 
          @click="naturalize_balloon(selected_object)"
          class="p-1.5 hover:bg-gray-700 rounded-md"
          title="Naturalize Balloon"
        >
          <i data-lucide="brush" class="w-5 h-5"></i>
        </button> -->

        <!-- Simplify and smooth balloon button -->
        <button @click="simplify_and_smooth_balloon(selected_object)" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('balloon.smooth_balloon')">
          <i data-lucide="spline" class="w-5 h-5"></i>
        </button>

        <!-- Randomize balloon button -->
        <button @click="randomize_balloon(selected_object)" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('balloon.randomize_balloon')">
          <i data-lucide="dices" class="w-5 h-5"></i>
        </button>

        <!-- Divider -->
        <div class="h-8 w-px bg-gray-600 mx-1"></div>

        <!-- Color de fondo -->
        <div class="flex flex-col items-center">
          <label class="block text-xs mb-1">{{ get_t('balloon.fill') }}</label>
          <color-picker-wrapper :model-value="get_balloon_fill_color()"
            @update:model-value="update_balloon_fill($event)" @change="push_to_history('change_balloon_fill')"
            :for-fill="true" :is_toolbar="true" />
        </div>

        <!-- Color de borde -->
        <div class="flex flex-col items-center">
          <label class="block text-xs mb-1">{{ get_t('balloon.border') }}</label>
          <color-picker-wrapper :model-value="selected_object_shape_stroke"
            @update:model-value="update_balloon_stroke($event)" @change="push_to_history('change_balloon_stroke')"
            :for-fill="false" :is_toolbar="true" />
        </div>

        <!-- Divider -->
        <div class="h-8 w-px bg-gray-600 mx-1"></div>

        <!-- Delete control -->
        <button @click="delete_selected_object" class="p-1.5 hover:bg-red-900 rounded-md text-rose-400"
          :title="get_t('balloon.delete_balloon')">
          <i data-lucide="trash-2" class="w-5 h-5"></i>
        </button>

      </div>

      <div v-if="balloon_edit_mode_active"
        class="rounded-lg shadow-lg p-3 flex items-center gap-4 z-10 backdrop-blur-sm bg-gray-900/80 border border-gray-600">
        <!-- Exit from node editing mode -->
        <button @click="exit_balloon_edit_mode()" class="p-1.5 hover:bg-gray-700 rounded-md"
          :title="get_t('balloon.exit_node_editor')">
          <i data-lucide="x" class="w-5 h-5"></i>
        </button>
      </div>

    </div>

  </div>

  <!-- Right sidebar container -->
  <div class="relative transition-all duration-300 ease-in-out" :class="{ 
         'w-80': !right_bar_collapsed, 
         'w-0': right_bar_collapsed 
       }">

    <!-- Collapse/Expand button -->
    <button @click.stop="toggle_right_bar" data-toggle-right-bar
      class="absolute top-4 left-[-33px] z-10 p-2 bg-gray-900 hover:from-gray-700 hover:to-gray-600 rounded-l-lg border border-r-0 border-gray-600/50 text-gray-300 hover:text-white transition-all duration-300 shadow-lg"
      :title="right_bar_collapsed ? get_t('ui.show_properties') : get_t('ui.hide_properties')">
      <i :data-lucide="right_bar_collapsed ? 'panel-right' : 'panel-right-close'"
        class="w-4 h-4 transition-transform duration-300" :class="{ 'rotate-180': right_bar_collapsed }"></i>
    </button>

    <!-- Right sidebar - Properties -->
    <div id="right_bar"
      class="h-full bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900 border-l border-gray-700/50 flex flex-col overflow-x-visible overflow-y-auto scrollbar-thin shadow-lg backdrop-blur-sm transition-all duration-300 ease-in-out"
      :class="{ 
           'translate-x-full': right_bar_collapsed && is_mobile_view 
         }">

      <!-- Mobile collapse button -->
      <button v-if="is_mobile_view" @click="toggle_right_bar" data-toggle-right-bar
        class="absolute top-4 z-10 p-2 bg-gradient-to-r from-gray-800 to-gray-700 hover:from-gray-700 hover:to-gray-600 rounded-l-lg border border-r-0 border-gray-600/50 text-gray-300 hover:text-white transition-all duration-300 shadow-lg"
        :class="right_bar_collapsed ? 'fixed right-0' : '-left-12'"
        :title="right_bar_collapsed ? get_t('ui.show_properties') : get_t('ui.hide_properties')">
        <i :data-lucide="right_bar_collapsed ? 'panel-right' : 'panel-right-close'"
          class="w-5 h-5 transition-transform duration-300" :class="{ 'rotate-180': right_bar_collapsed }"></i>
      </button>

      <!-- Object Properties Panel (Collapsible) -->
      <div
        v-if="active_tool == 'select' && selected_object_exists && active_subtool !== 'text' && !balloon_edit_mode_active"
        class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('object_props')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-amber-800/20 hover:to-orange-800/20 panel_header transition-all duration-200">
          <div class="flex items-center gap-2">
            <i data-lucide="settings" class="w-5 h-5 text-amber-400 mr-3"></i>
            <h3 class="section_title text-amber-200 font-semibold">{{ get_t('properties.object_properties') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('object_props')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-amber-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-amber-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('object_props')}" data-panel-id="object_props" v-lucide>
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-3 items-center">
              <button
                class="p-2 hover:bg-amber-600/20 rounded-lg transition-all duration-200 text-gray-300 hover:text-white border border-gray-600/30 hover:border-amber-500/50"
                :title="get_t('object.reset_scale')" @click="reset_object_scale()">
                <i data-lucide="maximize" class="w-4 h-4"></i>
              </button>
              <label class="text-sm mr-auto font-medium text-gray-200 ml-3">{{ get_t('object.size') }}</label>
              <!-- Use object_scale_value directly and format it -->
              <span class="text-sm font-semibold text-amber-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{
                (object_scale_value * 100).toFixed(2) }}%</span>
            </div>
            <input type="range" v-model.number="object_scale_value" min="0.1" max="3" step="0.01"
              class="w-full accent-amber-500" @input="resize_object_with_slider()"
              @change="push_to_history('resize_object')">
          </div>

          <!-- Slider rotation -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-3 items-center">
              <button
                class="p-2 hover:bg-amber-600/20 rounded-lg transition-all duration-200 text-gray-300 hover:text-white border border-gray-600/30 hover:border-amber-500/50"
                :title="get_t('object.reset_rotation')" @click="reset_object_rotation()">
                <i data-lucide="refresh-cw" class="w-4 h-4"></i>
              </button>
              <label class="text-sm mr-auto font-medium text-gray-200 ml-3">{{ get_t('object.rotation') }}</label>
              <span class="text-sm font-semibold text-amber-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{
                Math.round(object_rotation_value) }}°</span>
            </div>
            <input type="range" v-model="object_rotation_value" min="-180" max="180" class="w-full accent-amber-500"
              @input="rotate_object_with_slider()" @change="push_to_history('transform_object')">
          </div>

          <!-- Move to Global Panel Button -->
          <div v-if="selected_object && !selected_object_is_in_global_panel"
            class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <button @click="move_object_to_global_panel"
              class="w-full p-3 bg-gradient-to-r from-amber-600/80 to-orange-600/80 hover:from-amber-500/80 hover:to-orange-500/80 text-white rounded-lg transition-all duration-200 flex items-center justify-center gap-2 border border-amber-500/30 hover:border-amber-400/50">
              <i data-lucide="globe" class="w-4 h-4"></i>
              <span class="font-medium">{{ get_t('object.move_to_global_panel') }}</span>
            </button>
          </div>

          <!-- Cross-Panel Dragging Option -->
          <div v-if="selected_object" class="mb-6">
            <label
              class="flex items-center justify-between p-4 rounded-xl border-2 border-gray-600/50 bg-gradient-to-r from-gray-700/50 to-gray-800/50 text-sm hover:border-amber-500/50 transition-all duration-200">
              <div class="flex items-center gap-3">
                <i data-lucide="move" class="w-4 h-4 text-amber-400"></i>
                <span class="text-gray-200 font-medium">{{ get_t('object.enable_cross_panel_dragging') }}</span>
              </div>
              <input type="checkbox" v-model="enable_cross_panel_dragging"
                class="w-5 h-5 text-amber-500 bg-gray-700 border-gray-500 rounded-lg focus:ring-amber-500 focus:ring-2 focus:ring-offset-0 transition-colors"
                id="cross-panel-drag-checkbox">
            </label>
            <p class="text-xs text-gray-400 mt-2 px-4 leading-relaxed">{{
              get_t('object.cross_panel_dragging_description') }}</p>
          </div>

          <!-- Redesigned Tips Box -->
          <div
            class="mt-6 bg-gradient-to-br from-amber-900/20 to-orange-900/20 rounded-xl text-sm overflow-hidden border border-amber-500/20">
            <!-- Header with single icon -->
            <div
              class="flex items-center bg-gradient-to-r from-amber-800/30 to-orange-800/30 px-4 py-3 border-b border-amber-500/20">
              <i data-lucide="lightbulb" class="w-5 h-5 text-amber-400 mr-3"></i>
              <span class="text-amber-200 font-semibold">{{ get_t('tips.section_title') }}</span>
            </div>

            <!-- Tips content -->
            <div class="p-4 space-y-3">
              <!-- Tip 1: resize -->
              <div class="text-gray-200 flex items-start">
                <span class="text-amber-400 mr-3 mt-0.5">•</span>
                <span class="leading-relaxed">{{ get_t('tips.resize_object') }}</span>
              </div>

              <!-- Tip 2: deselect -->
              <div class="text-gray-200 flex items-start">
                <span class="text-amber-400 mr-3 mt-0.5">•</span>
                <span class="leading-relaxed">{{ get_t('tips.deselect_object') }}</span>
              </div>

              <!-- Tip 3: direct select -->
              <div class="text-gray-200 flex items-start">
                <span class="text-amber-400 mr-3 mt-0.5">•</span>
                <span class="leading-relaxed">{{ get_t('tips.direct_select') }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- No Object Selected Info (Not Collapsible) -->
      <div v-if="active_tool == 'select' && !selected_object_exists && !balloon_edit_mode_active"
        class="p-6 border-b border-gray-600/30 bg-gradient-to-br from-gray-800/30 to-gray-900/50" v-lucide>
        <div class="text-center">
          <div class="mb-4">
            <i data-lucide="mouse-pointer-click" class="w-12 h-12 text-gray-400 mx-auto"></i>
          </div>
          <h3 class="section_title text-gray-300 font-semibold mb-2">{{ get_t('properties.no_object_selected') }}</h3>
          <p class="text-sm text-gray-400 leading-relaxed">{{ get_t('properties.select_object_message') }}</p>
        </div>
      </div>

      <!-- Navigation Info Panel (Not Collapsible) -->
      <div v-if="active_tool == 'zoom'"
        class="p-6 border-b border-gray-600/30 bg-gradient-to-br from-green-900/20 to-emerald-900/20" v-lucide>
        <div class="flex items-center mb-4">
          <i data-lucide="navigation" class="w-5 h-5 text-green-400 mr-3"></i>
          <h3 class="section_title text-green-200 font-semibold">{{ get_t('properties.navigation') }}</h3>
        </div>

        <ul class="space-y-3 text-gray-200 text-sm">
          <li class="flex items-center p-2 rounded-lg bg-gray-800/30">
            <i data-lucide="zoom-in" class="w-4 h-4 mr-3 text-green-400"></i>
            <span class="leading-relaxed">{{ get_t('navigation.click_to_zoom_in') }}</span>
          </li>
          <li class="flex items-center p-2 rounded-lg bg-gray-800/30">
            <i data-lucide="zoom-out" class="w-4 h-4 mr-3 text-green-400"></i>
            <span class="leading-relaxed">{{ get_t('navigation.alt_click_to_zoom_out') }}</span>
          </li>
          <li class="flex items-center p-2 rounded-lg bg-gray-800/30">
            <i data-lucide="move-horizontal" class="w-4 h-4 mr-3 text-green-400"></i>
            <span class="leading-relaxed">{{ get_t('navigation.click_drag_horizontal_zoom') }}</span>
          </li>
          <li class="flex items-center p-2 rounded-lg bg-gray-800/30">
            <i data-lucide="mouse" class="w-4 h-4 mr-3 text-green-400"></i>
            <span class="leading-relaxed">{{ get_t('navigation.mouse_wheel_zoom') }}</span>
          </li>
          <li class="flex items-center p-2 rounded-lg bg-gray-800/30">
            <i data-lucide="hand" class="w-4 h-4 mr-3 text-green-400"></i>
            <span class="leading-relaxed">{{ get_t('navigation.space_bar_pan') }}</span>
          </li>
        </ul>

      </div>

      <!-- Gallery Admin Panel (Only in Dev Environment) -->
      <div v-if="is_dev_environment && active_tool == 'select' && selected_object_exists"
        class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('gallery_admin')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-cyan-800/20 hover:to-blue-800/20 panel_header transition-all duration-200">
          <div class="flex items-center">
            <i data-lucide="database" class="w-5 h-5 text-cyan-400 mr-3"></i>
            <h3 class="section_title text-cyan-200 font-semibold">{{ get_t('gallery.admin_panel') }}</h3>
            <span
              class="text-xs bg-cyan-600/30 text-cyan-300 px-2 py-1 rounded-full ml-3 border border-cyan-600/50">DEV</span>
          </div>
          <span>
            <span v-if="is_panel_collapsed('gallery_admin')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-cyan-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-cyan-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('gallery_admin')}" data-panel-id="gallery_admin" v-lucide>

          <div class="mb-4 p-3 bg-cyan-900/20 border border-cyan-600/30 rounded-lg">
            <p class="text-sm text-cyan-200 mb-3">{{ get_t('gallery.admin_instructions') }}</p>

            <!-- Category Selection -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-200 mb-2">{{ get_t('gallery.select_category') }}</label>
              <select v-model="admin_selected_category"
                class="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:border-cyan-500 focus:outline-none">
                <option v-for="category in admin_available_categories" :key="category" :value="category">
                  {{ gallery_categories[category] ? gallery_categories[category].display : category }}
                </option>
              </select>
            </div>

            <!-- Subcategory Selection -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-200 mb-2">Subcategory</label>
              <select v-model="admin_selected_subcategory"
                class="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:border-cyan-500 focus:outline-none">
                <option v-for="subcategory in admin_available_subcategories" :key="subcategory.clean"
                  :value="subcategory.clean">
                  {{ subcategory.display }}
                </option>
              </select>
            </div>

            <!-- Element Name Input -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-200 mb-2">{{ get_t('gallery.element_name') }}</label>
              <input v-model="admin_element_name" type="text" :placeholder="get_t('gallery.enter_element_name')"
                class="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-white focus:border-cyan-500 focus:outline-none">
            </div>

            <!-- Premium Checkbox -->
            <div class="mb-4">
              <label class="flex items-center cursor-pointer">
                <input v-model="admin_element_is_premium" type="checkbox"
                  class="w-4 h-4 text-rose-600 bg-gray-700 border-gray-600 rounded focus:ring-rose-500 focus:ring-2 accent-rose-600">
                <span class="ml-2 text-sm text-gray-200">{{ get_t('gallery.is_premium_element') }}</span>
              </label>
              <p class="text-xs text-gray-400 mt-1">{{ get_t('gallery.premium_element_description') }}</p>
            </div>

            <!-- Add Button -->
            <button @click="add_selected_to_gallery()" :disabled="!admin_element_name.trim()"
              class="w-full bg-cyan-600 hover:bg-cyan-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2">
              <i data-lucide="plus" class="w-4 h-4"></i>
              {{ get_t('gallery.add_to_gallery') }}
            </button>
          </div>

        </div>
      </div>

      <!-- Page Properties Panel (Collapsible) -->
      <div v-if="active_tool == 'select_panel'" class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('page_props')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-purple-800/20 hover:to-violet-800/20 panel_header transition-all duration-200">
          <div class="flex items-center">
            <i data-lucide="file-text" class="w-5 h-5 text-purple-400 mr-3"></i>
            <h3 class="section_title text-purple-200 font-semibold">{{ get_t('properties.page_properties') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('page_props')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-purple-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-purple-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-5 pt-3 panel_content bg-gradient-to-br from-gray-800/30 to-gray-900/30"
          :class="{'open': !is_panel_collapsed('page_props')}" data-panel-id="page_props">
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-3 items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('page.page_margin') }}</label>
              <span class="text-sm font-semibold text-purple-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{ page_margin
                }}px</span>
            </div>
            <input type="range" v-model="page_margin" min="-5" max="100" step="5"
              class="w-full accent-purple-500 bg-gray-600 rounded-lg" @input="update_page_margin()"
              @change="push_to_history('update_margin')">
          </div>

          <!-- Divider/Outline width -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-3 items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('page.outline_width') }}</label>
              <span class="text-sm font-semibold text-purple-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{ outline_width
                }}px</span>
            </div>
            <input type="range" v-model="outline_width" min="0" max="50"
              class="w-full accent-purple-500 bg-gray-600 rounded-lg" @input="update_outline_width(outline_width)"
              @change="push_to_history('update_outline_width')">
          </div>

          <!-- Outline color -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('page.outline_color') }}</label>
              <color-picker-wrapper :model-value="outline_color" @update:model-value="update_outline_color($event)"
                @change="push_to_history('update_outline_color')" :for-fill="false" class="w-[64px] h-10" />
            </div>
          </div>

          <!-- Background color -->
          <div class="mb-4 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('page.background_color') }}</label>
              <color-picker-wrapper :model-value="background_color"
                @update:model-value="update_background_color($event)"
                @change="push_to_history('update_background_color')" :for-fill="false" class="w-[64px] h-10" />
            </div>
          </div>

        </div>
      </div>

      <!-- Panel Properties Panel (Collapsible) - Only show when a panel is selected and it's not a global panel -->
      <div v-if="active_tool == 'select_panel' && selected_panel && selected_panel.getAttr('is_global') != true"
        class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('panel_props')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-rose-800/20 hover:to-pink-800/20 panel_header transition-all duration-200">
          <div class="flex items-center">
            <i data-lucide="layout" class="w-5 h-5 text-rose-400 mr-3"></i>
            <h3 class="section_title text-rose-200 font-semibold">{{ get_t('properties.panel_properties') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('panel_props')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-5 pt-3 panel_content bg-gradient-to-br from-gray-800/30 to-gray-900/30"
          :class="{'open': !is_panel_collapsed('panel_props')}" data-panel-id="panel_props">

          <!-- Panel background color -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('panel.panel_background') }}</label>
              <color-picker-wrapper :model-value="selected_panel_background_color"
                @update:model-value="update_selected_panel_background_color($event)"
                @change="push_to_history('update_panel_background_color')" :for-fill="false" class="w-[64px] h-10" />
            </div>
          </div>
          <!-- Transform panel button -->
          <div class="mb-6">
            <button @click="toggle_panel_transform(); push_to_history('toggle_panel_transform')"
              class="w-full p-3 rounded-xl border-2 text-sm font-medium transition-all duration-200"
              :class="panel_edit_mode_active ? 'bg-gradient-to-r from-rose-600 to-pink-600 border-rose-500 text-white shadow-lg shadow-rose-500/25' : 'bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600 text-gray-200 hover:from-gray-600 hover:to-gray-700 hover:border-gray-500'">
              <i data-lucide="edit-3" class="w-4 h-4 inline mr-2"></i>
              {{ panel_edit_mode_active ? get_t('panel.exit_transform_mode') : get_t('panel.transform_panel') }}
            </button>
          </div>
          <!-- Transform mode toggle (only visible when in edit mode) -->
          <div v-if="panel_edit_mode_active" class="mb-6">
            <label
              class="flex items-center justify-between p-4 rounded-xl border-2 border-gray-600/50 bg-gradient-to-r from-gray-700/50 to-gray-800/50 text-sm hover:border-rose-500/50 transition-all duration-200">
              <div class="flex items-center gap-3">
                <span class="text-gray-200 font-medium">{{ get_t('panel.proportional_mode') }}</span>
                <button class="text-gray-400 hover:text-rose-300 transition-colors p-1 rounded-lg hover:bg-gray-600/50"
                  :title="get_t('panel.proportional_mode_help')" @click="show_proportional_mode_help">
                  <i data-lucide="help-circle" class="w-4 h-4"></i>
                </button>
              </div>
              <input type="checkbox" v-model="panel_edit_proportional_mode"
                class="w-5 h-5 text-rose-600 bg-gray-700 border-gray-500 rounded-lg focus:ring-rose-500 focus:ring-2 focus:ring-offset-0 transition-colors" />
            </label>
            <div class="mt-3 p-3 rounded-lg bg-gray-800/30 border border-gray-600/20">
              <p class="text-xs text-gray-300 leading-relaxed">
                <span class="text-green-400 font-semibold">{{ get_t('panel.green_edge_handles') }}:</span>
                <span class="ml-1">{{ panel_edit_proportional_mode ? get_t('panel.proportional_mode_on') :
                  get_t('panel.proportional_mode_off') }}</span>
              </p>
            </div>
          </div>

          <!-- Margin constraints toggle -->
          <div class="mb-6">
            <label
              class="flex items-center justify-between p-4 rounded-xl border-2 border-gray-600/50 bg-gradient-to-r from-gray-700/50 to-gray-800/50 text-sm hover:border-rose-500/50 transition-all duration-200">
              <div class="flex items-center gap-3">
                <span class="text-gray-200 font-medium">{{ get_t('panel.respect_margins') }}</span>
                <button
                  class="text-gray-400 hover:text-rose-300 transition-colors p-1 mr-3 rounded-lg hover:bg-gray-600/50"
                  :title="get_t('panel.respect_margins_help')" @click="show_respect_margins_help">
                  <i data-lucide="help-circle" class="w-4 h-4"></i>
                </button>
              </div>
              <input type="checkbox" :checked="selected_panel && selected_panel.getAttr('respect_margins')"
                @change="toggle_panel_respect_margins($event.target.checked)"
                class="w-5 h-5 text-rose-600 bg-gray-700 border-gray-500 rounded-lg focus:ring-rose-500 focus:ring-2 focus:ring-offset-0 transition-colors" />
            </label>
          </div>

          <!-- Panel depth controls -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-gray-200 mb-3">{{ get_t('panel.panel_depth') }}</label>
            <div class="flex gap-2">
              <button @click="move_panel_up"
                class="flex-1 p-2 rounded-lg border-2 bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600 text-gray-200 text-sm font-medium hover:from-gray-600 hover:to-gray-700 hover:border-gray-500 transition-all duration-200">
                <i data-lucide="chevron-up" class="w-4 h-4 inline mr-1"></i>
                {{ get_t('panel.move_panel_up') }}
              </button>
              <button @click="move_panel_down"
                class="flex-1 p-2 rounded-lg border-2 bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600 text-gray-200 text-sm font-medium hover:from-gray-600 hover:to-gray-700 hover:border-gray-500 transition-all duration-200">
                <i data-lucide="chevron-down" class="w-4 h-4 inline mr-1"></i>
                {{ get_t('panel.move_panel_down') }}
              </button>
            </div>
          </div>

          <!-- Delete panel button -->
          <div class="mb-6">
            <button @click="delete_selected_panel"
              class="w-full p-3 rounded-xl border-2 bg-gradient-to-r from-red-700 to-red-800 border-red-600 text-white text-sm font-medium hover:from-red-600 hover:to-red-700 hover:border-red-500 transition-all duration-200">
              <i data-lucide="trash-2" class="w-4 h-4 inline mr-2"></i>
              {{ get_t('panel.delete_panel') }}
            </button>
          </div>

        </div>
      </div>

      <!-- Panel unificado para globos de texto (Balloon Panel) -->
      <div
        v-if="(active_tool === 'add_balloon' || (active_tool === 'select' && selected_object_is_balloon)) && active_subtool !== 'text' && !balloon_edit_mode_active"
        class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('balloon_panel')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-rose-800/20 hover:to-pink-800/20 panel_header transition-all duration-200">
          <div class="flex items-center gap-2">
            <i data-lucide="message-circle" class="w-5 h-5 text-rose-400 mr-3"></i>
            <h3 class="section_title text-rose-200 font-semibold">
              {{ active_tool === 'add_balloon' ? get_t('properties.balloon_properties') :
              get_t('properties.edit_balloon') }}
            </h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('balloon_panel')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('balloon_panel')}" data-panel-id="balloon_panel" v-lucide>
          <!-- Balloon Type (común) -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20"
            v-if="active_tool === 'add_balloon'">
            <label class="block text-sm font-medium text-gray-300 mb-3">{{ get_t('balloon.balloon_type') }}</label>
            <div class="flex items-center gap-2">
              <!-- Type selector on creation mode -->
              <button @click="set_balloon_type('speech')" class="p-1.5 rounded-md"
                :class="{'bg-rose-900': active_balloon_type === 'speech', 'hover:bg-gray-700': active_balloon_type !== 'speech'}"
                :title="get_t('balloon.speech_balloon')">
                <i data-lucide="message-circle" class="w-5 h-5"></i>
              </button>

              <button @click="set_balloon_type('rectangular')" class="p-1.5 rounded-md"
                :class="{'bg-rose-900': active_balloon_type === 'rectangular', 'hover:bg-gray-700': active_balloon_type !== 'rectangular'}"
                :title="get_t('balloon.rectangular_balloon')">
                <i data-lucide="square" class="w-5 h-5"></i>
              </button>

              <button @click="set_balloon_type('thought')" class="p-1.5 rounded-md"
                :class="{'bg-rose-900': active_balloon_type === 'thought', 'hover:bg-gray-700': active_balloon_type !== 'thought'}"
                :title="get_t('balloon.thought_bubble')">
                <i data-lucide="cloud" class="w-5 h-5"></i>
              </button>

              <button @click="set_balloon_type('shout')" class="p-1.5 rounded-md"
                :class="{'bg-rose-900': active_balloon_type === 'shout', 'hover:bg-gray-700': active_balloon_type !== 'shout'}"
                :title="get_t('balloon.shout_balloon')">
                <i data-lucide="zap" class="w-5 h-5"></i>
              </button>
            </div>

            <!-- Thought balloon style options (for creation mode) -->
            <div class="mt-3" v-if="active_tool === 'add_balloon' && active_balloon_type === 'thought'">
              <label class="block text-xs font-medium text-gray-300 mb-2">
                {{ get_t('balloon.simplicity') }}: {{ Math.round(thought_balloon_simplicity * 100) }}%
              </label>
              <input type="range" min="0" max="1" step="0.05" v-model.number="thought_balloon_simplicity"
                class="w-full h-2 bg-gray-600 rounded-lg cursor-pointer"
                style="outline: none; -webkit-appearance: none; appearance: none;" />
              <div class="flex justify-between text-xs text-gray-400 mt-1">
                <span>{{ get_t('balloon.complex') }}</span>
                <span>{{ get_t('balloon.simple') }}</span>
              </div>
              <p class="text-xs text-gray-400 mt-1">
                {{ get_t('balloon.bubble_size_description') }}
              </p>
            </div>

            <!-- Extra settings -->
            <div
              v-if="active_tool === 'select' && selected_object && selected_object.getAttr('balloon_type') === 'thought'">
              <div class="bg-gray-700 rounded-lg p-3">
                <h4 class="text-sm font-medium text-gray-200 mb-2">
                  <i data-lucide="cloud" class="w-4 h-4 inline mr-1"></i>
                  {{ get_t('balloon.thought_balloon_options') }}
                </h4>

                <!-- Simplicity Slider -->
                <div class="mb-3">
                  <label class="block text-xs font-medium text-gray-300 mb-2">
                    {{ get_t('balloon.simplicity') }}: {{ Math.round(thought_balloon_simplicity * 100) }}%
                  </label>
                  <input type="range" min="0" max="1" step="0.05" v-model.number="thought_balloon_simplicity"
                    class="w-full h-2 bg-gray-600 rounded-lg cursor-pointer"
                    style="outline: none; -webkit-appearance: none; appearance: none;" />
                  <div class="flex justify-between text-xs text-gray-400 mt-1">
                    <span>{{ get_t('balloon.complex') }}</span>
                    <span>{{ get_t('balloon.simple') }}</span>
                  </div>
                  <p class="text-xs text-gray-400 mt-1">
                    {{ get_t('balloon.bubble_size_description') }}
                  </p>
                </div>

                <p class="text-xs text-gray-400 mb-3">{{ get_t('balloon.regenerate_description') }}</p>
                <button @click="regenerate_thought_balloon(selected_object)"
                  class="w-full px-3 py-2 bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-500 hover:to-rose-600 rounded-lg text-sm transition-all duration-200 shadow-lg shadow-rose-600/25"
                  :title="get_t('balloon.generate_new_pattern')">
                  <i data-lucide="refresh-cw" class="w-4 h-4 inline mr-2"></i>
                  {{ get_t('balloon.regenerate') }}
                </button>
              </div>
            </div>

          </div>

          <!-- Controles de modo edición (solo visibles cuando un globo está seleccionado) -->
          <template v-if="active_tool === 'select' && selected_object_is_balloon">
            <!-- Text editing section -->
            <div class="mb-4">
              <label class="block text-sm mb-2">{{ get_t('balloon.text') }}</label>
              <!-- If multiple texts (merged balloon) -->
              <template v-if="selected_object.texts && selected_object.texts.length > 1">
                <div class="space-y-2">
                  <button v-for="(text_data, index) in selected_object_texts_sorted" :key="text_data.original_index"
                    @click="set_active_text_for_editing(selected_object, text_data.original_index)"
                    class="w-full p-2 bg-gray-700 hover:bg-gray-600 rounded flex items-center justify-between"
                    :class="{ 'bg-rose-800 hover:bg-rose-700': active_text_index_in_merged_balloon === text_data.original_index }">
                    <span class="text-sm truncate max-w-56">
                      {{ text_data.text_node.text().substring(0, 30) + (text_data.text_node.text().length > 30 ? '...' :
                      '') }}
                    </span>
                    <i data-lucide="edit-2" class="w-4 h-4"></i>
                  </button>
                </div>
              </template>
              <!-- If single text -->
              <template v-else>
                <button @click="edit_balloon_text(selected_object)"
                  class="w-full p-2 bg-gray-700 hover:bg-gray-600 rounded flex items-center justify-between">
                  <span class="text-sm truncate max-w-56">
                    {{ selected_object_text_short }}
                  </span>
                  <i data-lucide="edit-2" class="w-4 h-4"></i>
                </button>
              </template>
            </div>

            <!-- Shape editing button -->
            <div class="mb-4">
              <label class="block text-sm mb-2">{{ get_t('balloon.shape') }}</label>
              <button @click="toggle_balloon_edit_mode(selected_object)"
                class="w-full p-2 rounded flex items-center justify-between"
                :class="{'bg-rose-900': selected_object_editing_mode, 'bg-gray-700 hover:bg-gray-600': !selected_object_editing_mode}">
                <span class="text-sm">{{ selected_object_editing_mode ? get_t('balloon.exit_edit_mode') :
                  get_t('balloon.edit_shape') }}</span>
                <i data-lucide="edit-3" class="w-4 h-4"></i>
              </button>
            </div>
          </template>

          <!-- Colors (común con pequeñas diferencias) -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm font-medium text-gray-300 mb-3">
              {{ active_tool === 'add_balloon' ? get_t('balloon.default_colors') : get_t('balloon.colors') }}
            </label>
            <div class="grid grid-cols-2 gap-3">
              <!-- Modo creación -->
              <template v-if="active_tool === 'add_balloon'">
                <div>
                  <label class="block text-xs mb-2 text-gray-400">{{ get_t('balloon.fill_label') }}:</label>
                  <color-picker-wrapper :model-value="get_balloon_fill_color()"
                    @update:model-value="update_balloon_fill($event)" @change="push_to_history('change_balloon_fill')"
                    :for-fill="true" class="w-full h-10" />
                </div>

                <div>
                  <label class="block text-xs mb-2 text-gray-400">{{ get_t('balloon.border_label') }}:</label>
                  <color-picker-wrapper :model-value="balloon_default_stroke"
                    @update:model-value="update_balloon_stroke($event)"
                    @change="push_to_history('change_balloon_stroke')" :for-fill="false" class="w-full h-10" />
                </div>
              </template>

              <!-- Modo edición -->
              <template v-else>
                <div>
                  <label class="block text-xs mb-2 text-gray-400">{{ get_t('balloon.fill_label') }}:</label>
                  <color-picker-wrapper :model-value="get_balloon_fill_color()"
                    @update:model-value="update_balloon_fill($event)" @change="push_to_history('change_balloon_fill')"
                    :for-fill="true" class="w-full h-10" />
                </div>

                <div>
                  <label class="block text-xs mb-2 text-gray-400">{{ get_t('balloon.border_label') }}:</label>
                  <color-picker-wrapper :model-value="selected_object_shape_stroke"
                    @update:model-value="update_balloon_stroke($event)"
                    @change="push_to_history('change_balloon_stroke')" :for-fill="false" class="w-full h-10" />
                </div>
              </template>
            </div>
          </div>

          <!-- Border Width (común con pequeñas diferencias) -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm font-medium text-gray-300 mb-3">
              {{ active_tool === 'add_balloon' ? get_t('balloon.default_border_width') : get_t('balloon.border_width')
              }}
            </label>
            <div class="flex items-center gap-3">
              <!-- Modo creación -->
              <template v-if="active_tool === 'add_balloon'">
                <input type="range" v-model.number="balloon_default_stroke_width" min="0" max="20" step="1"
                  class="w-full accent-rose-600">
                <input type="number" v-model.number="balloon_default_stroke_width" min="0" max="20"
                  class="w-16 p-2 bg-gray-600/50 border border-gray-500/50 rounded-lg text-white text-sm text-center">
              </template>

              <!-- Modo edición -->
              <template v-else>
                <input type="range" v-model.number="selected_object_shape_stroke_width"
                  @input="update_selected_balloon_stroke_width($event.target.value)"
                  @change="push_to_history('change_balloon_stroke_width')" min="0" max="20" step="1"
                  class="w-full accent-rose-600">
                <input type="number" v-model.number="selected_object_shape_stroke_width"
                  @input="update_selected_balloon_stroke_width($event.target.value)"
                  @change="push_to_history('change_balloon_stroke_width')" min="0" max="20"
                  class="w-16 p-2 bg-gray-600/50 border border-gray-500/50 rounded-lg text-white text-sm text-center">
              </template>
              <span class="text-sm text-gray-400">px</span>
            </div>
          </div>

          <!-- Border Dash Pattern  -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm font-medium text-gray-300 mb-3">
              {{ active_tool === 'add_balloon' ? get_t('balloon.default_border_style') : get_t('balloon.border_style')
              }}
            </label>
            <div class="grid grid-cols-2 gap-3"> <!-- Modo creación -->
              <template v-if="active_tool === 'add_balloon'">
                <button @click="balloon_default_stroke_dash = ''"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="balloon_default_stroke_dash === '' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.solid') }}
                </button>
                <button @click="balloon_default_stroke_dash = '5,5'"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="balloon_default_stroke_dash === '5,5' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dashed') }}
                </button>
                <button @click="balloon_default_stroke_dash = '2,3'"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="balloon_default_stroke_dash === '2,3' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dotted') }}
                </button>
                <button @click="balloon_default_stroke_dash = '10,3,2,3'"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="balloon_default_stroke_dash === '10,3,2,3' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dash_dot') }}
                </button>
              </template>

              <!-- Modo edición -->
              <template v-else>
                <button @click="update_selected_balloon_stroke_dash(''); push_to_history('change_balloon_stroke_dash')"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="selected_object_stroke_dash === '' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.solid') }}
                </button>
                <button
                  @click="update_selected_balloon_stroke_dash('5,5'); push_to_history('change_balloon_stroke_dash')"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="selected_object_stroke_dash === '5,5' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dashed') }}
                </button>
                <button
                  @click="update_selected_balloon_stroke_dash('2,3'); push_to_history('change_balloon_stroke_dash')"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="selected_object_stroke_dash === '2,3' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dotted') }}
                </button>
                <button
                  @click="update_selected_balloon_stroke_dash('10,3,2,3'); push_to_history('change_balloon_stroke_dash')"
                  class="p-3 border border-gray-600/50 rounded-lg text-xs transition-all duration-200"
                  :class="selected_object_stroke_dash === '10,3,2,3' ? 'bg-rose-900 hover:bg-rose-800 border-rose-700' : 'hover:bg-gray-600/50'">
                  {{ get_t('balloon.dash_dot') }}
                </button>
              </template>
            </div>
          </div>

          <!-- Fill Opacity (común para ambos modos) -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-3">
              <label class="text-sm font-medium text-gray-300">{{ get_t('balloon.fill_opacity') }}</label>
              <span class="text-sm text-gray-400">{{ Math.round(balloon_fill_alpha * 100) }}%</span>
            </div>
            <input type="range" min="0" max="1" step="0.01" v-model.number="balloon_fill_alpha"
              @input="on_balloon_fill_alpha_input" @change="push_to_history('change_balloon_opacity')"
              class="w-full accent-rose-500">
          </div>

          <!-- Controles específicos para el modo edición -->
          <template v-if="active_tool === 'select' && selected_object_is_balloon">
            <!-- Add pointer and Merge Shapes buttons in one row -->
            <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
              <div class="grid grid-cols-2 gap-3">

                <button @click="handle_merge_selected_balloons" :title="get_t('balloon.merge_shapes')"
                  class="p-3 rounded-lg flex flex-col items-center justify-center gap-1 bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-500 hover:to-rose-600 text-white shadow-lg shadow-rose-600/25 transition-all duration-200">
                  <i data-lucide="combine" class="w-4 h-4"></i>
                  <span class="text-xs">{{ get_t('balloon.merge_shapes') }}</span>
                </button>

                <button @click="change_tool('add_pointer');"
                  class="p-3 bg-gray-600/50 hover:bg-gray-600 rounded-lg flex flex-col items-center justify-center gap-1 border border-gray-500/50 transition-all duration-200"
                  :title="get_t('balloon.add_pointer')">
                  <i data-lucide="navigation" class="w-4 h-4"></i>
                  <span class="text-xs">{{ get_t('balloon.add_pointer') }}</span>
                </button>

              </div>
            </div>

          </template>


          <!-- Instrucciones específicas para el modo de creación -->
          <template v-if="active_tool === 'add_balloon'">
            <div class="mt-6 p-4 bg-gray-700/30 rounded-xl border border-gray-600/20 text-sm flex items-start">
              <i data-lucide="info" class="w-5 h-5 text-rose-400 mr-3 flex-shrink-0 mt-0.5"></i>
              <span class="text-gray-300" v-html="get_t('balloon.creation_instructions')">
              </span>
            </div>
          </template>

          <!-- Instrucciones específicas para añadir panel -->
          <template v-if="active_tool === 'add_panel'">
            <div class="mt-6 p-4 bg-gray-700/30 rounded-xl border border-gray-600/20 text-sm flex items-start">
              <i data-lucide="info" class="w-5 h-5 text-green-400 mr-3 flex-shrink-0 mt-0.5"></i>
              <span class="text-gray-300" v-html="get_t('panel.creation_instructions')">
              </span>
            </div>
          </template>

        </div>
      </div>

      <!-- Panel de edición de texto para globos -->
      <div
        v-if="active_subtool === 'text' && text_editing.active && (selected_object_is_balloon || selected_object_is_standalone_text)"
        class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('text_edit_panel')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-rose-800/20 hover:to-pink-800/20 panel_header transition-all duration-200">
          <div class="flex items-center gap-2">
            <i data-lucide="type" class="w-5 h-5 text-rose-400 mr-3"></i>
            <h3 class="section_title text-rose-200 font-semibold">{{ get_t('text.text_editor') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('text_edit_panel')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-rose-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('text_edit_panel')}" data-panel-id="text_edit_panel" v-lucide>
          <!-- Contenido del texto -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm mb-2 font-medium text-gray-200">{{ get_t('text.text_label') }}:</label>
            <textarea v-model="text_editing.text"
              class="w-full h-32 p-3 bg-gray-800/50 border border-gray-600/30 rounded-lg text-white resize-none focus:border-rose-500/50 focus:ring-1 focus:ring-rose-500/20 transition-all duration-200"
              :placeholder="get_t('text.placeholder')" @input="update_text_content()"
              @blur="push_to_history('update_text_content')"></textarea>
          </div>

          <!-- Format -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm mb-3 font-medium text-gray-200">{{ get_t('text.format') }}:</label>
            <div class="flex justify-between w-full">
              <!-- Grupo de alineación (izquierda) -->
              <div class="flex rounded-md overflow-hidden bg-gray-700 border border-gray-600">
                <button @click="text_editing.align = 'left'; update_text_align();"
                  class="px-2 py-1 flex items-center justify-center"
                  :class="{'bg-rose-700': text_editing.align === 'left', 'hover:bg-gray-600': text_editing.align !== 'left'}"
                  :title="get_t('text.align_left')">
                  <i data-lucide="align-left" class="w-4 h-4"></i>
                </button>
                <button @click="text_editing.align = 'center'; update_text_align();"
                  class="px-2 py-1 flex items-center justify-center"
                  :class="{'bg-rose-700': text_editing.align === 'center', 'hover:bg-gray-600': text_editing.align !== 'center'}"
                  :title="get_t('text.align_center')">
                  <i data-lucide="align-center" class="w-4 h-4"></i>
                </button>
                <button @click="text_editing.align = 'right'; update_text_align();"
                  class="px-2 py-1 flex items-center justify-center"
                  :class="{'bg-rose-700': text_editing.align === 'right', 'hover:bg-gray-600': text_editing.align !== 'right'}"
                  :title="get_t('text.align_right')">
                  <i data-lucide="align-right" class="w-4 h-4"></i>
                </button>
              </div>

              <!-- Grupo de estilo (derecha) -->
              <div class="flex rounded-md overflow-hidden bg-gray-700 border border-gray-600">
                <button @click="toggle_text_style('bold')" class="px-2 py-1 flex items-center justify-center"
                  :class="{'bg-rose-700': text_editing.is_bold, 'hover:bg-gray-600': !text_editing.is_bold}"
                  :title="get_t('text.bold')">
                  <i data-lucide="bold" class="w-4 h-4"></i>
                </button>
                <button @click="toggle_text_style('italic')" class="px-2 py-1 flex items-center justify-center"
                  :class="{'bg-rose-700': text_editing.is_italic, 'hover:bg-gray-600': !text_editing.is_italic}"
                  :title="get_t('text.italic')">
                  <i data-lucide="italic" class="w-4 h-4"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Fuente y tamaño -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between items-end gap-3">
              <div class="flex-1">
                <label class="block text-sm mb-2 font-medium text-gray-200">{{ get_t('text.font_family') }}:</label>
                <select v-model="text_editing.font_family"
                  class="w-full p-2 bg-gray-800/50 border border-gray-600/30 rounded-lg text-white font_select focus:border-rose-500/50 focus:ring-1 focus:ring-rose-500/20 transition-all duration-200"
                  @change="update_text_font()">
                  <!-- Extended Support (Latin + Spanish) -->
                  <optgroup :label="get_t('text.extended_support')">
                    <option value="New Wild Words, Arial, sans-serif"
                      style="font-family: 'New Wild Words'; font-size: 16px;" selected>New Wild Words</option>
                    <option value="Anime Ace, Arial, sans-serif" style="font-family: 'Anime Ace';">Anime Ace</option>
                    <option value="Anime Ace 3, Arial, sans-serif" style="font-family: 'Anime Ace 3';">Anime Ace 3
                    </option>
                    <option value="Ames, Arial, sans-serif" style="font-family: 'Ames';">Ames</option>
                    <option value="Buddy Champion, Arial, sans-serif" style="font-family: 'Buddy Champion';">Buddy
                      Champion</option>
                    <option value="Buddy Champion 3D, Arial, sans-serif" style="font-family: 'Buddy Champion 3D';">Buddy
                      Champion 3D</option>
                    <option value="Buddy Champion Condensed, Arial, sans-serif"
                      style="font-family: 'Buddy Champion Condensed';">Buddy Champion Condensed</option>
                    <option value="Buddy Champion Expanded, Arial, sans-serif"
                      style="font-family: 'Buddy Champion Expanded';">Buddy Champion Expanded</option>
                    <option value="Buddy Champion Left, Arial, sans-serif" style="font-family: 'Buddy Champion Left';">
                      Buddy Champion Left</option>
                    <option value="Buddy Champion Rotate, Arial, sans-serif"
                      style="font-family: 'Buddy Champion Rotate';">Buddy Champion Rotate</option>
                    <option value="Buddy Champion Rotal, Arial, sans-serif"
                      style="font-family: 'Buddy Champion Rotal';">Buddy Champion Rotal</option>
                    <option value="CC Astrocity, Impact, sans-serif" style="font-family: 'CC Astrocity';">CC Astrocity
                    </option>
                    <option value="Joe Mad, Arial, sans-serif" style="font-family: 'Joe Mad';">Joe Mad</option>
                    <option value="SF Wonder Comic Inline, Arial, sans-serif"
                      style="font-family: 'SF Wonder Comic Inline';">SF Wonder Comic Inline</option>
                    <option value="SF Wonder Comic Inline2, Arial, sans-serif"
                      style="font-family: 'SF Wonder Comic Inline2';">SF Wonder Comic Inline 2</option>
                    <option value="SF Wonder Comic, Arial, sans-serif" style="font-family: 'SF Wonder Comic';">SF Wonder
                      Comic</option>
                    <option value="SF Wonder Comic Blotch, Arial, sans-serif"
                      style="font-family: 'SF Wonder Comic Blotch';">SF Wonder Comic Blotch</option>
                    <option value="Kalam, cursive" style="font-family: 'Kalam';">Kalam</option>
                  </optgroup>

                  <!-- Basic Support (English only) -->
                  <optgroup :label="get_t('text.basic_support')">
                    <option value="Wild Words, Arial, sans-serif" style="font-family: 'Wild Words';">Wild Words</option>
                    <option value="Clementine, Arial, sans-serif" style="font-family: 'Clementine';">Clementine</option>
                  </optgroup>

                  <!-- Japanese Fonts -->
                  <optgroup :label="get_t('text.japanese')">
                    <option value="GenEiAntique, sans-serif" style="font-family: 'GenEiAntique';">GenEi Antique</option>
                    <option value="GenEiAntiqueP, sans-serif" style="font-family: 'GenEiAntiqueP';">GenEi Antique P
                    </option>
                    <option value="GenEiKoburi, sans-serif" style="font-family: 'GenEiKoburi';">GenEi Koburi</option>
                    <option value="GenEiMGothic, sans-serif" style="font-family: 'GenEiMGothic';">GenEi MGothic</option>
                  </optgroup>

                  <!-- Chinese Fonts -->
                  <optgroup :label="get_t('text.chinese')">
                    <option value="Yozai, Arial, sans-serif" style="font-family: 'Yozai';">Yozai</option>
                  </optgroup>

                  <!-- Korean Fonts -->
                  <optgroup :label="get_t('text.korean')">
                    <option value="KakaoBigSans, sans-serif" style="font-family: 'KakaoBigSans';">Kakao Big</option>
                    <option value="KakaoSmallSans, sans-serif" style="font-family: 'KakaoSmallSans';">Kakao Small
                    </option>
                    <option value="SinchonRhapsody, sans-serif" style="font-family: 'SinchonRhapsody';">Sinchon Rhapsody
                    </option>
                    <option value="EunglwolYakdahyun, sans-serif" style="font-family: 'EunglwolYakdahyun';">Eunglwol
                      Yakdahyun</option>
                  </optgroup>

                  <!-- System Fonts -->
                  <optgroup :label="get_t('text.system_fonts')">
                    <option value="Comic Sans MS, cursive" style="font-family: 'Comic Sans MS';">Comic Sans MS</option>
                    <option value="Arial, sans-serif" style="font-family: Arial;">Arial</option>
                    <option value="Impact, sans-serif" style="font-family: Impact;">Impact</option>
                    <option value="Times New Roman, serif" style="font-family: 'Times New Roman';">Times New Roman
                    </option>
                    <option value="Courier New, monospace" style="font-family: 'Courier New';">Courier</option>
                    <option value="Verdana, sans-serif" style="font-family: Verdana;">Verdana</option>
                  </optgroup>
                </select>
              </div>

              <div class="w-20">
                <label class="block text-sm mb-2 font-medium text-gray-200">{{ get_t('text.size') }}:</label>
                <input type="number" v-model="text_editing.font_size" min="8" max="999"
                  class="w-full py-1.5 px-2 bg-gray-800/50 border border-gray-600/30 rounded-lg text-white text-center focus:border-rose-500/50 focus:ring-1 focus:ring-rose-500/20 transition-all duration-200"
                  @input="update_text_font()" @click="$event.target.select()">
              </div>
            </div>
          </div>

          <!-- Colores de texto y outline -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <h4 class="text-sm font-medium text-gray-200 mb-4">{{ get_t('text.colors') }}</h4>
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-xs mb-2 text-gray-400">{{ get_t('text.text_color') }}</label>
                <color-picker-wrapper :model-value="text_editing.text_color"
                  @update:model-value="text_editing.text_color = $event; update_text_color()"
                  @change="push_to_history('update_text_color')" :for-fill="false" class="w-full h-10" />
              </div>

              <div>
                <label class="block text-xs mb-2 text-gray-400">{{ get_t('text.text_outline') }}</label>
                <color-picker-wrapper :model-value="text_editing.text_stroke"
                  @update:model-value="text_editing.text_stroke = $event; update_text_outline()"
                  @change="push_to_history('update_text_outline')" :for-fill="false" class="w-full h-10" />
              </div>
            </div>
            <!-- Outline Width -->
            <div class="mb-4">
              <div class="flex justify-between mb-2 items-center">
                <label class="text-sm font-medium text-gray-200">{{ get_t('text.outline_width') }}:</label>
                <span class="text-sm font-semibold text-rose-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{
                  text_editing.text_stroke_width }}px</span>
              </div>
              <input type="range" v-model.number="text_editing.text_stroke_width" min="0" max="5" step="0.1"
                class="w-full accent-rose-500" @input="update_text_outline()"
                @change="push_to_history('update_text_outline_width')">
            </div>
          </div>

          <!-- Line Height -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="flex justify-between mb-2 items-center">
              <label class="text-sm font-medium text-gray-200">{{ get_t('text.line_height') }}:</label>
              <span class="text-sm font-semibold text-rose-300 bg-gray-800/50 px-2 py-1 rounded-lg">{{
                text_editing.line_height }}</span>
            </div>
            <input type="range" v-model.number="text_editing.line_height" min="0.8" max="3.0" step="0.1"
              class="w-full accent-rose-500" @input="update_text_line_height()"
              @change="push_to_history('update_text_line_height')">
          </div>




          <!-- Text Position -->
          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20"
            v-if="!selected_object_is_standalone_text">
            <div class="r">
              <label class="block text-sm mb-3 font-medium text-gray-200">{{ get_t('text.text_position') }}:</label>
              <div class="flex gap-3 mb-3">
                <button v-if="text_editing.active && selected_object_is_balloon" @click="reset_text_position"
                  class="flex-1 px-2 py-2 rounded-lg bg-rose-800/50 hover:bg-rose-700/50 text-rose-200 hover:text-white text-xs flex items-center justify-center font-medium border border-rose-600/50 hover:border-rose-500 transition-all duration-200"
                  :title="get_t('text.reset_text_position_to_default')">
                  <i data-lucide="rotate-ccw" class="w-4 h-4 mr-1"></i>
                  <span class="whitespace-nowrap">{{ get_t('text.reset') }}</span>
                </button>

                <button v-if="text_editing.active && selected_object_is_balloon" @click="enter_text_adjust_mode"
                  :class="['flex-1 px-2 py-2 rounded-lg text-xs flex items-center justify-center font-medium transition-all duration-200', text_editing.adjust_mode ? 'bg-rose-600 text-white hover:bg-rose-500 border border-rose-500' : 'bg-rose-800/50 hover:bg-rose-700/50 text-rose-200 hover:text-white border border-rose-600/50 hover:border-rose-500']"
                  :title="text_editing.adjust_mode ? get_t('text.finish_adjusting_text_box') : get_t('text.adjust_text_box_position_size')">
                  <i data-lucide="move" class="w-4 h-4 mr-1"></i>
                  <span class="whitespace-nowrap">{{ get_t('text.adjust_text') }}</span>
                </button>
              </div>
            </div>
            <div class="text-xs text-gray-400 mt-1 bg-gray-800/30 p-2 rounded-lg" v-if="!text_editing.adjust_mode"
              v-html="get_t('text.adjust_instructions')">
            </div>
            <div class="text-xs text-gray-400 mt-1 bg-gray-800/30 p-2 rounded-lg" v-if="text_editing.adjust_mode"
              v-html="get_t('text.adjust_mode_instructions')">
            </div>
          </div>

          <!-- Botón para cerrar el modo edición -->
          <div class="flex justify-center">
            <button @click="cancel_balloon_text_editing()"
              class="px-4 py-2 bg-rose-600 hover:bg-rose-500 text-white rounded-lg w-full flex items-center justify-center text-sm font-medium transition-all duration-200 border border-rose-500/50">
              <i data-lucide="x" class="w-4 h-4 mr-2"></i>
              {{ get_t('actions.close') }}
            </button>
          </div>





        </div>
      </div>

      <!-- Balloon edit mode -->
      <div v-if="balloon_edit_mode_active" class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('node_editor_panel')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-blue-800/20 hover:to-indigo-800/20 panel_header transition-all duration-200">
          <div class="flex items-center gap-2">
            <i data-lucide="edit-3" class="w-5 h-5 text-blue-400 mr-3"></i>
            <h3 class="section_title text-blue-200 font-semibold">{{ get_t('balloons.node_editor') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('node_editor_panel')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-blue-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-blue-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content" :class="{'open': !is_panel_collapsed('node_editor_panel')}"
          data-panel-id="node_editor_panel" v-lucide>
          <!-- Controls help section -->
          <div class="mb-4 p-3 bg-gray-700 rounded-md text-sm">
            <h4 class="font-medium mb-2">{{ get_t('balloons.controls') }}:</h4>
            <ul class="space-y-1 text-gray-300">
              <li class="flex items-center">
                <span class="text-rose-400 mr-1">●</span> {{ get_t('balloons.smooth_node') }}
              </li>
              <li class="flex items-center">
                <span class="text-orange-400 mr-1">●</span> {{ get_t('balloons.broken_tangency') }}
              </li>
              <li class="flex items-center">
                <span class="text-red-400 mr-1">●</span> {{ get_t('balloons.corner_node') }}
              </li>
              <li class="mt-1">{{ get_t('balloons.ctrl_click_add_remove') }}</li>
              <li>{{ get_t('balloons.right_click_change_type') }}</li>
              <li>{{ get_t('balloons.alt_drag_handle') }}</li>
            </ul>
          </div>

          <!-- Node type buttons -->
          <div class="mb-4">
            <label class="block text-sm mb-2">{{ get_t('balloons.node_type') }}:</label>
            <div class="flex gap-2">
              <button @click="set_selected_node_type('smooth')"
                class="flex-1 p-2 rounded-md flex items-center justify-center"
                :class="{'bg-rose-900': selected_node_index !== null && editing_balloon && editing_balloon.balloon_points && editing_balloon.balloon_points[selected_node_index] && editing_balloon.balloon_points[selected_node_index].node_type === 'smooth' && !editing_balloon.balloon_points[selected_node_index].tangency_broken, 'bg-gray-700 hover:bg-gray-600': selected_node_index === null || !editing_balloon || !editing_balloon.balloon_points || !editing_balloon.balloon_points[selected_node_index] || editing_balloon.balloon_points[selected_node_index].node_type !== 'smooth' || editing_balloon.balloon_points[selected_node_index].tangency_broken}"
                :disabled="selected_node_index === null">
                <span class="h-3 w-3 rounded-full bg-rose-400 mr-1"></span>
                <span>{{ get_t('balloons.smooth') }}</span>
              </button>

              <button @click="set_selected_node_type('broken_tangency')"
                class="flex-1 p-2 rounded-md flex items-center justify-center"
                :class="{'bg-rose-900': selected_node_index !== null && editing_balloon && editing_balloon.balloon_points && editing_balloon.balloon_points[selected_node_index] && editing_balloon.balloon_points[selected_node_index].node_type === 'smooth' && editing_balloon.balloon_points[selected_node_index].tangency_broken, 'bg-gray-700 hover:bg-gray-600': selected_node_index === null || !editing_balloon || !editing_balloon.balloon_points || !editing_balloon.balloon_points[selected_node_index] || editing_balloon.balloon_points[selected_node_index].node_type !== 'smooth' || !editing_balloon.balloon_points[selected_node_index].tangency_broken}"
                :disabled="selected_node_index === null">
                <span class="h-3 w-3 rounded-full bg-orange-400 mr-1"></span>
                <span>{{ get_t('balloons.broken') }}</span>
              </button>

              <button @click="set_selected_node_type('corner')"
                class="flex-1 p-2 rounded-md flex items-center justify-center"
                :class="{'bg-rose-900': selected_node_index !== null && editing_balloon && editing_balloon.balloon_points && editing_balloon.balloon_points[selected_node_index] && editing_balloon.balloon_points[selected_node_index].node_type === 'corner', 'bg-gray-700 hover:bg-gray-600': selected_node_index === null || !editing_balloon || !editing_balloon.balloon_points || !editing_balloon.balloon_points[selected_node_index] || editing_balloon.balloon_points[selected_node_index].node_type !== 'corner'}"
                :disabled="selected_node_index === null">
                <span class="h-3 w-3 rounded-full bg-red-400 mr-1"></span>
                <span>{{ get_t('balloons.corner') }}</span>
              </button>
            </div>
          </div>

          <!-- Exit node editor button -->
          <button @click="exit_balloon_edit_mode()"
            class="w-full p-2 bg-red-900 hover:bg-red-800 rounded flex items-center justify-center gap-2"
            :title="get_t('balloons.exit_node_editor')">
            <i data-lucide="x" class="w-4 h-4"></i>
            <span class="text-sm">{{ get_t('balloons.exit_node_editor') }}</span>
          </button>
        </div>
      </div>

      <!-- Tail Tool -->
      <div v-if="active_tool === 'add_pointer'" class="border-b border-gray-600/30">
        <div @click="toggle_panel_collapse('pointer_panel')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-orange-800/20 hover:to-amber-800/20 panel_header transition-all duration-200">
          <div class="flex items-center gap-2">
            <i data-lucide="mouse-pointer" class="w-5 h-5 text-orange-400 mr-3"></i>
            <h3 class="section_title text-orange-200 font-semibold">{{ get_t('properties.pointer_properties') }}</h3>
          </div>
          <span>
            <span v-if="is_panel_collapsed('pointer_panel')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-orange-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-orange-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>

        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('pointer_panel')}" data-panel-id="pointer_panel" v-lucide>

          <div class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <div class="mt-1 mb-4 p-3 bg-orange-900/20 rounded-lg text-sm flex items-start border border-orange-700/30">
              <i data-lucide="info" class="w-4 h-4 text-orange-400 mr-2 flex-shrink-0 mt-0.5"></i>
              <span class="text-gray-300"
                v-html="get_t('balloons.pointer_instructions_1') + '<br>• ' + get_t('balloons.pointer_instructions_2') + '<br>• ' + get_t('balloons.pointer_instructions_3')">
              </span>
            </div>

            <!-- Pointer Type Selection -->
            <div class="mb-3">
              <label class="block text-sm mb-3 font-medium text-gray-200">{{ get_t('balloons.pointer_type') }}:</label>
              <div class="grid grid-cols-2 gap-2">
                <button @click="active_pointer_type = 'triangle'"
                  class="p-3 rounded-lg flex items-center justify-center transition-all duration-200 border"
                  :class="{'bg-orange-600 border-orange-500': active_pointer_type === 'triangle', 'bg-gray-800/50 hover:bg-gray-700/50 border-gray-600/30': active_pointer_type !== 'triangle'}"
                  :title="get_t('balloons.triangle_pointer')">
                  <i data-lucide="triangle" class="w-4 h-4"></i>
                  <span class="text-xs ml-1 font-medium">{{ get_t('balloons.standard') }}</span>
                </button>
                <button @click="active_pointer_type = 'curved'"
                  class="p-3 rounded-lg flex items-center justify-center transition-all duration-200 border"
                  :class="{'bg-orange-600 border-orange-500': active_pointer_type === 'curved', 'bg-gray-800/50 hover:bg-gray-700/50 border-gray-600/30': active_pointer_type !== 'curved'}"
                  :title="get_t('balloons.curved_pointer')">
                  <i data-lucide="pencil" class="w-4 h-4"></i>
                  <span class="text-xs ml-1 font-medium">{{ get_t('balloons.curved') }}</span>
                </button>
              </div>
              <div class="grid grid-cols-2 gap-2 mt-2">
                <button @click="active_pointer_type = 'thought'"
                  class="p-3 rounded-lg flex items-center justify-center transition-all duration-200 border"
                  :class="{'bg-orange-600 border-orange-500': active_pointer_type === 'thought', 'bg-gray-800/50 hover:bg-gray-700/50 border-gray-600/30': active_pointer_type !== 'thought'}"
                  :title="get_t('balloons.thought_bubble')">
                  <i data-lucide="cloud" class="w-4 h-4"></i>
                  <span class="text-xs ml-1 font-medium">{{ get_t('balloons.thought') }}</span>
                </button>
                <button @click="active_pointer_type = 'zigzag'"
                  class="p-3 rounded-lg flex items-center justify-center transition-all duration-200 border"
                  :class="{'bg-orange-600 border-orange-500': active_pointer_type === 'zigzag', 'bg-gray-800/50 hover:bg-gray-700/50 border-gray-600/30': active_pointer_type !== 'zigzag'}"
                  :title="get_t('balloons.zigzag_pointer')">
                  <i data-lucide="zap" class="w-4 h-4"></i>
                  <span class="text-xs ml-1 font-medium">{{ get_t('balloons.zigzag') }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Triangle Pointer Width -->
          <div v-if="active_pointer_type !== 'thought'"
            class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">
            <label class="block text-sm mb-3 font-medium text-gray-200">{{ get_t('balloons.pointer_width') }}:</label>
            <div class="flex items-center gap-3">
              <input type="range" v-model.number="pointer_width" min="3" max="30" step="1"
                class="flex-1 accent-orange-500">
              <input type="number" v-model.number="pointer_width" min="3" max="30"
                class="w-16 px-2 py-1 bg-gray-800/50 border border-gray-600/30 rounded-lg text-orange-300 text-center text-sm focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/20 transition-all duration-200">
            </div>
          </div>

          <!-- Curved Pointer Specific Options -->
          <div v-if="active_pointer_type === 'curved'"
            class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">

            <!-- Auto Edit Mode Checkbox -->
            <div class="flex items-center gap-3 mb-3 p-3 bg-gray-800/30 rounded-lg border border-gray-600/20">
              <input type="checkbox" id="curved_auto_edit_mode" v-model="curved_auto_edit_mode"
                class="w-4 h-4 text-orange-500 accent-orange-500 cursor-pointer flex-shrink-0">
              <label for="curved_auto_edit_mode" class="text-sm text-gray-300 cursor-pointer font-medium">
                {{ get_t('balloons.auto_enter_edit_mode') }}
              </label>
            </div>

            <!-- Curve Reflection Checkbox -->
            <div class="flex items-center gap-3 mb-3 p-3 bg-gray-800/30 rounded-lg border border-gray-600/20">
              <input type="checkbox" id="curved_reflect_mode" v-model="curved_reflect_mode"
                class="w-4 h-4 text-orange-500 accent-orange-500 cursor-pointer flex-shrink-0">
              <label for="curved_reflect_mode" class="text-sm text-gray-300 cursor-pointer font-medium">
                {{ get_t('balloons.flip_curvature') }}
              </label>
            </div>

            <!-- Info Box -->
            <div class="bg-orange-900/20 border border-orange-700/30 rounded-lg p-3">
              <div class="flex items-start gap-2">
                <i data-lucide="info" class="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0"></i>
                <div class="text-xs text-gray-200"
                  v-html="'<strong>' + get_t('balloons.tip') + ':</strong> ' + get_t('balloons.move_red_tip_node')">
                </div>
              </div>
            </div>
          </div>

          <!-- Zigzag Pointer Specific Options -->
          <div v-if="active_pointer_type === 'zigzag'"
            class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">

            <!-- Zigzag Reflection Checkbox -->
            <div class="flex items-center gap-3 mb-3 p-3 bg-gray-800/30 rounded-lg border border-gray-600/20">
              <input type="checkbox" id="zigzag_reflect_mode" v-model="zigzag_reflect_mode"
                class="w-4 h-4 text-orange-500 accent-orange-500 cursor-pointer flex-shrink-0">
              <label for="zigzag_reflect_mode" class="text-sm text-gray-300 cursor-pointer font-medium">
                {{ get_t('balloons.flip_zigzag') }}
              </label>
            </div>

            <!-- Info Box -->
            <div class="bg-orange-900/20 border border-orange-700/30 rounded-lg p-3">
              <div class="flex items-start gap-2">
                <i data-lucide="info" class="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0"></i>
                <div class="text-xs text-gray-200"
                  v-html="'<strong>' + get_t('balloons.tip') + ':</strong> ' + get_t('balloons.zigzag_tip')">
                </div>
              </div>
            </div>
          </div>

          <!-- Thought Pointer Specific Options -->
          <div v-if="active_pointer_type === 'thought'"
            class="mb-6 bg-gray-700/30 rounded-xl p-4 border border-gray-600/20">

            <!-- Number of Bubbles -->
            <div class="mb-4">
              <label class="block text-sm mb-2 font-medium text-gray-200">{{ get_t('balloons.bubble_count') }}:</label>
              <div class="flex items-center gap-3">
                <input type="range" v-model.number="thought_bubble_count" min="3" max="8" step="1"
                  class="flex-1 accent-orange-500">
                <input type="number" v-model.number="thought_bubble_count" min="3" max="8"
                  class="w-16 px-2 py-1 bg-gray-800/50 border border-gray-600/30 rounded-lg text-orange-300 text-center text-sm focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/20 transition-all duration-200">
              </div>
            </div>

            <!-- Bubble Size -->
            <div class="mb-4">
              <label class="block text-sm mb-2 font-medium text-gray-200">{{ get_t('balloons.bubble_size') }}:</label>
              <div class="flex items-center gap-3">
                <input type="range" v-model.number="thought_bubble_size" min="8" max="30" step="1"
                  class="flex-1 accent-orange-500">
                <input type="number" v-model.number="thought_bubble_size" min="8" max="30"
                  class="w-16 px-2 py-1 bg-gray-800/50 border border-gray-600/30 rounded-lg text-orange-300 text-center text-sm focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/20 transition-all duration-200">
              </div>
            </div>

            <!-- Info Box -->
            <div class="bg-orange-900/20 border border-orange-700/30 rounded-lg p-3 mt-4">
              <div class="flex items-start gap-2">
                <i data-lucide="info" class="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0"></i>
                <div class="text-xs text-gray-200"
                  v-html="'<strong>' + get_t('balloons.tip') + ':</strong> ' + get_t('balloons.thought_tip')">
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <!-- Layers panel implementation (Collapsible) -->
      <div class="mt-auto border-t border-gray-600/30">
        <div @click="toggle_panel_collapse('layers')"
          class="p-4 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-emerald-800/20 hover:to-green-800/20 panel_header transition-all duration-200 bg-gradient-to-r from-gray-800/50 to-gray-700/30">
          <div class="flex items-center w-full pr-1">
            <i data-lucide="layers" class="w-5 h-5 text-emerald-400 mr-3"></i>
            <h3 class="section_title text-emerald-200 font-semibold mr-auto">
              {{ selected_panel && selected_panel.getAttr('is_global') ? get_t('layers.global_layers') :
              get_t('layers.layers') }}
            </h3>

            <!-- Indicator for selected panel type -->
            <div class="px-2 py-1 rounded-md text-xs font-medium flex items-center border" :class="selected_panel && selected_panel.getAttr('is_global') ? 
              'bg-gray-700/50 text-gray-300 border-gray-600/30' : 
              'bg-rose-800/30 text-rose-300 border-rose-600/30'">
              <i :data-lucide="selected_panel && selected_panel.getAttr('is_global') ? 'layers' : 'grid'"
                class="w-3.5 h-3.5 mr-1"></i>
              <span class="whitespace-nowrap">{{ selected_panel && selected_panel.getAttr('is_global') ?
                get_t('layers.global_panel') : get_t('layers.panel') + ' ' + (panels.indexOf(selected_panel)) }}</span>
            </div>
          </div>
          <span>
            <span v-if="is_panel_collapsed('layers')">
              <i data-lucide="chevron-down" class="w-5 h-5 text-emerald-300 transition-transform duration-200"></i>
            </span>
            <span v-else>
              <i data-lucide="chevron-up" class="w-5 h-5 text-emerald-300 transition-transform duration-200"></i>
            </span>
          </span>
        </div>
        <div class="p-4 pt-2 panel_content bg-gradient-to-b from-gray-800/20 to-transparent"
          :class="{'open': !is_panel_collapsed('layers')}" data-panel-id="layers">

          <!-- Layer blend and opacity controls -->
          <div class="mb-4 bg-gray-700/30 rounded-lg p-3 border border-gray-600/20">
            <div class="grid grid-cols-2 gap-3">
              <!-- Blend mode -->
              <div>
                <select
                  class="bg-gray-800 text-white text-xs rounded-md px-2 py-2 border border-gray-600 w-full focus:border-emerald-500 transition-colors"
                  v-model="selected_blend_mode" @change="update_blend_mode"
                  :disabled="!selected_layer || selected_layer.locked"
                  :class="{'opacity-50': !selected_layer || selected_layer.locked}">
                  <option value="normal">{{ get_t('layers.normal') }}</option>
                  <option value="multiply">{{ get_t('layers.multiply') }}</option>
                  <option value="screen">{{ get_t('layers.screen') }}</option>
                  <option value="overlay">{{ get_t('layers.overlay') }}</option>
                  <option value="darken">{{ get_t('layers.darken') }}</option>
                  <option value="lighten">{{ get_t('layers.lighten') }}</option>
                </select>
              </div>

              <!-- Opacity -->
              <div class="relative">
                <div class="flex items-center gap-1">
                  <input type="text"
                    class="bg-gray-800 text-white text-xs rounded-md px-2 py-2 border border-gray-600 w-full text-center focus:border-emerald-500 transition-colors"
                    v-model="selected_opacity_text" @input="value = value.replace(/[^0-9%]/g, '')"
                    @change="update_opacity_from_text" @blur="validate_opacity_text"
                    :disabled="!selected_layer || selected_layer.locked"
                    :class="{'opacity-50': !selected_layer || selected_layer.locked}" placeholder="100%">

                  <button class="p-1.5 hover:bg-gray-600 rounded-md transition-colors" @click="toggle_opacity_slider"
                    :disabled="!selected_layer || selected_layer.locked"
                    :class="{'opacity-50': !selected_layer || selected_layer.locked}">
                    <i data-lucide="chevron-down" class="w-3 h-3"></i>
                  </button>
                </div>

                <!-- Dropdown slider for opacity -->
                <div v-if="show_opacity_slider"
                  class="absolute top-full right-0 mt-1 bg-gray-800 p-3 rounded-lg shadow-lg border border-gray-700 z-10 w-48"
                  v-click_away="hide_opacity_slider" @click.stop>
                  <input type="range" class="w-full h-4 accent-emerald-500" min="0" max="100" step="1"
                    v-model="selected_opacity" @input="update_opacity" @change="push_to_history('change_opacity')"
                    :disabled="selected_layer && selected_layer.locked">
                  <div class="flex justify-between mt-1 text-xs text-gray-400">
                    <span>0%</span>
                    <span>50%</span>
                    <span>100%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Layers content - always displayed -->
          <div
            class="bg-gray-700/50 rounded-lg p-2 max-h-90 overflow-y-auto relative scrollbar mk_layer_block border border-gray-600/30"
            @dragover.prevent @drop.prevent="drop_layer_on_container($event)">
            <!-- When no layers are available -->
            <div v-if="panel_layers.length === 0" class="text-sm text-gray-400 flex items-center justify-center h-20">
              {{ get_t('layers.no_layers') }}
            </div>

            <!-- Layer items list with compact design -->
            <div v-for="(layer, index) in panel_layers" :key="layer.id" @click="select_layer(layer)"
              class="flex items-center p-2 rounded-lg mb-1.5 cursor-pointer group transition-all duration-200" :class="{
              'bg-emerald-800/30 border border-emerald-600/50': layer.id === selected_layer?.id,
              'bg-gray-600/30 hover:bg-gray-600/50 border border-transparent': layer.id !== selected_layer?.id
            }" :data-layer-id="layer.id" draggable="true" @dragstart="start_drag_layer(layer, $event)"
              @dragover.prevent="drag_layer_over(layer, $event)" @dragenter.prevent
              @drop.prevent="drop_layer(layer, $event)">

              <!-- Visibility toggle on the left -->
              <div class="flex-shrink-0 pr-2">
                <button class="p-1 rounded-md hover:bg-gray-500/50 transition-colors"
                  :title="get_t('layers.toggle_visibility')" @click.stop="toggle_layer_visibility(layer)">
                  <div v-show="layer.visible">
                    <i data-lucide="eye" class="w-3.5 h-3.5 text-emerald-400"></i>
                  </div>
                  <div v-show="!layer.visible">
                    <i data-lucide="eye-off" class="w-3.5 h-3.5 text-gray-500"></i>
                  </div>
                </button>
              </div>

              <!-- Compact thumbnail preview -->
              <div
                class="w-8 h-8 mr-2.5 bg-gray-800 border border-gray-600/50 rounded flex-shrink-0 overflow-hidden flex items-center justify-center">
                <img :src="layer.preview_url" class="max-w-full max-h-full object-contain" v-if="layer.preview_url">
                <i data-lucide="image" class="w-4 h-4 text-gray-500" v-else></i>
              </div>

              <!-- Layer name -->
              <div class="flex-1 text-sm truncate mr-2" @dblclick.stop="edit_layer_name(layer)" @mousedown.stop
                @mouseup.stop :title="get_t('layers.double_click_to_rename')" :class="{
                'text-emerald-200': layer.id === selected_layer?.id,
                'text-gray-200': layer.id !== selected_layer?.id
              }">
                {{ layer.name }}
              </div>

              <!-- Lock/unlock and delete buttons -->
              <div class="flex-shrink-0 flex space-x-0.5 opacity-70 group-hover:opacity-100 transition-opacity">
                <!-- Lock/unlock button -->
                <button class="p-1 rounded-md hover:bg-gray-500/50 transition-colors"
                  :title="get_t('layers.lock_unlock_layer')" @click.stop="toggle_layer_lock(layer)">
                  <div v-show="layer.locked">
                    <i data-lucide="lock" class="w-3.5 h-3.5 text-amber-400"></i>
                  </div>
                  <div v-show="!layer.locked">
                    <i data-lucide="unlock" class="w-3.5 h-3.5 text-gray-400"></i>
                  </div>
                </button>

                <!-- Delete button -->
                <button class="p-1 rounded-md hover:bg-red-600/50 transition-colors"
                  :title="get_t('layers.delete_layer')" @click.stop="delete_layer(layer)">
                  <i data-lucide="trash-2" class="w-3.5 h-3.5 text-rose-400 hover:text-rose-300"></i>
                </button>
              </div>
            </div>

            <!-- Drop indicator -->
            <div ref="layer_drop_indicator" id="layer_drop_indicator"
              class="h-0.5 bg-rose-500 w-full hidden transition-all duration-100 z-10"></div>
          </div>

          <!-- Bottom toolbar for adding elements -->
          <div v-show="!show_welcome_screen" class="mt-3 space-y-2">
            <!-- Global layers button -->
            <button v-if="selected_panel && !selected_panel.getAttr('is_global')" @click="select_global_layers()"
              class="w-full p-2.5 rounded-lg border transition-all duration-200 flex items-center justify-center bg-rose-800/30 border-rose-600/50 text-rose-300 hover:bg-rose-700/30"
              :title="get_t('layers.select_panel_to_add_elements')">
              <i data-lucide="layers" class="w-4 h-4 mr-2"></i>
              <span class="font-medium text-sm whitespace-nowrap">
                {{ get_t('layers.global_layers') }}
              </span>
            </button>

            <!-- Tools grid -->
            <div class="bg-gray-700/50 rounded-lg p-2 border border-gray-600/30">
              <div class="flex justify-center gap-2">
                <!-- Divider Panel button -->
                <button @click="toggle_divider()"
                  class="p-2.5 hover:bg-gray-600/50 rounded-md flex items-center justify-center transition-colors"
                  :class="{
                  'bg-rose-800/50': active_subtool === 'divider',
                  'text-gray-500': !selected_panel || selected_panel.getAttr('is_global') === true,
                  'text-gray-200': selected_panel && selected_panel.getAttr('is_global') !== true
                }" :title="get_t('layers.divide_panel')"
                  :disabled="!selected_panel || selected_panel.getAttr('is_global') === true">
                  <i data-lucide="scissors" class="w-4 h-4"></i>
                </button>

                <!-- Gallery button -->
                <button @click="show_gallery()"
                  class="p-2.5 hover:bg-gray-600/50 rounded-md flex items-center justify-center transition-colors text-gray-200"
                  :title="get_t('gallery.open_gallery')">
                  <i data-lucide="sparkles" class="w-4 h-4"></i>
                </button>

                <!-- Add Balloon button -->
                <button @click="change_tool('add_balloon')"
                  class="p-2.5 hover:bg-gray-600/50 rounded-md flex items-center justify-center transition-colors"
                  :title="get_t('layers.add_speech_balloon')"
                  :class="{'bg-rose-800/50': active_tool === 'add_balloon'}">
                  <i data-lucide="message-circle" class="w-4 h-4"></i>
                </button>

                <!-- Add Image button -->
                <button @click="load_image_into_panel()"
                  class="p-2.5 hover:bg-gray-600/50 rounded-md flex items-center justify-center transition-colors text-gray-200"
                  :title="get_t('layers.add_image')">
                  <i data-lucide="image-plus" class="w-4 h-4"></i>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>




    </div>

  </div> <!-- End right sidebar container -->

  <!-- AI Generation Panel - Resizable -->
  <div id="ai_generation_panel" v-if="ai_panel_ready"
    class="fixed top-0 h-full bg-gray-900/95 backdrop-blur-sm border-l border-gray-700/50 shadow-2xl z-[100] flex flex-col transition-transform duration-300 ease-in-out"
    :class="ai_generation_active ? 'right-0' : 'right-[-100vw]'" :style="{ width: ai_panel_width + 'px' }">

    <!-- Resize Handle (left edge) -->
    <div
      class="absolute top-0 left-0 w-1 h-full cursor-col-resize bg-transparent hover:bg-purple-500/30 transition-colors duration-200 z-10"
      @mousedown="start_ai_panel_resize" :class="{ 'bg-purple-500/50': ai_panel_resizing }">
    </div>

    <!-- Header with maximize button -->
    <div class="flex items-center justify-between p-2 border-b border-gray-700/50">
      <div class="flex items-center gap-2">
        <i data-lucide="wand-2" class="w-4 h-4 text-purple-400"></i>
        <h2 class="text-sm font-semibold text-white">{{ get_t('ai.generation_panel') }}</h2>
      </div>
      <div class="flex items-center gap-1">
        <!-- Maximize/Restore button -->
        <button @click="toggle_ai_panel_maximize"
          class="p-1 hover:bg-gray-800 rounded-lg transition-colors duration-200 text-gray-400 hover:text-white"
          :title="ai_panel_expanded ? get_t('ai.restore_panel') : get_t('ai.maximize_panel')">
          <i :data-lucide="ai_panel_expanded ? 'minimize-2' : 'maximize-2'" class="w-4 h-4"></i>
        </button>
        <!-- Close button -->
        <button @click="deactivate_ai_generation_mode"
          class="p-1 hover:bg-gray-800 rounded-lg transition-colors duration-200 text-gray-400 hover:text-white">
          <i data-lucide="x" class="w-4 h-4"></i>
        </button>
      </div>
    </div>

    <!-- Model Selection -->
    <div class="w-full p-4 border-b border-gray-700/30" v-show="!show_legacy_models">
      <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.model_selection') }}</h3>
      <div class="flex gap-3 overflow-x-auto pb-2" style="scrollbar-width: thin;">
        <div v-for="variant in model_variants" :key="variant.id" @click="select_variant(variant.id)"
          class="relative group transition-all duration-200 overflow-hidden flex-shrink-0 cursor-pointer" :class="[
            'rounded-lg border-2',
            current_variant === variant.id ? 
              'border-purple-500 bg-purple-500/10' : 
              'border-gray-600 hover:border-gray-500'
          ]" style="width: 95px;">
          <div class="aspect-[2/2.2] bg-gray-800 flex items-center justify-center">
            <img :src="'./img/ai/models2/' + variant.id + '.webp'" :alt="variant.display_name"
              class="w-full h-full object-cover object-top smooth-scaling" loading="lazy">
          </div>
          <div class="p-1">
            <p class="text-[10px] text-center font-medium text-gray-300">{{ variant.display_name }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Model and Style Selection -->
    <div class="w-full p-4 border-b border-gray-700/30" v-show="show_legacy_models">
      <div class="flex gap-6">
        <!-- Model Selection -->
        <div class="flex-shrink-0">
          <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.model_selection') }}</h3>
          <div class="flex gap-3">
            <div v-for="model in available_models" :key="model.name"
              @click="model.enabled ? handle_model_change(model.name) : handle_disabled_model_click(model)"
              class="relative group transition-all duration-200 overflow-hidden flex-shrink-0" :class="[
                'rounded-lg border-2',
                model.enabled ? 'cursor-pointer' : 'cursor-not-allowed opacity-60',
                model.enabled && ai_settings.model === model.name ? 
                  'border-purple-500 bg-purple-500/10' : 
                  model.enabled ? 'border-gray-600 hover:border-gray-500' : 'border-gray-700'
              ]" style="width: 95px;">
              <div class="aspect-[2/2.2] bg-gray-800 flex items-center justify-center">
                <img :src="'./img/ai/models/' + model.id + '.webp'" :alt="model.display_name"
                  :class="model.enabled ? 'w-full h-full object-cover object-top smooth-scaling' : 'w-full h-full object-cover object-top smooth-scaling grayscale'"
                  loading="lazy">
                <!-- Coming Soon Overlay -->
                <div v-if="!model.enabled" class="absolute inset-0 bg-black/70 flex items-center justify-center">
                  <div class="text-center px-1">
                    <div class="text-[9px] text-white font-bold mb-1">{{ get_t('ai.model_coming_soon') }}</div>
                    <div class="text-[7px] text-gray-300">Soon</div>
                  </div>
                </div>
              </div>
              <div class="p-1">
                <p class="text-[10px] text-center font-medium"
                  :class="model.enabled ? 'text-gray-300' : 'text-gray-500'">{{ model.display_name }}</p>
              </div>
              <!-- Info button -->
              <button @click.stop="show_model_info(model.name)"
                class="absolute top-1 right-1 w-5 h-5 bg-gray-700/80 hover:bg-purple-600/80 rounded-full flex items-center justify-center transition-colors duration-200"
                :class="model.enabled ? '' : 'opacity-50'">
                <i data-lucide="help-circle" class="w-3 h-3 text-gray-300 hover:text-white"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Vertical Separator -->
        <div class="border-l border-gray-600"></div>

        <!-- Style Selection -->
        <div class="flex-shrink-0">
          <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.style_selection') }}</h3>
          <div class="flex gap-3">
            <div v-for="style in filtered_styles" :key="style.id" @click="ai_settings.style = style.id"
              class="group cursor-pointer rounded-lg border-2 transition-all duration-200 overflow-hidden w-20" :class="ai_settings.style === style.id ? 
                'border-purple-500 bg-purple-500/10' : 
                'border-gray-600 hover:border-gray-500'">
              <div class="w-full h-24 bg-gray-800 flex items-center justify-center">
                <img
                  :src="(ai_settings.model && ai_settings.model.includes('mikoniji_semi') ? './img/ai/style_niji_' : './img/ai/style_') + style.id + '.webp'"
                  :alt="get_t('ai.' + style.name)" class="w-full h-full object-cover object-top smooth-scaling"
                  loading="lazy">
              </div>
              <div class="p-1">
                <p class="text-xs text-gray-300 text-center font-medium">{{ get_t('ai.' + style.name) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content - Responsive Column Layout -->
    <div class="flex-1 flex overflow-hidden">

      <!-- Column 1: Controls (Fixed max width) -->
      <div class="border-r border-gray-700/30 flex flex-col p-4 space-y-6"
        style="max-width: 400px; min-width: 320px; width: 35%;">

        <!-- Scrollable content area -->
        <div class="flex-1 overflow-y-auto space-y-6">
          <div>
            <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.load_from_metadata') }}</h3>
            <div @drop="handle_ai_metadata_drop" @dragenter="handle_ai_drag_enter" @dragleave="handle_ai_drag_leave"
              @dragover="handle_ai_drag_over" @click="$refs.file_input?.click()"
              class="relative cursor-pointer rounded-lg border-2 border-dashed transition-all duration-200 p-4" :class="drop_zone_active ? 
              'border-purple-500 bg-purple-500/10' : 
              'border-gray-600 hover:border-gray-500'">
              <div class="text-center">
                <i data-lucide="upload" class="w-6 h-6 text-gray-400 mx-auto mb-2"></i>
                <p class="text-sm text-gray-400">{{ get_t('ai.drop_image_here') }}</p>
              </div>
              <input ref="file_input" type="file" accept="image/*" @change="handle_ai_metadata_drop" class="hidden">
            </div>
          </div>



          <!-- Prompt Enhancement Controls -->
          <div>
            <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.prompt_enhancement') }}</h3>
            <div class="space-y-3">
              <!-- Enhanced Prompt and Reinforce Background Toggles -->
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.enhanced_prompt') }}</label>
                  <button @click="ai_settings.use_enhanced_prompt = !ai_settings.use_enhanced_prompt"
                    class="w-full p-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-center gap-2"
                    :class="ai_settings.use_enhanced_prompt ? 
                    'bg-purple-600/20 border-purple-500 text-purple-300' : 
                    'bg-gray-800 border-gray-600 text-gray-400 hover:border-gray-500'">
                    <i :data-lucide="ai_settings.use_enhanced_prompt ? 'zap' : 'zap-off'" class="w-4 h-4"></i>
                    <span class="text-xs">{{ ai_settings.use_enhanced_prompt ? 'On' : 'Off' }}</span>
                  </button>
                </div>

                <div>
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.reinforce_background') }}</label>
                  <button @click="ai_settings.reinforce_background = !ai_settings.reinforce_background"
                    class="w-full p-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-center gap-2"
                    :class="ai_settings.reinforce_background ? 
                    'bg-purple-600/20 border-purple-500 text-purple-300' : 
                    'bg-gray-800 border-gray-600 text-gray-400 hover:border-gray-500'">
                    <i :data-lucide="ai_settings.reinforce_background ? 'image' : 'image'" class="w-4 h-4"></i>
                    <span class="text-xs">{{ ai_settings.reinforce_background ? 'On' : 'Off' }}</span>
                  </button>
                </div>

              </div>

              <!-- Hand Fixer Toggle -->
              <div>
                <div class="flex items-center justify-between mb-2">
                  <label class="block text-xs text-gray-400">{{ get_t('ai.hand_fixer') }}</label>
                  <button @click.stop="show_hand_fixer_warning" class="p-1 rounded hover:bg-gray-700 transition-colors"
                    :title="get_t('ai.hand_fixer_info')">
                    <i data-lucide="alert-triangle" class="w-3.5 h-3.5 text-yellow-500"></i>
                  </button>
                </div>
                <button @click="ai_settings.use_prompt_hand_fixer = !ai_settings.use_prompt_hand_fixer"
                  class="w-full p-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-center gap-2"
                  :class="ai_settings.use_prompt_hand_fixer ? 
                  'bg-yellow-600/20 border-yellow-500 text-yellow-300' : 
                  'bg-gray-800 border-gray-600 text-gray-400 hover:border-gray-500'">
                  <i data-lucide="alert-triangle" class="w-4 h-4"></i>
                  <span class="text-xs">{{ ai_settings.use_prompt_hand_fixer ? 'On' : 'Off' }}</span>
                </button>
              </div>

              <!-- Reinforce Anime Slider -->
              <div>
                <div class="flex justify-between items-center mb-2">
                  <label class="text-xs text-gray-400">{{ get_t('ai.reinforce_anime') }}</label>
                  <span class="text-xs text-purple-400 font-mono">{{ ai_settings.reinforce_anime }}</span>
                </div>
                <input type="range" v-model.number="ai_settings.reinforce_anime" min="0" max="20" step="1"
                  class="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider-purple focus:outline-none"
                  style="outline: none !important;">
              </div>
            </div>
          </div>

          <!-- Positive Prompt -->
          <div>
            <label class="block text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.positive_prompt') }}</label>
            <div class="relative">
              <textarea v-model="ai_prompts.positive"
                class="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 pr-6 text-white text-sm resize-y min-h-[200px] focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
                style="resize: vertical;" :placeholder="sample_prompts.sample_pos_pro"></textarea>
              <!-- Custom resize handle -->
              <div class="absolute bottom-1 right-1 w-4 h-4 pointer-events-none">
                <div class="w-0 h-0 border-l-4 border-l-transparent border-b-4 border-b-purple-500 opacity-60"></div>
              </div>
            </div>
          </div>

          <!-- Negative Prompt System (Redesigned) -->
          <div>
            <label class="block text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.negative_prompt') }}</label>
            <div class="space-y-3">
              <!-- Mikomic Negative Options -->
              <div>
                <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.mikomic_negative') }}</label>
                <div class="grid grid-cols-3 gap-2">
                  <button @click="ai_settings.use_mikomic_negative = 4; handle_negative_prompt_change()"
                    class="px-3 py-2 rounded-md text-xs font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
                    :class="[1,4,5].includes(ai_settings.use_mikomic_negative) ? 
                    'bg-purple-600 text-white' : 
                    'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                    {{ get_t('ai.custom_negative_mode') }}
                  </button>
                  <button @click="ai_settings.use_mikomic_negative = 2; handle_negative_prompt_change()"
                    class="px-3 py-2 rounded-md text-xs font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
                    :class="ai_settings.use_mikomic_negative === 2 ? 
                    'bg-purple-600 text-white' : 
                    'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                    {{ get_t('ai.negative_modes.general') }}
                  </button>
                  <button @click="ai_settings.use_mikomic_negative = 3; handle_negative_prompt_change()"
                    class="px-3 py-2 rounded-md text-xs font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
                    :class="ai_settings.use_mikomic_negative === 3 ? 
                    'bg-purple-600 text-white' : 
                    'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                    {{ get_t('ai.negative_modes.detailed') }}
                  </button>
                </div>
              </div>

              <!-- Custom Negative Prompt (when Custom is selected or append modes) -->
              <div
                v-if="ai_settings.use_mikomic_negative === 1 || ai_settings.use_mikomic_negative === 4 || ai_settings.use_mikomic_negative === 5">
                <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.custom_negative') }}</label>

                <!-- Append Mode Selection (only when custom is active) -->
                <div
                  v-if="ai_settings.use_mikomic_negative === 1 || ai_settings.use_mikomic_negative === 4 || ai_settings.use_mikomic_negative === 5"
                  class="mb-3">
                  <div class="flex items-center space-x-4">
                    <label class="flex items-center">
                      <input type="checkbox" @change="toggle_add_general"
                        :checked="ai_settings.use_mikomic_negative === 4"
                        class="w-4 h-4 text-purple-600 bg-gray-800 border-gray-600 rounded focus:ring-purple-500 focus:ring-2">
                      <span class="ml-2 text-xs text-gray-300">{{ get_t('ai.add_to_general') }}</span>
                    </label>
                    <label class="flex items-center">
                      <input type="checkbox" @change="toggle_add_detailed"
                        :checked="ai_settings.use_mikomic_negative === 5"
                        class="w-4 h-4 text-purple-600 bg-gray-800 border-gray-600 rounded focus:ring-purple-500 focus:ring-2">
                      <span class="ml-2 text-xs text-gray-300">{{ get_t('ai.add_to_detailed') }}</span>
                    </label>
                  </div>
                  <!-- Quality warning for full custom mode -->
                  <div v-if="ai_settings.use_mikomic_negative === 1"
                    class="mt-2 p-2 bg-red-900/20 border border-red-700/50 rounded text-xs text-red-400">
                    ⚠️ {{ get_t('ai.quality_warning_custom_negative') }}
                  </div>
                </div>

                <div class="relative">
                  <textarea v-model="ai_prompts.negative"
                    class="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white text-sm min-h-[80px] focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent resize-none"
                    style="resize: vertical; background-image: linear-gradient(-45deg, transparent 75%, rgb(147, 51, 234) 75%, rgb(147, 51, 234) 100%); background-size: 8px 8px; background-repeat: no-repeat; background-position: bottom right;"
                    rows="3" :placeholder="get_t('ai.custom_negative_placeholder')"></textarea>
                </div>

                <!-- Append mode indicator -->
                <div v-if="ai_settings.use_mikomic_negative === 4 || ai_settings.use_mikomic_negative === 5"
                  class="mt-2 text-xs text-green-400 flex items-center">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"></path>
                  </svg>
                  {{ get_t('ai.enhance_mode_active') }}
                  <span class="font-medium ml-1">
                    {{ ai_settings.use_mikomic_negative === 4 ? get_t('ai.negative_modes.general') :
                    get_t('ai.negative_modes.detailed') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- End scrollable content -->

        <!-- Bottom Actions (Generate & Credits) - ALWAYS AT BOTTOM -->
        <div class="border-t border-gray-700/50 pt-4 space-y-4">

          <!-- Generate Button -->
          <button @click="generate_ai_image" :disabled="ai_generating || !selected_panel"
            class="w-full py-3 px-4 rounded-lg font-medium text-sm transition-all duration-200 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-white/50"
            :class="ai_generating ? 
              'bg-red-600 text-white border-2 border-red-400 animate-pulse' : 
              'bg-purple-600 hover:bg-purple-700 text-white disabled:opacity-50'">
            <div v-if="ai_generating" class="flex items-center justify-center">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              <span v-if="ai_queue_status === 'queued' && ai_queue_position > 0">
                {{ get_t('ai.queued_position') }} {{ ai_queue_position }}
              </span>
              <span v-else>
                {{ get_t('ai.generating') }}
              </span>
            </div>
            <div v-else class="flex items-center justify-center">
              <i data-lucide="wand-2" class="w-4 h-4 mr-2"></i>
              {{ get_t('ai.generate') }} ({{ get_generation_cost() }} {{ get_t('ai.credits') }})
            </div>
          </button>

          <!-- Credits Display -->
          <div class="text-center text-xs text-gray-400">
            {{ get_t('ai.available_credits') }}: <span class="text-purple-400 font-mono">{{ get_available_ai_credits()
              }}</span>
          </div>
        </div>

      </div>

      <!-- Columns 2 & 3: Settings and Preview (Responsive) -->
      <div class="flex overflow-hidden" :class="use_three_column_layout ? 'flex-row' : 'flex-1 flex-col'">

        <!-- Column 2: Size, HiresFix, Advanced Settings -->
        <div class="flex flex-col overflow-y-auto space-y-6"
          :class="use_three_column_layout ? 'border-r border-gray-700/30 p-4 pr-5 max-w-[450px] min-w-[344px]' : 'flex-1 p-4'">

          <!-- Size Presets -->
          <div>
            <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.size_presets') }}</h3>
            <div class="flex gap-2 justify-center mb-3">
              <button @click="set_size_preset('16:9')"
                class="p-2 rounded border border-gray-600 hover:border-purple-500 transition-all duration-300">
                <div class="w-6 h-6 flex items-center justify-center">
                  <div class="w-3 h-6 bg-gray-300 rounded-sm transition-transform duration-300"
                    :class="!presets_rotated ? 'rotate-90' : ''"></div>
                </div>
              </button>
              <button @click="set_size_preset('2:3')"
                class="p-2 rounded border border-gray-600 hover:border-purple-500 transition-all duration-300">
                <div class="w-6 h-6 flex items-center justify-center">
                  <div class="w-4 h-6 bg-gray-300 rounded-sm transition-transform duration-300"
                    :class="!presets_rotated ? 'rotate-90' : ''"></div>
                </div>
              </button>
              <button @click="set_size_preset('1:1')"
                class="p-2 rounded border border-gray-600 hover:border-purple-500 transition-colors duration-200">
                <div class="w-6 h-6 flex items-center justify-center">
                  <div class="w-5 h-5 bg-gray-300 rounded-sm"></div>
                </div>
              </button>
              <button @click="swap_dimensions"
                class="p-2 rounded border border-gray-600 hover:border-purple-500 transition-colors duration-200"
                :title="get_t('ai.swap_dimensions')">
                <i data-lucide="arrow-left-right" class="w-4 h-4 text-gray-400 hover:text-purple-400"></i>
              </button>
            </div>

            <!-- Size inputs -->
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-sm text-gray-400 mb-2">{{ get_t('ai.width') }}</label>
                <input type="number" v-model.number="ai_settings.width" min="768" max="1536" step="64"
                  @blur="validate_dimension('width', $event)"
                  class="w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent">
              </div>
              <div>
                <label class="block text-sm text-gray-400 mb-2">{{ get_t('ai.height') }}</label>
                <input type="number" v-model.number="ai_settings.height" min="768" max="1536" step="64"
                  @blur="validate_dimension('height', $event)"
                  class="w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent">
              </div>
            </div>
          </div>


          <!-- HiresFix -->
          <div>
            <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.use_hires_fix') }}</h3>
            <div class="bg-gray-800/50 border border-purple-500/50 rounded-xl p-4">
              <div class="flex items-center justify-between mb-4"
                @click="ai_settings.use_hires_fix = !ai_settings.use_hires_fix" style="cursor: pointer;">
                <div class="flex flex-col items-center bg-gray-700 rounded-lg p-3 flex-1 mr-2">
                  <div class="text-xs text-gray-400 mb-1">Base</div>
                  <div class="text-sm font-mono text-white">{{ ai_settings.width }}×{{ ai_settings.height }}</div>
                </div>

                <div class="flex items-center justify-center px-2">
                  <i data-lucide="arrow-right" class="w-4 h-4 text-purple-400"></i>
                </div>

                <div class="flex flex-col items-center rounded-lg p-3 flex-1 ml-2"
                  :class="ai_settings.use_hires_fix ? 'bg-purple-600' : 'bg-gray-700'">
                  <div class="text-xs mb-1" :class="ai_settings.use_hires_fix ? 'text-white' : 'text-gray-400'">HIRES
                  </div>
                  <div class="text-sm font-mono text-white">{{ Math.round(ai_settings.width * 1.29) }}×{{
                    Math.round(ai_settings.height * 1.29) }}</div>
                </div>
              </div>

              <div class="text-center text-sm font-medium text-gray-300 mb-4"
                @click="ai_settings.use_hires_fix = !ai_settings.use_hires_fix" style="cursor: pointer;">
                Final Resolution: <span class="text-purple-400 font-mono">{{ ai_settings.use_hires_fix ?
                  Math.round(ai_settings.width * 1.29) + '×' + Math.round(ai_settings.height * 1.29) : ai_settings.width
                  + '×' + ai_settings.height }}</span>
              </div>

              <div class="mb-3">
                <div class="flex justify-between items-center mb-2">
                  <label class="text-xs text-gray-400">{{ get_t('ai.hires_denoise') }}</label>
                  <span class="text-xs text-purple-400 font-mono">{{ ai_settings.hires_denoise.toFixed(2) }}</span>
                </div>
                <input type="range" v-model.number="ai_settings.hires_denoise" min="0.3" max="1" step="0.01"
                  class="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider-purple focus:outline-none"
                  style="outline: none !important;">
              </div>

              <div class="mt-3">
                <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.use_same_seed_for_hires') }}</label>
                <button @click="ai_settings.use_same_seed_for_hires = !ai_settings.use_same_seed_for_hires"
                  class="w-full p-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-center gap-2"
                  :class="ai_settings.use_same_seed_for_hires ? 
                  'bg-purple-600/20 border-purple-500 text-purple-300' : 
                  'bg-gray-800 border-gray-600 text-gray-400 hover:border-gray-500'">
                  <i :data-lucide="ai_settings.use_same_seed_for_hires ? 'check' : 'x'" class="w-4 h-4"></i>
                  <span class="text-xs">{{ ai_settings.use_same_seed_for_hires ? 'On' : 'Off' }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Advanced Settings (Collapsible) -->
          <div>
            <button @click="toggle_advanced_settings"
              class="w-full flex items-center justify-between p-3 bg-gray-800 border border-gray-600 rounded-lg hover:border-gray-500 transition-colors duration-200">
              <span class="text-sm font-medium text-gray-200">{{ get_t('ai.advanced_settings') }}</span>
              <i :data-lucide="advanced_settings_collapsed ? 'chevron-down' : 'chevron-up'"
                class="w-4 h-4 text-gray-400"></i>
            </button>

            <div v-if="!advanced_settings_collapsed"
              class="mt-3 space-y-4 p-4 bg-gray-800/50 rounded-lg border border-gray-700/50">
              <!-- Seed -->
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-2">
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.seed') }}</label>
                  <input type="number" v-model.number="ai_settings.seed" min="-1" max="1125899906842620" step="1"
                    class="w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent">
                </div>
                <div>
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.random_seed') }}</label>
                  <button @click="randomize_seed()"
                    class="w-full p-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-center bg-purple-600/20 border-purple-500 text-purple-300 hover:bg-purple-600/30 hover:border-purple-400">
                    <i data-lucide="shuffle" class="w-4 h-4"></i>
                  </button>
                </div>
              </div>

              <!-- Steps and CFG -->
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <div class="flex justify-between items-center mb-2">
                    <label class="text-xs text-gray-400">{{ get_t('ai.steps') }}</label>
                    <span class="text-xs text-purple-400 font-mono">{{ ai_settings.steps }}</span>
                  </div>
                  <input type="range" v-model.number="ai_settings.steps" min="20" max="32" step="1"
                    class="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider-purple focus:outline-none"
                    style="outline: none !important;">
                </div>

                <div>
                  <div class="flex justify-between items-center mb-2">
                    <label class="text-xs text-gray-400">{{ get_t('ai.cfg_scale') }}</label>
                    <span class="text-xs text-purple-400 font-mono">{{ ai_settings.cfg_scale }}</span>
                  </div>
                  <input type="range" v-model.number="ai_settings.cfg_scale" min="4" max="16" step="0.1"
                    class="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider-purple focus:outline-none"
                    style="outline: none !important;">
                </div>
              </div>

              <!-- Sampler and Scheduler -->
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.sampler') }}</label>
                  <select v-model="ai_settings.sampler"
                    class="w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent">
                    <option v-for="sampler in available_samplers" :key="sampler.name" :value="sampler.name">
                      {{ sampler.display_name }}
                    </option>
                  </select>
                </div>

                <div>
                  <label class="block text-xs text-gray-400 mb-2">{{ get_t('ai.scheduler') }}</label>
                  <div @click="handle_scheduler_dropdown_click" class="relative">
                    <select v-model="ai_settings.scheduler" :disabled="is_scheduler_dropdown_disabled"
                      :class="{'opacity-60': is_scheduler_dropdown_disabled, 'cursor-pointer': !is_scheduler_dropdown_disabled}"
                      :style="{pointerEvents: is_scheduler_dropdown_disabled ? 'none' : 'auto'}"
                      class="cursor-pointer w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent">
                      <option v-for="scheduler in filtered_schedulers" :key="scheduler.name" :value="scheduler.name"
                        :disabled="scheduler.disabled"
                        :class="{'text-yellow-400 font-semibold': scheduler.recommended, 'text-gray-500': scheduler.disabled, 'text-white': !scheduler.recommended && !scheduler.disabled}">
                        {{ scheduler.display_name }}{{ scheduler.recommended ? ' ⭐' : '' }}{{ is_karras_only_model &&
                        scheduler.name === 'karras' ? '' : '' }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Generation History (Collapsible) - Shows in column 2 when 2-column, moves to column 3 when 3-column -->
          <div v-if="!use_three_column_layout">
            <button @click="toggle_generation_history"
              class="w-full flex items-center justify-between p-3 bg-gray-800 border border-gray-600 rounded-lg hover:border-gray-500 transition-colors duration-200">
              <span class="text-sm font-medium text-gray-200">{{ get_t('ai.generation_history') }}</span>
              <i :data-lucide="show_generation_history ? 'chevron-up' : 'chevron-down'"
                class="w-4 h-4 text-gray-400"></i>
            </button>

            <div v-if="show_generation_history" class="mt-3 bg-gray-800/50 rounded-lg border border-gray-700/50">
              <!-- History Content -->
              <div v-if="generation_history.length > 0" class="max-h-96 overflow-y-auto p-4"
                @scroll="handle_history_scroll">

                <!-- History counter and info -->
                <div class="flex items-center justify-between mb-4 pb-2 border-b border-gray-700/50">
                  <div
                    class="flex items-center gap-2 cursor-pointer text-gray-300 hover:text-gray-100 transition-colors"
                    @click="show_history_info_modal">
                    <span class="text-sm font-medium">
                      {{ get_t('ai.generation_history') }} {{ history_total_images || generation_history.length }}/{{
                      get_tier_limit('history_images') }}
                    </span>
                    <i data-lucide="help-circle" class="w-4 h-4 text-gray-400"></i>
                  </div>
                </div>

                <!-- Grid responsive: max 6 columns, images expand to fill -->
                <div class="grid gap-3"
                  style="grid-template-columns: repeat(auto-fill, minmax(max(110px, calc((100% - 15px * 5) / 6)), 1fr)); max-width: 100%;">
                  <div v-for="(image, index) in generation_history" :key="image.id || index"
                    class="relative group bg-gray-900 rounded-lg overflow-hidden border border-gray-700 hover:border-gray-500 transition-colors duration-200"
                    :class="image.is_placeholder ? 'cursor-default' : 'cursor-pointer'">

                    <!-- Placeholder card -->
                    <div v-if="image.is_placeholder" class="aspect-[4/5] bg-gray-800 flex items-center justify-center">
                      <i data-lucide="image" class="w-8 h-8 text-gray-600"></i>
                    </div>

                    <!-- Real image -->
                    <div v-else class="aspect-[4/5]">
                      <img :src="image.url" :alt="`Generated image ${index + 1}`"
                        class="w-full h-full object-cover smooth-scaling" draggable="true" loading="lazy" width="113"
                        height="141" @click="view_history_image(image)"
                        @dragstart="handle_history_image_dragstart($event, image)">
                    </div>

                    <!-- Action buttons at bottom - only for real images -->
                    <div v-if="!image.is_placeholder"
                      class="absolute bottom-0 left-0 right-0 bg-black/30 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <div class="flex gap-1 justify-center">
                        <!-- Insert -->
                        <button @click.stop="insert_history_image(image)"
                          class="p-1.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.insert_image')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                        </button>

                        <!-- Download -->
                        <button @click.stop="download_history_image(image)"
                          class="p-1.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.download')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                        </button>

                        <!-- Delete -->
                        <button @click.stop="confirm_delete_history_image(image)"
                          class="p-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.delete_image')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Loading indicator -->
                <div v-if="history_loading && history_has_more" class="text-center py-4">
                  <div class="inline-flex items-center text-gray-400">
                    <i data-lucide="loader-2" class="w-4 h-4 mr-2 animate-spin"></i>
                    {{ get_t('ai.loading_history') }}
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div v-else class="p-6 text-center">
                <i data-lucide="image" class="w-8 h-8 text-gray-500 mx-auto mb-3"></i>
                <p class="text-gray-400 text-sm">{{ get_t('ai.no_history_images') }}</p>
              </div>
            </div>
          </div>

        </div>

        <!-- AI Preview Area (only when NOT in 3-column mode) -->
        <div v-if="!use_three_column_layout" class="border-t border-gray-700/50 p-4 mt-auto">
          <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.generation_preview') }}</h3>

          <!-- Generated image or default preview -->
          <div class="relative bg-gray-800 rounded-lg overflow-hidden mb-3" style="height: 340px;">
            <img
              :src="ai_preview_image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgZmlsbD0iIzM3NDE0ZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0iY2VudHJhbCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzY5NzM4MyIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTZweCIgZm9udC13ZWlnaHQ9Im5vcm1hbCI+UHJldmlldyBBcmVhPC90ZXh0Pjwvc3ZnPg=='"
              alt="AI Preview" class="w-full h-full object-contain cursor-pointer" :draggable="!!ai_preview_image"
              @dragstart="handle_ai_preview_dragstart" @click="ai_preview_image && show_ai_image_fullscreen()">
          </div>

          <!-- Preview Actions - only show when image exists -->
          <div v-if="ai_preview_image" class="grid grid-cols-2 gap-2 mb-3">
            <button @click="accept_ai_image"
              class="py-2 px-3 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50">
              <i data-lucide="check" class="w-4 h-4 mr-1"></i>
              {{ get_t('ai.accept') }}
            </button>
            <button @click="discard_ai_image" :disabled="!is_generated_image"
              :class="is_generated_image 
                ? 'py-2 px-3 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50' 
                : 'py-2 px-3 rounded-lg bg-gray-400 text-gray-600 text-sm font-medium flex items-center justify-center cursor-not-allowed'">
              <i data-lucide="x" class="w-4 h-4 mr-1"></i>
              {{ get_t('ai.discard') }}
            </button>
          </div>

          <button v-if="ai_preview_image" @click="download_ai_image"
            class="w-full py-2 px-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50">
            <i data-lucide="download" class="w-4 h-4 mr-1"></i>
            {{ get_t('ai.download') }}
          </button>
        </div>

      </div>

      <!-- Column 3: Generation History & Preview (only in 3-column mode) -->
      <div v-if="use_three_column_layout" class="flex-1 flex flex-col pl-4 pr-4 py-4 min-h-0">

        <!-- Scrollable content area -->
        <div class="flex flex-col flex-1 overflow-y-auto min-h-0">
          <!-- Generation History (Collapsible) -->
          <div>
            <button @click="toggle_generation_history"
              class="w-full flex items-center justify-between p-3 bg-gray-800 border border-gray-600 rounded-lg hover:border-gray-500 transition-colors duration-200">
              <span class="text-sm font-medium text-gray-200">{{ get_t('ai.generation_history') }}</span>
              <i :data-lucide="show_generation_history ? 'chevron-up' : 'chevron-down'"
                class="w-4 h-4 text-gray-400"></i>
            </button>

            <div v-if="show_generation_history" class="mt-3 bg-gray-800/50 rounded-lg border border-gray-700/50">
              <!-- History Content -->
              <div v-if="generation_history.length > 0" class="max-h-96 overflow-y-auto p-4"
                @scroll="handle_history_scroll">

                <!-- History counter and info -->
                <div class="flex items-center justify-between mb-4 pb-2 border-b border-gray-700/50">
                  <div
                    class="flex items-center gap-2 cursor-pointer text-gray-300 hover:text-gray-100 transition-colors"
                    @click="show_history_info_modal">
                    <span class="text-sm font-medium">
                      {{ get_t('ai.generation_history') }} {{ history_total_images || generation_history.length }}/{{
                      get_tier_limit('history_images') }}
                    </span>
                    <i data-lucide="help-circle" class="w-4 h-4 text-gray-400"></i>
                  </div>
                </div>

                <!-- Grid responsive: max 6 columns, images expand to fill -->
                <div class="grid gap-3"
                  style="grid-template-columns: repeat(auto-fill, minmax(max(110px, calc((100% - 15px * 5) / 6)), 1fr));">
                  <div v-for="(image, index) in generation_history" :key="image.id || index"
                    class="relative group bg-gray-900 rounded-lg overflow-hidden border border-gray-700 hover:border-gray-500 transition-colors duration-200"
                    :class="image.is_placeholder ? 'cursor-default' : 'cursor-pointer'">

                    <!-- Placeholder card -->
                    <div v-if="image.is_placeholder" class="aspect-[4/5] bg-gray-800 flex items-center justify-center">
                      <i data-lucide="image" class="w-8 h-8 text-gray-600"></i>
                    </div>

                    <!-- Real image -->
                    <div v-else class="aspect-[4/5]">
                      <img :src="image.url" :alt="`Generated image ${index + 1}`"
                        class="w-full h-full object-cover smooth-scaling" draggable="true" loading="lazy" width="113"
                        height="141" @click="view_history_image(image)"
                        @dragstart="handle_history_image_dragstart($event, image)">
                    </div>

                    <!-- Action buttons at bottom - only for real images -->
                    <div v-if="!image.is_placeholder"
                      class="absolute bottom-0 left-0 right-0 bg-black/30 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <div class="flex gap-1 justify-center">
                        <button @click.stop="insert_history_image(image)"
                          class="p-1.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.insert_image')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                        </button>

                        <button @click.stop="download_history_image(image)"
                          class="p-1.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.download')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                        </button>

                        <button @click.stop="confirm_delete_history_image(image)"
                          class="p-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
                          :title="get_t('ai.delete_image')">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Loading indicator -->
                <div v-if="history_loading && history_has_more" class="text-center py-4">
                  <div class="inline-flex items-center text-gray-400">
                    <i data-lucide="loader-2" class="w-4 h-4 mr-2 animate-spin"></i>
                    {{ get_t('ai.loading_history') }}
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div v-else class="p-6 text-center">
                <i data-lucide="image" class="w-8 h-8 text-gray-500 mx-auto mb-3"></i>
                <p class="text-gray-400 text-sm">{{ get_t('ai.no_history_images') }}</p>
              </div>
            </div>
          </div>
          <!-- End scrollable area -->

          <!-- AI Preview Area (in 3-column mode) - Fixed at bottom -->
          <div class="border-t border-gray-700/50 pt-4 flex-shrink-0 mt-auto">
            <h3 class="text-sm font-medium text-gray-200 mb-3">{{ get_t('ai.generation_preview') }}</h3>

            <!-- Generated image or default preview -->
            <div class="relative bg-gray-800 rounded-lg overflow-hidden mb-3" style="height: 385px;">
              <img
                :src="ai_preview_image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQwMCIgZmlsbD0iIzM3NDE0ZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0iY2VudHJhbCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzY5NzM4MyIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTZweCIgZm9udC13ZWlnaHQ9Im5vcm1hbCI+UHJldmlldyBBcmVhPC90ZXh0Pjwvc3ZnPg=='"
                alt="AI Preview" class="w-full h-full object-contain cursor-pointer" :draggable="!!ai_preview_image"
                @dragstart="handle_ai_preview_dragstart" @click="ai_preview_image && show_ai_image_fullscreen()">
            </div>

            <!-- Preview Actions - only show when image exists -->
            <div v-if="ai_preview_image" class="grid grid-cols-2 gap-2 mb-3">
              <button @click="accept_ai_image"
                class="py-2 px-3 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50">
                <i data-lucide="check" class="w-4 h-4 mr-1"></i>
                {{ get_t('ai.accept') }}
              </button>
              <button @click="discard_ai_image" :disabled="!is_generated_image"
                :class="is_generated_image 
                ? 'py-2 px-3 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50' 
                : 'py-2 px-3 rounded-lg bg-gray-400 text-gray-600 text-sm font-medium flex items-center justify-center cursor-not-allowed'">
                <i data-lucide="x" class="w-4 h-4 mr-1"></i>
                {{ get_t('ai.discard') }}
              </button>
            </div>

            <button v-if="ai_preview_image" @click="download_ai_image"
              class="w-full py-2 px-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors duration-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50">
              <i data-lucide="download" class="w-4 h-4 mr-1"></i>
              {{ get_t('ai.download') }}
            </button>
          </div>

        </div>

      </div>
    </div>

  </div>

</div>
<!-- End Main content area -->

<!-- Status bar -->
<div v-if="comic_mode===true" id="status_bar"
  class="bg-gradient-to-r from-gray-950 via-gray-900 to-gray-950 border-gray-700 py-1 px-3 flex items-center justify-between text-xs text-gray-400">
  <div class="flex items-center gap-4">
    <span :class="{ 'text-red-400 font-medium': is_saving_status }">{{ status_message }}</span>
    <span>{{ get_t('status.panels') }}: {{ panels.length - 1 }}</span>
    <span v-if="current_file_path && !is_mobile_view">{{ current_file_path }}{{ document_has_unsaved_changes ? '*' : ''
      }}</span>
  </div>
  <div class="flex items-center gap-4">
    <div class="flex items-center gap-1">
      <span>{{ get_t('status.zoom') }}:</span>
      <span class="bg-gray-700 rounded px-2 py-0.5 hover:bg-gray-600 cursor-pointer" @click="reset_zoom_to_100_percent"
        title="get_t('zoom.click_to_reset_zoom')">
        {{ get_current_zoom() }}%
      </span>
    </div>
    <span>{{ get_t('format.format_label') }}: {{ current_format }} ({{ canvas_width }}x{{ canvas_height }})</span>
    <span v-if="user_data && user_data.tier !== 'free'" class="px-2 py-0.5 text-xs font-medium rounded-full" :class="{
            'bg-amber-500/20 text-amber-400': user_data.tier === 'premium',
            'bg-purple-500/20 text-purple-400': user_data.tier === 'creator_pro'
          }">
      {{ user_data.tier === 'premium' ? 'Premium' : 'Creator Pro' }}
    </span>
  </div>
</div>

<!-- Model Info Modal -->
<div v-if="show_model_info_modal && current_model_info"
  class="fixed inset-0 bg-black/90 backdrop-blur-md flex items-center justify-center z-[9999]"
  @click="close_model_info_modal">

  <div @click.stop
    class="relative bg-gradient-to-b from-gray-900 to-black rounded-3xl max-w-7xl w-full mx-8 border border-gray-700/50 shadow-2xl flex flex-col overflow-hidden max-h-[90vh] ring-1 ring-white/10">

    <!-- Header -->
    <div
      class="px-8 py-6 border-b border-gray-800 flex items-center justify-between bg-gray-900/80 backdrop-blur-sm z-20">
      <div>
        <h2 class="text-3xl font-bold text-white tracking-tight mb-1 font-display">{{ current_model_info.display_name }}
        </h2>
        <div class="flex items-center gap-2">
          <span
            class="px-2 py-0.5 rounded text-xs font-medium bg-purple-500/10 text-purple-400 border border-purple-500/20">{{
            current_model_info.type || 'Checkpoint' }}</span>
          <span
            class="px-2 py-0.5 rounded text-xs font-medium bg-blue-500/10 text-blue-400 border border-blue-500/20">{{
            current_model_info.version || 'v1.0' }}</span>
        </div>
      </div>
      <button @click="close_model_info_modal"
        class="group bg-gray-800 hover:bg-gray-700 rounded-full p-2 transition-all duration-300 border border-gray-700 hover:border-gray-500">
        <i data-lucide="x" class="w-6 h-6 text-gray-400 group-hover:text-white transition-colors"></i>
      </button>
    </div>

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col overflow-hidden relative group/modal">

      <!-- Carousel Container -->
      <div
        class="relative w-full py-8 bg-gradient-to-r from-gray-900 via-gray-800/50 to-gray-900 min-h-[500px] flex items-center">

        <!-- Navigation Button Prev -->
        <div
          class="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-black/80 to-transparent z-10 flex items-center justify-center opacity-0 group-hover/modal:opacity-100 transition-opacity duration-300 pointer-events-none">
          <button @click="scroll_info_carousel('prev')"
            class="pointer-events-auto w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/10 text-white flex items-center justify-center transition-all duration-200 hover:scale-110 active:scale-95 shadow-lg">
            <i data-lucide="chevron-left" class="w-8 h-8"></i>
          </button>
        </div>

        <!-- Scrollable Track -->
        <div ref="model_info_carousel"
          class="flex overflow-x-auto gap-6 px-12 scrollbar-hide scroll-smooth h-full items-center py-4 w-full">

          <div v-for="(img, index) in current_model_info.demo_images" :key="index"
            class="group relative flex-shrink-0 h-[450px] aspect-[2/3] rounded-2xl overflow-hidden cursor-pointer shadow-2xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 ring-1 ring-white/10 hover:ring-purple-500/50 bg-gray-800"
            @click="open_model_info_lightbox(index)">

            <img :src="img" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              loading="lazy">

            <!-- Gradient Overlay -->
            <div
              class="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-60 group-hover:opacity-100 transition-opacity duration-300">
            </div>

            <!-- Actions -->
            <div
              class="absolute inset-0 flex items-end justify-center p-6 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-4 group-hover:translate-y-0">
              <button @click.stop="load_metadata_from_url(img); close_model_info_modal()"
                class="w-full bg-white text-black hover:bg-purple-100 font-bold py-3 px-4 rounded-xl shadow-lg flex items-center justify-center gap-2 transition-colors duration-200">
                <i data-lucide="sparkles" class="w-4 h-4 text-purple-600"></i>
                <span>{{ get_t('ai.load_metadata') }}</span>
              </button>
            </div>
          </div>

        </div>

        <!-- Navigation Button Next -->
        <div
          class="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-black/80 to-transparent z-10 flex items-center justify-center opacity-0 group-hover/modal:opacity-100 transition-opacity duration-300 pointer-events-none">
          <button @click="scroll_info_carousel('next')"
            class="pointer-events-auto w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/10 text-white flex items-center justify-center transition-all duration-200 hover:scale-110 active:scale-95 shadow-lg">
            <i data-lucide="chevron-right" class="w-8 h-8"></i>
          </button>
        </div>
      </div>

      <!-- Info Footer -->
      <div class="bg-gray-900 p-8 border-t border-gray-800 z-20">
        <div class="max-w-4xl mx-auto text-center">
          <p class="text-gray-300 text-lg leading-relaxed font-light">
            {{ get_t(current_model_info.description_key) }}
          </p>

          <div
            class="mt-6 flex justify-center gap-8 text-sm text-gray-500 font-medium uppercase tracking-widest border-t border-gray-800 pt-6 w-full opacity-60">
            <div class="flex items-center gap-2">
              <i data-lucide="palette" class="w-4 h-4"></i>
              <span>{{ get_t('ai.model_tags.high_fidelity') }}</span>
            </div>
            <div class="flex items-center gap-2">
              <i data-lucide="zap" class="w-4 h-4"></i>
              <span>{{ get_t('ai.model_tags.fast_gen') }}</span>
            </div>
            <div class="flex items-center gap-2">
              <i data-lucide="layers" class="w-4 h-4"></i>
              <span>{{ get_t('ai.model_tags.sota') }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Lightbox Overlay -->
<div v-if="model_info_lightbox_active && current_model_info"
  class="fixed inset-0 bg-black/95 z-[10000] flex items-center justify-center backdrop-blur-md"
  @click="close_model_info_lightbox">

  <!-- Close Button -->
  <button class="absolute top-6 right-6 text-white/50 hover:text-white p-2 z-[10010]"
    @click="close_model_info_lightbox">
    <i data-lucide="x" class="w-10 h-10"></i>
  </button>

  <!-- Main Image -->
  <div class="relative w-full h-full flex items-center justify-center p-12" @click.stop>
    <img :src="current_model_info.demo_images[model_info_lightbox_index]"
      class="max-w-full max-h-full rounded-lg shadow-2xl object-contain transition-all duration-300">

    <!-- Metadata Button (Lightbox) -->
    <button
      @click="load_metadata_from_url(current_model_info.demo_images[model_info_lightbox_index]); close_model_info_lightbox(); close_model_info_modal()"
      class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-purple-600 hover:bg-purple-500 text-white px-6 py-3 rounded-full font-semibold shadow-xl flex items-center gap-2 transition-transform hover:scale-105 border border-purple-400/30">
      <i data-lucide="sparkles" class="w-5 h-5"></i>
      {{ get_t('ai.load_metadata') }}
    </button>
  </div>

  <!-- Navigation -->
  <button v-if="current_model_info.demo_images.length > 1" @click.stop="navigate_lightbox('prev')"
    class="absolute left-6 top-1/2 -translate-y-1/2 text-white/50 hover:text-white p-4 transition-colors z-[10010] bg-black/20 hover:bg-black/40 rounded-full backdrop-blur-sm">
    <i data-lucide="chevron-left" class="w-12 h-12"></i>
  </button>

  <button v-if="current_model_info.demo_images.length > 1" @click.stop="navigate_lightbox('next')"
    class="absolute right-6 top-1/2 -translate-y-1/2 text-white/50 hover:text-white p-4 transition-colors z-[10010] bg-black/20 hover:bg-black/40 rounded-full backdrop-blur-sm">
    <i data-lucide="chevron-right" class="w-12 h-12"></i>
  </button>

</div>

<!-- Gallery Modal -->
<div v-if="show_gallery_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-rose-600/10 to-rose-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-rose-500 to-rose-600 rounded-xl flex items-center justify-center shadow-lg">
            <i data-lucide="sparkles" class="w-5 h-5 text-white"></i>
          </div>
          <div>
            <h2 class="text-xl font-semibold text-white">{{ get_t('gallery.title') }}</h2>
            <p v-if="gallery_admin_mode && is_dev_environment" class="text-xs text-amber-400">{{
              get_t('gallery.admin_mode_active') }}</p>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <!-- Admin Mode Toggle (Dev Only) -->
          <button v-if="is_dev_environment" @click="toggle_gallery_admin_mode()"
            class="px-3 py-1.5 rounded-lg border transition-all duration-200 text-sm" :class="gallery_admin_mode ? 
                            'bg-amber-600 border-amber-500 text-white flex items-center ' : 
                            'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600 flex items-center '"
            :title="gallery_admin_mode ? get_t('gallery.exit_admin_mode') : get_t('gallery.enter_admin_mode')">
            <i data-lucide="settings" class="w-3 h-3 mr-1"></i>
            {{ gallery_admin_mode ? get_t('gallery.exit_admin') : get_t('gallery.admin') }}
          </button>

          <button @click="hide_gallery"
            class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Category Tabs -->
    <div v-if="Object.keys(gallery_categories).length > 0" class="bg-gray-800/50 border-b border-gray-600/30 px-6 py-3">
      <div class="flex gap-2 overflow-x-auto">
        <button v-for="(category_data, category_name) in gallery_categories" :key="category_name"
          @click="switch_gallery_tab(category_name)" :class="{
                        'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg': active_gallery_tab === category_name,
                        'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50 hover:text-white': active_gallery_tab !== category_name
                    }" class="px-4 py-2 rounded-lg font-medium transition-all duration-200 whitespace-nowrap">
          {{ category_data.display }}
        </button>
      </div>
    </div>

    <!-- Subcategory Tabs -->
    <div v-if="current_subcategories.length > 1" class="bg-gray-750/50 border-b border-gray-600/20 px-6 py-2">
      <div class="flex gap-2 overflow-x-auto">
        <button v-for="subcategory in current_subcategories" :key="subcategory.clean"
          @click="switch_gallery_subtab(subcategory.clean)" :class="{
                        'bg-gradient-to-r from-rose-500 to-rose-600 text-white shadow-lg': active_gallery_subtab === subcategory.clean,
                        'bg-gray-600/50 text-gray-400 hover:bg-gray-600 hover:text-white': active_gallery_subtab !== subcategory.clean
                    }"
          class="px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap">
          {{ subcategory.display }}
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 overflow-y-auto max-h-[60vh] gallery-scrollbar">
      <!-- Loading State -->
      <div v-if="gallery_loading" class="flex items-center justify-center py-12">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-2 border-rose-500/30 border-t-rose-500 mx-auto mb-4">
          </div>
          <p class="text-gray-400">{{ get_t('status.loading') }}...</p>
        </div>
      </div>

      <!-- Special Info Message -->
      <div v-if="!gallery_loading && current_subcategory_info"
        class="mb-4 p-4 bg-amber-500/10 border border-amber-500/30 rounded-xl">
        <div class="flex items-start gap-3">
          <svg class="w-5 h-5 text-amber-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z">
            </path>
          </svg>
          <div>
            <p class="text-amber-200 text-sm font-medium mb-1">{{ get_t('gallery.info') }}</p>
            <p class="text-amber-100 text-sm leading-relaxed">{{ get_t(current_subcategory_info.info_key) }}</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="!gallery_loading && (!current_gallery_items || current_gallery_items.length === 0)"
        class="text-center py-12">
        <div class="w-20 h-20 bg-gray-700/50 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <h3 class="text-lg font-medium text-gray-300 mb-2">{{ get_t('gallery.empty_category') }}</h3>
        <p class="text-gray-400">{{ get_t('gallery.empty_category_description') }}</p>
      </div>

      <!-- Gallery Grid -->
      <div v-if="!gallery_loading && current_gallery_items && current_gallery_items.length > 0"
        class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"
        :class="{ 'sortable-gallery': gallery_admin_mode && is_dev_environment }" :data-category="active_gallery_tab"
        :data-subcategory="active_gallery_subtab">
        <div v-for="item in current_gallery_items" :key="item.id" :data-item-id="item.id"
          @click="!gallery_admin_mode && insert_gallery_item(item)"
          class="group relative bg-gray-700/30 hover:bg-gray-600/50 border border-gray-600/50 hover:border-rose-500/50 rounded-xl p-3 transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-rose-500/20 gallery-item"
          :class="{ 
                        'opacity-60': item.is_premium && !user_data.is_premium && !gallery_admin_mode,
                        'cursor-not-allowed': item.is_premium && !user_data.is_premium && !gallery_admin_mode,
                        'cursor-default': gallery_admin_mode,
                        'cursor-pointer': !gallery_admin_mode,
                        'cursor-move': gallery_admin_mode && is_dev_environment
                    }">
          <!-- Admin Controls (Dev Only) -->
          <div v-if="gallery_admin_mode && is_dev_environment"
            class="absolute inset-0 bg-black/80 rounded-xl flex flex-col justify-between p-2 z-30">
            <!-- Top controls -->
            <div class="flex justify-between">
              <!-- Move to top button -->
              <button @click.stop="move_item_to_top(item)"
                class="p-1 bg-blue-600 hover:bg-blue-700 rounded text-white text-xs transition-colors"
                :title="get_t('gallery.move_to_top')">
                <i data-lucide="arrow-up" class="w-3 h-3"></i>
              </button>

              <!-- Toggle premium button -->
              <button @click.stop="toggle_item_premium(item)" class="p-1 rounded text-white text-xs transition-colors"
                :class="item.is_premium ? 'bg-amber-600 hover:bg-amber-700' : 'bg-gray-600 hover:bg-gray-700'"
                :title="item.is_premium ? get_t('gallery.make_free') : get_t('gallery.make_premium')">
                <i data-lucide="sparkles" class="w-3 h-3"></i>
              </button>
            </div>

            <!-- Center info button -->
            <div class="flex justify-center">
              <button @click.stop="show_item_details(item)"
                class="p-2 bg-gray-700 hover:bg-gray-600 rounded-full text-white transition-colors"
                :title="get_t('gallery.show_details')">
                <i data-lucide="info" class="w-4 h-4"></i>
              </button>
            </div>

            <!-- Bottom controls -->
            <div class="flex justify-between">
              <!-- Edit name button -->
              <button @click.stop="edit_item_name(item)"
                class="p-1 bg-green-600 hover:bg-green-700 rounded text-white text-xs transition-colors"
                :title="get_t('gallery.edit_name')">
                <i data-lucide="edit-2" class="w-3 h-3"></i>
              </button>

              <!-- Delete button -->
              <button @click.stop="delete_gallery_item(item)"
                class="p-1 bg-red-600 hover:bg-red-700 rounded text-white text-xs transition-colors"
                :title="get_t('gallery.delete_item')">
                <i data-lucide="trash-2" class="w-3 h-3"></i>
              </button>
            </div>
          </div>

          <!-- Premium Badge -->
          <div v-if="item.is_premium" class="absolute top-2 right-2 z-10">
            <div
              class="flex items-center justify-center w-6 h-6 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full shadow-lg">
              <i data-lucide="sparkles" class="w-3 h-3 text-white"></i>
            </div>
          </div>

          <!-- Premium Overlay (for non-premium users) -->
          <div v-if="item.is_premium && !user_data.is_premium && !gallery_admin_mode"
            class="absolute inset-0 bg-black/40 backdrop-blur-[1px] rounded-xl flex items-center justify-center z-20">
            <div class="text-center">
              <i data-lucide="lock" class="w-6 h-6 text-amber-400 mx-auto mb-1"></i>
              <p class="text-xs text-amber-400 font-medium">{{ get_t('premium.required') }}</p>
            </div>
          </div>

          <!-- Thumbnail -->
          <div class="aspect-square bg-gray-800/50 rounded-lg mb-3 overflow-hidden">
            <!-- Composite Preview (for special effects) -->
            <div v-if="use_composite_preview && item.blend_mode"
              class="relative w-full h-full gallery-composite-preview">
              <!-- Background image -->
              <img src="./data/galleries/preview_bg.webp" alt="Background"
                class="absolute inset-0 w-full h-full object-cover">
              <!-- Effect overlay with blend mode -->
              <img :src="item.thumbnail_base64 || item.thumbnail" :alt="item.name || 'Gallery item'"
                class="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                :style="{ mixBlendMode: konva_to_css_blend_mode(item.blend_mode) }" loading="lazy">
            </div>

            <!-- Regular thumbnail -->
            <img v-else :src="item.thumbnail_base64 || item.thumbnail" :alt="item.name || 'Gallery item'"
              class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" loading="lazy">
          </div>

          <!-- Item Info -->
          <div class="text-center">
            <p class="text-sm text-gray-300 font-medium truncate" :title="item.name || 'Gallery item'">{{ item.name ||
              get_t('gallery.unnamed_item') }}</p>
            <p class="text-xs text-gray-400 mt-1">{{ item.blend_mode || 'normal' }}</p>
            <!-- Admin info -->
            <p v-if="gallery_admin_mode && is_dev_environment" class="text-xs mt-1"
              :class="item.is_premium ? 'text-amber-400' : 'text-green-400'">
              {{ item.is_premium ? get_t('gallery.premium') : get_t('gallery.free') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="bg-gray-800/30 backdrop-blur-sm border-t border-gray-600/30 p-4">
      <div class="flex justify-between items-center">
        <div class="flex flex-col gap-1">
          <p class="text-sm text-gray-400">
            {{ current_gallery_items ? current_gallery_items.length : 0 }} {{ get_t('gallery.items_count') }}
          </p>
          <!-- Admin mode drag & drop info -->
          <p v-if="gallery_admin_mode && is_dev_environment" class="text-xs text-amber-400">
            {{ get_t('gallery.drag_to_reorder') || 'Drag items to reorder them' }}
          </p>
        </div>

        <!-- Insert to Global Panel Checkbox -->
        <label class="flex items-center gap-2 text-sm text-gray-300 cursor-pointer hover:text-white transition-colors">
          <input type="checkbox" v-model="insert_to_global_panel"
            class="w-4 h-4 text-rose-600 bg-gray-700 border-gray-600 rounded focus:ring-rose-500 focus:ring-2 accent-rose-600">
          {{ get_t('gallery.insert_to_global_panel') }}
        </label>

      </div>
    </div>
  </div>
</div>

<!-- Admin Gallery Panel (Dev Only) -->
<div v-if="show_admin_panel && is_dev_environment && comic_mode"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[210]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-blue-600/10 to-blue-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h2 class="text-xl font-semibold text-white">{{ get_t('gallery.admin_panel') }}</h2>
        </div>
        <button @click="hide_admin_gallery_panel"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 space-y-6">
      <div class="text-center">
        <div
          class="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-2xl shadow-blue-500/25">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-white mb-2">{{ get_t('gallery.add_to_gallery') }}</h3>
        <p class="text-gray-400 text-sm leading-relaxed">{{ get_t('gallery.admin_instructions') }}</p>
      </div>

      <div class="space-y-4">
        <button @click="add_to_gallery(active_gallery_tab)"
          :disabled="!selected_objects || selected_objects.length === 0"
          class="w-full group relative overflow-hidden bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-600 disabled:to-gray-700 text-white py-3 rounded-xl font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:shadow-blue-500/25 hover:scale-[1.02] active:scale-[0.98]">
          <span class="relative z-10 flex items-center justify-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            {{ get_t('gallery.add_selected_object') }}
          </span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>
        </button>

        <p class="text-xs text-gray-400 text-center">
          {{ selected_objects && selected_objects.length > 0 ?
          get_t('gallery.objects_selected').replace('{count}', selected_objects.length) :
          get_t('gallery.no_objects_selected')
          }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Global popup system - Professional design -->
<div v-if="show_popup" class="fixed inset-0 z-[600] flex items-center justify-center">
  <!-- Enhanced overlay with stronger blur effect -->
  <div class="absolute inset-0 bg-black/60 backdrop-blur-md transition-all duration-300" @click="close_popup"></div>

  <!-- Enhanced popup content with better styling -->
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-2xl w-full mx-4 z-10 transform transition-all duration-300 scale-100 overflow-hidden">

    <!-- Header with better styling -->
    <div class="relative bg-gradient-to-r from-rose-600/10 to-rose-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <h2 class="text-xl font-semibold text-white flex items-center" v-html="popup_title">
        </h2>
        <button @click="close_popup"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content area with better scrolling -->
    <div class="relative p-6 overflow-y-auto max-h-[calc(80vh-120px)]">
      <div class="text-gray-100" v-html="popup_content"></div>
    </div>
  </div>
</div>

<!-- Preferences popup - Fixed height with proper scrolling -->
<div v-if="show_preferences_popup"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]"
  @click.self="close_preferences_popup">
  <!-- Popup content with max-height -->
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-sm sm:max-w-2xl md:max-w-4xl w-full overflow-hidden transform scale-100 transition-all duration-300 ease-out flex flex-col max-h-[90vh] md:max-h-[80vh]">
    <!-- Header with gradient background -->
    <div
      class="relative bg-gradient-to-r from-gray-600/20 to-gray-500/10 border-gray-500/30 border-b p-4 md:p-6 flex-shrink-0">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3 md:gap-4">
          <div
            class="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shadow-xl bg-gradient-to-br from-gray-500 to-gray-600 shadow-gray-500/25">
            <svg class="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
              </path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
          </div>
          <h2 class="text-lg md:text-xl font-semibold text-gray-400">{{ get_t('preferences.title') }}</h2>
        </div>
        <button @click="close_preferences_popup"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <div class="flex flex-1 overflow-hidden">
      <!-- Left column: Categories - Responsive -->
      <div class="w-16 md:w-48 border-r border-gray-700 p-2 md:p-4 space-y-3 overflow-y-auto">
        <div v-for="(category, index) in preferences_categories" :key="index" @click="scroll_to_category(category.id)"
          class="py-2 px-2 md:px-3 rounded-md cursor-pointer hover:bg-gray-700 flex items-center justify-center md:justify-start gap-3 relative group"
          :class="{ 'bg-gray-700': active_preferences_category === category.id }"
          :title="get_t(`preferences.categories.${category.id}`)">
          <!-- Icons for categories -->
          <svg v-if="category.id === 'interface'" class="w-5 h-5 text-gray-300 flex-shrink-0" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
            </path>
          </svg>
          <svg v-else-if="category.id === 'editor'" class="w-5 h-5 text-gray-300 flex-shrink-0" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
            </path>
          </svg>
          <svg v-else-if="category.id === 'chapters'" class="w-5 h-5 text-gray-300 flex-shrink-0" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253">
            </path>
          </svg>
          <!-- Text only visible on medium screens and up -->
          <span class="hidden md:block text-sm">
            {{ get_t(`preferences.categories.${category.id}`) }}
          </span>
        </div>
      </div>

      <!-- Right column: Options with overflow scrolling and custom scrollbar -->
      <div class="flex-1 p-3 md:p-4 overflow-y-auto" ref="preferences_options_container">
        <!-- Interface section - visible by default -->
        <div :id="'pref_' + preferences_categories[0].id" class="mb-8"
          v-show="active_preferences_category === preferences_categories[0].id">
          <h3 class="text-lg font-medium text-white mb-4 border-b border-gray-700 pb-2">
            {{ get_t(`preferences.categories.${preferences_categories[0].id}`) }}
          </h3>

          <!-- Language option -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-300 mb-2">
              {{ get_t('preferences.interface.language') }}
            </label>
            <select v-model="preferences.interface.language"
              class="w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white"
              @change="change_language(preferences.interface.language, false)">
              <option value="en">English</option>
              <option value="es">Español</option>
              <option value="cn">中文</option>
              <option value="jp">日本語</option>
              <option value="kr">한국어</option>
            </select>
          </div>

          <!-- Interface scale option -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-300 mb-2">
              {{ get_t('preferences.interface.scale') }}
            </label>
            <select v-model="preferences.interface.scale"
              class="w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white"
              @change="apply_interface_scale(preferences.interface.scale)">
              <!-- Don't add symbols on values! -->
              <option value="75">75%</option>
              <option value="100">100%</option>
              <option value="125">125%</option>
              <option value="150">150%</option>
            </select>
          </div>
        </div>

        <!-- Editor section - hidden by default -->
        <div :id="'pref_' + preferences_categories[1].id" class="mb-8"
          v-show="active_preferences_category === preferences_categories[1].id">
          <h3 class="text-lg font-medium text-white mb-4 border-b border-gray-700 pb-2">
            {{ get_t(`preferences.categories.${preferences_categories[1].id}`) }}
          </h3>

          <!-- Autosave Section -->
          <div class="bg-gray-800/30 rounded-xl p-4 mb-6 border border-gray-700/50">
            <h4 class="text-sm font-semibold text-gray-200 mb-4 flex items-center gap-2">
              <svg class="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
              </svg>
              {{ get_t('preferences.sections.autosave') }}
            </h4>

            <!-- Autosave option -->
            <div class="mb-4">
              <div
                class="flex items-center justify-between p-3 bg-gray-900/40 rounded-lg border border-gray-600/40 hover:bg-gray-900/60 transition-colors">
                <div class="flex-1">
                  <label class="text-sm font-medium text-gray-200 cursor-pointer">
                    {{ get_t('preferences.editor.autosave') }}
                  </label>
                  <p class="text-xs text-gray-400 mt-1">{{ get_t('preferences.editor.autosave_description') }}</p>
                </div>
                <div class="flex items-center ml-4">
                  <input type="checkbox" v-model="preferences.editor.autosave_enabled"
                    class="h-5 w-5 accent-rose-600 rounded cursor-pointer">
                </div>
              </div>
            </div>

            <!-- Autosave interval option -->
            <div class="mb-4" v-if="preferences.editor.autosave_enabled">
              <label class="block text-sm font-medium text-gray-200 mb-2">
                {{ get_t('preferences.editor.autosave_interval') }}
              </label>
              <select v-model="preferences.editor.autosave_interval"
                @change="validate_premium_dropdown_option('min_autosave_interval', preferences.editor.autosave_interval)"
                class="w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white focus:border-rose-500 focus:outline-none">
                <option value="2">2 {{ get_t('preferences.editor.minutes') }} ✨</option>
                <option value="5">5 {{ get_t('preferences.editor.minutes') }} ✨</option>
                <option value="10">10 {{ get_t('preferences.editor.minutes') }} ✨</option>
                <option value="20">20 {{ get_t('preferences.editor.minutes') }}</option>
              </select>
            </div>
          </div>

          <!-- History Section -->
          <div class="bg-gray-800/30 rounded-xl p-4 mb-6 border border-gray-700/50">
            <h4 class="text-sm font-semibold text-gray-200 mb-4 flex items-center gap-2">
              <svg class="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              {{ get_t('preferences.sections.history') }}
            </h4>

            <!-- History steps option -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-200 mb-2">
                {{ get_t('preferences.editor.history_steps') }}
              </label>
              <select
                @change="validate_premium_dropdown_option('max_undo_steps', preferences.editor.history_steps); set_history_length()"
                v-model="preferences.editor.history_steps"
                class="w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white focus:border-rose-500 focus:outline-none">
                <option value="20">20</option>
                <option value="50">50 ✨</option>
                <option value="80">80 ✨</option>
              </select>
              <p class="text-xs text-gray-400 mt-1">{{ get_t('preferences.editor.history_steps_description') }}</p>
            </div>
          </div>

          <!-- Object Behavior Section -->
          <div class="bg-gray-800/30 rounded-xl p-4 mb-6 border border-gray-700/50">
            <h4 class="text-sm font-semibold text-gray-200 mb-4 flex items-center gap-2">
              <svg class="w-4 h-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z">
                </path>
              </svg>
              {{ get_t('preferences.sections.object_behavior') }}
            </h4>

            <!-- Transformer keep ratio option -->
            <div class="mb-4">
              <div
                class="flex items-center justify-between p-3 bg-gray-900/40 rounded-lg border border-gray-600/40 hover:bg-gray-900/60 transition-colors">
                <div class="flex-1">
                  <label class="text-sm font-medium text-gray-200 cursor-pointer">
                    {{ get_t('preferences.editor.transformer_keep_ratio') }}
                  </label>
                  <p class="text-xs text-gray-400 mt-1"
                    v-html="get_t('preferences.editor.transformer_keep_ratio_description')"></p>
                </div>
                <div class="flex items-center ml-4">
                  <input type="checkbox" v-model="preferences.editor.transformer_keep_ratio"
                    class="h-5 w-5 accent-rose-600 rounded cursor-pointer">
                </div>
              </div>
            </div>

            <!-- Insert to global panel option -->
            <div class="mb-4">
              <div
                class="flex items-center justify-between p-3 bg-gray-900/40 rounded-lg border border-gray-600/40 hover:bg-gray-900/60 transition-colors">
                <div class="flex-1">
                  <label class="text-sm font-medium text-gray-200 cursor-pointer">
                    {{ get_t('preferences.editor.insert_to_global_panel') }}
                  </label>
                  <p class="text-xs text-gray-400 mt-1">
                    {{ get_t('preferences.editor.insert_to_global_panel_description') }}
                  </p>
                </div>
                <div class="flex items-center ml-4">
                  <input type="checkbox" v-model="preferences.editor.insert_to_global_panel"
                    class="h-5 w-5 accent-rose-600 rounded cursor-pointer">
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Chapters section -->
        <div :id="'pref_' + preferences_categories[2].id" class="mb-8"
          v-show="active_preferences_category === preferences_categories[2].id">
          <h3 class="text-lg font-medium text-white mb-4 border-b border-gray-700 pb-2">
            {{ get_t(`preferences.categories.${preferences_categories[2].id}`) }}
          </h3>

          <!-- Chapter Behavior Section -->
          <div class="bg-gray-800/30 rounded-xl p-4 mb-6 border border-gray-700/50">
            <h4 class="text-sm font-semibold text-gray-200 mb-4 flex items-center gap-2">
              <svg class="w-4 h-4 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253">
                </path>
              </svg>
              {{ get_t('preferences.sections.chapter_behavior') }}
            </h4>

            <!-- Open last page option -->
            <div class="mb-4">
              <div
                class="flex items-center justify-between p-3 bg-gray-900/40 rounded-lg border border-gray-600/40 hover:bg-gray-900/60 transition-colors">
                <div class="flex-1">
                  <label class="text-sm font-medium text-gray-200 cursor-pointer">
                    {{ get_t('preferences.chapters.open_last_page') }}
                  </label>
                  <p class="text-xs text-gray-400 mt-1">{{ get_t('preferences.chapters.open_last_page_description') }}
                  </p>
                </div>
                <div class="flex items-center ml-4">
                  <input type="checkbox" v-model="preferences.chapters.open_last_page"
                    class="h-5 w-5 accent-rose-600 rounded cursor-pointer">
                </div>
              </div>
            </div>

            <!-- Show pages navigation by default option -->
            <div class="mb-4">
              <div
                class="flex items-center justify-between p-3 bg-gray-900/40 rounded-lg border border-gray-600/40 hover:bg-gray-900/60 transition-colors">
                <div class="flex-1">
                  <label class="text-sm font-medium text-gray-200 cursor-pointer">
                    {{ get_t('preferences.chapters.show_pages_navigation_by_default') }}
                  </label>
                  <p class="text-xs text-gray-400 mt-1">{{
                    get_t('preferences.chapters.show_pages_navigation_by_default_description') }}</p>
                </div>
                <div class="flex items-center ml-4">
                  <input type="checkbox" v-model="preferences.chapters.show_pages_navigation_by_default"
                    class="h-5 w-5 accent-rose-600 rounded cursor-pointer">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Footer with Save/Cancel buttons -->
    <div class="flex justify-end p-4 border-t border-gray-700 gap-2 flex-shrink-0">
      <button @click="close_preferences_popup" class="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-md text-white">
        {{ get_t('preferences.cancel') }}
      </button>
      <button @click.stop="save_preferences(false)"
        class="px-4 py-2 bg-rose-600 hover:bg-rose-500 rounded-md text-white">
        {{ get_t('preferences.save') }}
      </button>
    </div>
  </div>
</div>

<!-- Export Modal -->
<div v-if="show_export_dialog"
  class="fixed inset-0 bg-black/60 backdrop-blur-md z-50 flex items-center justify-center p-4"
  @click.self="close_export_modal">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl w-96 max-w-md overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-emerald-600/20 to-green-600/20 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center">
            <i data-lucide="download" class="w-5 h-5 text-white"></i>
          </div>
          <h3 class="text-xl font-semibold text-white">{{ get_t('export.title') }}</h3>
        </div>
        <button @click="close_export_modal"
          class="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-gray-700/50">
          <i data-lucide="x" class="w-5 h-5"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">

      <div class="space-y-4">
        <!-- Format Selection -->
        <div>
          <label class="block text-sm font-medium text-gray-300 mb-2">{{ get_t('export.format') }}</label>
          <select v-model="export_format"
            class="w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:border-rose-500 focus:outline-none">
            <option value="png">{{ get_t('export.formats.png') }}</option>
            <option value="jpeg">{{ get_t('export.formats.jpeg') }}</option>
            <option value="webp">{{ get_t('export.formats.webp') }}</option>
          </select>
        </div>

        <!-- Quality (for JPEG and WebP) -->
        <div v-if="export_format === 'jpeg' || export_format === 'webp'">
          <label class="block text-sm font-medium text-gray-300 mb-2">{{ get_t('export.quality') }}</label>
          <div class="flex items-center gap-3">
            <input type="range" v-model="export_quality" min="0.1" max="1" step="0.1" class="flex-1 accent-rose-600">
            <span class="text-sm text-gray-300 w-12">{{ Math.round(export_quality * 100) }}%</span>
          </div>
          <p class="text-xs text-gray-400 mt-1">{{ get_t('export.quality_description') }}</p>
        </div>

        <!-- Resolution Multiplier -->
        <div>
          <label class="block text-sm font-medium text-gray-300 mb-2">{{ get_t('export.resolution_multiplier')
            }}</label>
          <div class="flex items-center gap-3">
            <input type="range" v-model="export_pixel_ratio" min="0.5" max="4" step="0.1"
              class="flex-1 accent-rose-600">
            <span class="text-sm text-gray-300 w-16">{{ parseFloat(export_pixel_ratio).toFixed(1) }}x</span>
          </div>
          <p class="text-xs text-gray-400 mt-1">{{ get_t('export.resolution_description') }}</p>

          <!-- Limitation warning for free users -->
          <div v-if="!can_export_at_current_settings"
            class="flex items-center gap-2 mt-2 p-2 bg-red-900 bg-opacity-20 rounded border border-red-600">
            <i data-lucide="alert-triangle" class="w-4 h-4 text-red-500 flex-shrink-0"></i>
            <p class="text-xs text-red-200">{{ export_limitation_message }}</p>
          </div>

          <div v-if="!is_premium && can_export_at_current_settings"
            class="flex items-center gap-2 mt-2 p-2 bg-rose-900 bg-opacity-20 rounded border border-rose-600">
            <i data-lucide="star" class="w-4 h-4 text-yellow-500 flex-shrink-0"></i>
            <p class="text-xs text-yellow-200">{{ get_t('export.premium_resolution_note') }}</p>
          </div>
        </div>

        <!-- Preview info -->
        <div class="bg-gray-700 p-3 rounded-md">
          <div class="text-sm text-gray-300">
            <div>{{ get_t('export.final_resolution') }}: {{ calculated_final_resolution.width }} × {{
              calculated_final_resolution.height }}px</div>
            <div class="text-xs text-gray-400 mt-1">{{ get_t('export.base_canvas') }}: {{ canvas_width }} × {{
              canvas_height }}px</div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex gap-3 mt-6">
        <button @click="close_export_modal"
          class="flex-1 px-4 py-3 bg-gray-700/50 text-white rounded-xl hover:bg-gray-600/50 transition-all duration-200 border border-gray-600/30">
          {{ get_t('export.cancel') }}
        </button>
        <button @click="export_canvas_image" :disabled="export_processing || !can_export_at_current_settings"
          class="flex-1 px-4 py-3 rounded-xl transition-all duration-200 font-medium" :class="can_export_at_current_settings && !export_processing 
            ? 'bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:from-emerald-400 hover:to-green-500 shadow-lg shadow-emerald-600/25' 
            : 'bg-gray-600/50 text-gray-400 cursor-not-allowed border border-gray-600/30'">
          <span v-if="export_processing">{{ get_t('export.processing') }}</span>
          <span v-else>{{ export_button_text }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Context Menu -->
<div v-if="show_context_menu" id="mouse_context_menu"
  class="fixed rounded-md shadow-lg z-50 border border-gray-600 min-w-48 backdrop-blur-sm bg-gray-900/80"
  :style="{ left: context_menu_position.x + 'px', top: context_menu_position.y + 'px' }" @click.stop>
  <ul class="py-1">
    <li>
      <a href="#" @click.prevent="handle_copy_style"
        :class="can_copy_style(context_menu_target) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
        class="block px-4 py-2 text-sm">
        <span class="flex items-center gap-2">
          {{ get_t('menu.edit_submenu.copy_style') }}
          <span class="text-amber-400">✨</span>
        </span>
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="handle_paste_style" class="block px-4 py-2 text-sm"
        :class="can_paste_style(context_menu_target) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'">
        <span class="flex items-center gap-2">
          {{ get_t('menu.edit_submenu.paste_style') }}
          <span class="text-amber-400">✨</span>
        </span>
      </a>
    </li>
    <li>
      <hr class="border-t border-gray-600 my-1">
    </li>
    <!-- Image flip options - only for images -->
    <li v-if="context_menu_target && is_selected_object_image()">
      <a href="#" @click.prevent="flip_selected_image_horizontal(); hide_context_menu()"
        class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
        {{ get_t('menu.image_submenu.flip_horizontal') }}
      </a>
    </li>
    <li v-if="context_menu_target && is_selected_object_image()">
      <a href="#" @click.prevent="flip_selected_image_vertical(); hide_context_menu()"
        class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
        {{ get_t('menu.image_submenu.flip_vertical') }}
      </a>
    </li>
    <li v-if="context_menu_target && is_selected_object_image()">
      <hr class="border-t border-gray-600 my-1">
    </li>
    <li>
      <a href="#" @click.prevent="cut_selected_object(); hide_context_menu()"
        :class="(context_menu_target || selected_object) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
        class="block px-4 py-2 text-sm">
        {{ get_t('menu.edit_submenu.cut') }}
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="copy_selected_object(); hide_context_menu()"
        :class="(context_menu_target || selected_object) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
        class="block px-4 py-2 text-sm">
        {{ get_t('menu.edit_submenu.copy') }}
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="paste_copied_object(); hide_context_menu()"
        class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
        {{ get_t('menu.edit_submenu.paste') }}
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="delete_selected_object(); hide_context_menu()"
        :class="(context_menu_target || selected_object) ? 'text-white hover:bg-rose-600' : 'text-gray-500 cursor-not-allowed'"
        class="block px-4 py-2 text-sm">
        {{ get_t('menu.edit_submenu.delete') }}
      </a>
    </li>
    <li>
      <hr class="border-t border-gray-600 my-1">
    </li>
    <li>
      <a href="#" @click.prevent="deselect_all(); hide_context_menu()"
        class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
        {{ get_t('menu.edit_submenu.deselect_all') }}
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="select_global_layers(); hide_context_menu()"
        class="block px-4 py-2 text-sm text-white hover:bg-rose-600">
        {{ get_t('menu.edit_submenu.select_global_layers') }}
      </a>
    </li>
  </ul>
</div>

<!-- Cookie Consent Popup -->
<div id="cookie-consent" v-if="show_cookie_consent"
  class="fixed bottom-4 left-4 w-96 bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl p-5 z-[2500]">
  <div class="flex flex-col space-y-4">
    <div class="flex items-start space-x-3">
      <div class="flex-shrink-0">
        <div class="w-8 h-8 bg-gradient-to-br from-rose-500 to-rose-600 rounded-lg flex items-center justify-center">
          <i data-lucide="cookie" class="w-4 h-4 text-white"></i>
        </div>
      </div>
      <div class="flex-1">
        <h3 class="text-sm font-semibold text-white" v-text="get_t('cookies.title')"></h3>
        <p class="text-xs text-gray-300 mt-1 leading-relaxed" v-text="get_t('cookies.message')"></p>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row gap-2">
      <button @click="accept_cookies"
        class="flex-1 bg-gradient-to-r from-rose-500 to-rose-600 text-white text-xs px-4 py-2.5 rounded-xl hover:from-rose-400 hover:to-rose-500 transition-all duration-200 font-medium shadow-lg shadow-rose-600/25"
        v-text="get_t('cookies.accept')">
      </button>
      <button @click="show_cookie_info"
        class="flex-1 bg-gray-700/50 text-gray-300 text-xs px-4 py-2.5 rounded-xl hover:bg-gray-600/50 transition-all duration-200 border border-gray-600/30"
        v-text="get_t('cookies.more_info')">
      </button>
    </div>
  </div>
</div>

<!-- Cookie Info Modal -->
<div v-if="show_cookie_info_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-rose-600/20 to-rose-600/20 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-rose-500 to-rose-600 rounded-xl flex items-center justify-center">
            <i data-lucide="cookie" class="w-5 h-5 text-white"></i>
          </div>
          <h2 class="text-xl font-semibold text-white" v-text="get_t('cookies.info_title')"></h2>
        </div>
        <button @click="close_cookie_info"
          class="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-gray-700/50">
          <i data-lucide="x" class="w-5 h-5"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">

      <div
        class="space-y-4 text-sm text-gray-300 overflow-y-auto max-h-[60vh] pr-2 scrollbar-thin scrollbar-track-gray-700 scrollbar-thumb-gray-500 scrollbar-thumb-rounded">
        <div>
          <h3 class="font-medium text-white mb-2" v-text="get_t('cookies.essential_title')"></h3>
          <p v-text="get_t('cookies.essential_description')"></p>
        </div>

        <div>
          <h3 class="font-medium text-white mb-2" v-text="get_t('cookies.session_title')"></h3>
          <p v-text="get_t('cookies.session_description')"></p>
        </div>

        <div class="pt-4 border-t border-gray-600">
          <p class="text-xs text-gray-400" v-text="get_t('cookies.policy_note')"></p>
        </div>
      </div>

      <div class="flex justify-end mt-6 pt-4 border-t border-gray-600/30">
        <button @click="accept_cookies_and_close"
          class="bg-gradient-to-r from-rose-500 to-rose-600 text-white px-6 py-3 rounded-xl hover:from-rose-400 hover:to-rose-500 transition-all duration-200 font-medium shadow-lg shadow-rose-600/25"
          v-text="get_t('cookies.accept_and_close')">
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Premium Restriction Modal -->
<div v-if="is_premium_modal_open"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[9999]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
    <!-- Header -->
    <div class="relative border-b border-gray-600/30 p-6" :class="{
            'bg-gradient-to-r from-gray-600/20 to-gray-700/20': premium_modal.action === 'registered_only',
            'bg-gradient-to-r from-amber-600/20 to-orange-600/20': premium_modal.action !== 'registered_only' && premium_modal.target_tier === 'premium',
            'bg-gradient-to-r from-blue-600/20 to-blue-700/20': premium_modal.action !== 'registered_only' && premium_modal.target_tier === 'creator_pro'
        }">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div v-if="premium_modal.action === 'registered_only'"
            class="w-10 h-10 bg-gradient-to-br from-gray-500 to-gray-700 rounded-xl flex items-center justify-center">
            <i data-lucide="user" class="w-5 h-5 text-white"></i>
          </div>
          <div v-else-if="premium_modal.target_tier === 'premium'"
            class="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
            <i data-lucide="crown" class="w-5 h-5 text-white"></i>
          </div>
          <div v-else
            class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
            <i data-lucide="zap" class="w-5 h-5 text-white"></i>
          </div>
          <h2 v-if="premium_modal.action === 'registered_only'" class="text-xl font-semibold text-white">{{
            get_t('user.registration_required') }}</h2>
          <h2 v-else-if="premium_modal.target_tier === 'premium'" class="text-xl font-semibold text-white">{{
            get_t('premium.premium_required') }}</h2>
          <h2 v-else class="text-xl font-semibold text-white">{{ get_t('premium.creator_pro_required') }}</h2>
        </div>
        <button @click="close_premium_modal"
          class="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-gray-700/50">
          <i data-lucide="x" class="w-5 h-5"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">

      <div class="mb-6">
        <p class="text-gray-300 mb-4" v-html="premium_modal.message"></p>

        <!-- Registration features list -->
        <div v-if="premium_modal.action === 'registered_only'"
          class="bg-gradient-to-r from-gray-800/50 to-gray-700/30 border border-gray-600/30 rounded-lg p-4">
          <h3 class="text-gray-300 font-medium mb-2">{{ get_t('user.registration_benefits') }}:</h3>
          <ul class="text-sm text-gray-200 space-y-1">
            <li class="flex items-center gap-2">
              <i data-lucide="check" class="w-4 h-4 text-green-400"></i>
              {{ get_t('user.save_documents') }}
            </li>
            <li class="flex items-center gap-2">
              <i data-lucide="check" class="w-4 h-4 text-green-400"></i>
              {{ get_t('user.load_documents') }}
            </li>
            <li class="flex items-center gap-2">
              <i data-lucide="check" class="w-4 h-4 text-green-400"></i>
              {{ get_t('user.export_images') }}
            </li>
            <li class="flex items-center gap-2">
              <i data-lucide="check" class="w-4 h-4 text-green-400"></i>
              {{ get_t('user.auto_save') }}
            </li>
          </ul>
        </div>

        <!-- Premium/Creator Pro features list -->
        <div v-else :class="{
                    'bg-gradient-to-r from-yellow-900/20 to-yellow-800/20 border border-yellow-600/30': premium_modal.target_tier === 'premium',
                    'bg-gradient-to-r from-blue-900/20 to-blue-800/20 border border-blue-600/30': premium_modal.target_tier === 'creator_pro'
                }" class="rounded-lg p-4">
          <h3 :class="{
                        'text-yellow-300': premium_modal.target_tier === 'premium',
                        'text-blue-300': premium_modal.target_tier === 'creator_pro'
                    }" class="font-medium mb-2">
            {{ premium_modal.target_tier === 'premium' ? get_t('premium.premium_features') :
            get_t('premium.premium_features') }}:
          </h3>
          <ul :class="{
                        'text-yellow-100': premium_modal.target_tier === 'premium',
                        'text-blue-100': premium_modal.target_tier === 'creator_pro'
                    }" class="text-sm space-y-1">
            <template v-for="feature in get_tier_features(premium_modal.target_tier)" :key="feature.key">
              <li class="flex items-center gap-2" :class="{ 'opacity-50': !feature.enabled }">
                <i :data-lucide="feature.enabled ? 'check' : 'minus'" :class="{
                                    'text-green-400': feature.enabled,
                                    'text-gray-500': !feature.enabled
                                }" class="w-4 h-4"></i>
                <span v-if="feature.key === 'pages_per_chapter'">
                  {{ get_t('premium.pages_per_chapter').replace('{count}', feature.count) }}
                </span>
                <span v-else>
                  {{ get_t('premium.' + feature.key) }}
                </span>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <div class="flex gap-3">
        <!-- Registration action buttons -->
        <template v-if="premium_modal.action === 'registered_only'">
          <button @click="close_premium_modal"
            class="flex-1 px-4 py-3 bg-gray-700/50 text-white rounded-xl hover:bg-gray-600/50 transition-all duration-200 border border-gray-600/30">
            {{ get_t('actions.continue_guest') }}
          </button>
          <button @click="show_register_form"
            class="flex-1 px-4 py-3 bg-gradient-to-r from-rose-500 to-rose-600 text-white rounded-xl hover:from-rose-400 hover:to-rose-500 transition-all duration-200 font-medium shadow-lg shadow-rose-600/25">
            {{ get_t('actions.register_now') }}
          </button>
        </template>

        <!-- Premium action buttons -->
        <template v-else>
          <button @click="close_premium_modal"
            class="flex-1 px-4 py-3 bg-gray-700/50 text-white rounded-xl hover:bg-gray-600/50 transition-all duration-200 border border-gray-600/30">
            {{ get_t('actions.continue_free') }}
          </button>
          <button @click="show_pricing(); close_premium_modal()" :class="{
                            'bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-400 hover:to-orange-500 shadow-amber-600/25': premium_modal.target_tier === 'premium',
                            'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500 shadow-blue-600/25': premium_modal.target_tier === 'creator_pro'
                        }"
            class="flex-1 px-4 py-3 text-white rounded-xl transition-all duration-200 font-medium shadow-lg">
            {{ premium_modal.target_tier === 'premium' ? get_t('premium.upgrade_now') : get_t('premium.upgrade_now') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</div>

<!-- Authentication Modal -->
<div v-if="show_auth_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-rose-600/10 to-rose-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-rose-500 to-rose-600 rounded-xl flex items-center justify-center shadow-lg">
            <i data-lucide="user" class="w-5 h-5 text-white"></i>
          </div>
          <h2 class="text-xl font-semibold text-white">
            {{ auth_mode === 'login' ? get_t('auth.login') : get_t('auth.register') }}
          </h2>
        </div>
        <button @click="close_auth_modal"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 space-y-6">
      <!-- Google Auth Button -->
      <button v-if="google_auth_url" @click="open_google_auth"
        class="w-full group relative overflow-hidden bg-white/5 hover:bg-white/10 border border-gray-600/50 hover:border-gray-500/50 rounded-xl p-4 text-white transition-all duration-300 hover:shadow-lg hover:shadow-rose-500/10">
        <div class="flex items-center justify-center gap-3">
          <div class="relative">
            <svg class="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
          </div>
          <span class="font-medium">{{ get_t('auth.google_login') }}</span>
        </div>
        <div
          class="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
        </div>
      </button>

      <!-- Divider -->
      <div class="relative">
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-gradient-to-r from-transparent via-gray-600/50 to-transparent"></div>
        </div>
        <div class="relative flex justify-center">
          <span
            class="px-4 py-1 bg-gray-800/80 backdrop-blur-sm text-gray-400 text-sm rounded-full border border-gray-600/30">
            {{ get_t('common.or') }}
          </span>
        </div>
      </div>

      <!-- Error Message -->
      <div v-if="auth_errors.general" class="p-4 bg-red-500/10 border border-red-500/20 rounded-xl backdrop-blur-sm">
        <div class="flex items-center gap-3">
          <div class="flex-shrink-0">
            <svg class="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd" />
            </svg>
          </div>
          <p class="text-red-400 text-sm font-medium">{{ auth_errors.general }}</p>
        </div>
      </div>

      <!-- Auth Form -->
      <form @submit.prevent="handle_auth_submit" class="space-y-5">
        <!-- Email -->
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-300">
            {{ get_t('auth.email') }}
          </label>
          <div class="relative">
            <input type="email" v-model="auth_form.email" :class="{ 
                                'border-red-500/50 bg-red-500/5': auth_errors.email,
                                'border-gray-600/50 hover:border-gray-500/50 focus:border-rose-500/50': !auth_errors.email
                            }"
              class="w-full bg-gray-700/30 backdrop-blur-sm border rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:ring-2 focus:ring-rose-500/20 transition-all duration-200"
              :placeholder="get_t('auth.email')" required>
            <div
              class="absolute inset-0 rounded-xl bg-gradient-to-r from-rose-500/0 via-rose-500/5 to-rose-500/0 opacity-0 focus-within:opacity-100 transition-opacity duration-300 pointer-events-none">
            </div>
          </div>
          <p v-if="auth_errors.email" class="text-red-400 text-xs font-medium">{{ auth_errors.email }}</p>
        </div>

        <!-- Password -->
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-300">
            {{ get_t('auth.password') }}
          </label>
          <div class="relative">
            <input type="password" v-model="auth_form.password" :class="{ 
                                'border-red-500/50 bg-red-500/5': auth_errors.password,
                                'border-gray-600/50 hover:border-gray-500/50 focus:border-rose-500/50': !auth_errors.password
                            }"
              class="w-full bg-gray-700/30 backdrop-blur-sm border rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:ring-2 focus:ring-rose-500/20 transition-all duration-200"
              :placeholder="get_t('auth.password')" required>
            <div
              class="absolute inset-0 rounded-xl bg-gradient-to-r from-rose-500/0 via-rose-500/5 to-rose-500/0 opacity-0 focus-within:opacity-100 transition-opacity duration-300 pointer-events-none">
            </div>
          </div>
          <p v-if="auth_errors.password" class="text-red-400 text-xs font-medium">{{ auth_errors.password }}</p>
        </div>

        <!-- Confirm Password (Register only) -->
        <div v-if="auth_mode === 'register'" class="space-y-2">
          <label class="block text-sm font-medium text-gray-300">
            {{ get_t('auth.confirm_password') }}
          </label>
          <div class="relative">
            <input type="password" v-model="auth_form.confirm_password" :class="{ 
                                'border-red-500/50 bg-red-500/5': auth_errors.confirm_password,
                                'border-gray-600/50 hover:border-gray-500/50 focus:border-rose-500/50': !auth_errors.confirm_password
                            }"
              class="w-full bg-gray-700/30 backdrop-blur-sm border rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:ring-2 focus:ring-rose-500/20 transition-all duration-200"
              :placeholder="get_t('auth.confirm_password')" required>
            <div
              class="absolute inset-0 rounded-xl bg-gradient-to-r from-rose-500/0 via-rose-500/5 to-rose-500/0 opacity-0 focus-within:opacity-100 transition-opacity duration-300 pointer-events-none">
            </div>
          </div>
          <p v-if="auth_errors.confirm_password" class="text-red-400 text-xs font-medium">{{
            auth_errors.confirm_password }}</p>
        </div>

        <!-- Submit Button -->
        <button type="submit" :disabled="auth_loading"
          class="w-full group relative overflow-hidden bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white py-4 rounded-xl font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:shadow-rose-500/25 hover:scale-[1.02] active:scale-[0.98]">
          <span v-if="auth_loading" class="flex items-center justify-center gap-3">
            <div class="animate-spin rounded-full h-5 w-5 border-2 border-white/30 border-t-white"></div>
            <span>{{ get_t('status.loading') }}</span>
          </span>
          <span v-else class="relative z-10">
            {{ auth_mode === 'login' ? get_t('auth.login') : get_t('auth.register') }}
          </span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>
        </button>
      </form>
    </div>

    <!-- Footer -->
    <div class="bg-gray-800/30 backdrop-blur-sm border-t border-gray-600/30 p-6 space-y-4">
      <!-- Password Reset Link (Login only) -->
      <div v-if="auth_mode === 'login'" class="text-center">
        <button @click="show_password_reset_modal"
          class="group inline-flex items-center gap-2 text-gray-400 hover:text-rose-400 text-sm font-medium transition-colors duration-200">
          <svg class="w-4 h-4 group-hover:rotate-12 transition-transform duration-200" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-3.586l4.293-4.293a1 1 0 011.414 0l1.793 1.793A6 6 0 1121 9z" />
          </svg>
          {{ get_t('auth.forgot_password') }}
        </button>
      </div>

      <!-- Mode Switch -->
      <div class="text-center">
        <button @click="switch_auth_mode"
          class="group inline-flex items-center gap-2 text-gray-400 hover:text-rose-400 text-sm font-medium transition-colors duration-200">
          <svg class="w-4 h-4 group-hover:scale-110 transition-transform duration-200" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          {{ auth_mode === 'login' ? get_t('auth.switch_to_register') : get_t('auth.switch_to_login') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Notification Modal -->
<div v-if="notification_modal.show"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[700]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform scale-100 transition-all duration-300 ease-out">
    <!-- Header with Status Color -->
    <div :class="{
            'bg-gradient-to-r from-green-600/20 to-green-500/10 border-green-500/30': notification_modal.type === 'success',
            'bg-gradient-to-r from-red-600/20 to-red-500/10 border-red-500/30': notification_modal.type === 'error',
            'bg-gradient-to-r from-yellow-600/20 to-yellow-500/10 border-yellow-500/30': notification_modal.type === 'warning',
            'bg-gradient-to-r from-gray-600/20 to-gray-500/10 border-gray-500/30': notification_modal.type === 'info'
        }" class="relative border-b p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4">
          <div :class="{
                        'bg-gradient-to-br from-green-500 to-green-600 shadow-green-500/25': notification_modal.type === 'success',
                        'bg-gradient-to-br from-red-500 to-red-600 shadow-red-500/25': notification_modal.type === 'error',
                        'bg-gradient-to-br from-yellow-500 to-yellow-600 shadow-yellow-500/25': notification_modal.type === 'warning',
                        'bg-gradient-to-br from-gray-500 to-gray-600 shadow-gray-500/25': notification_modal.type === 'info'
                    }" class="w-12 h-12 rounded-xl flex items-center justify-center shadow-xl">
            <svg v-if="notification_modal.type === 'success'" class="w-6 h-6 text-white" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <svg v-else-if="notification_modal.type === 'error'" class="w-6 h-6 text-white" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            <svg v-else-if="notification_modal.type === 'warning'" class="w-6 h-6 text-white" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.34 16.5c-.77.833.192 2.5 1.732 2.5z">
              </path>
            </svg>
            <svg v-else class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h3 :class="{
                        'text-green-400': notification_modal.type === 'success',
                        'text-red-400': notification_modal.type === 'error',
                        'text-yellow-400': notification_modal.type === 'warning',
                        'text-gray-400': notification_modal.type === 'info'
                    }" class="text-xl font-semibold">
            {{ notification_modal.type === 'success' ? get_t('common.success') :
            notification_modal.type === 'error' ? get_t('common.error') :
            notification_modal.type === 'warning' ? get_t('common.warning') :
            get_t('common.info') }}
          </h3>
        </div>
        <button @click="hide_notification_modal"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">
      <p class="text-gray-300 text-base leading-relaxed mb-6" v-html="notification_modal.message"></p>

      <div v-if="!notification_modal.auto_close" class="flex justify-end">
        <button @click="hide_notification_modal"
          class="group relative overflow-hidden bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-rose-500/25 hover:scale-105 active:scale-95">
          <span class="relative z-10">{{ get_t('common.ok') }}</span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Subscription Success Modal (No X button, forces refresh) -->
<div v-if="subscription_success_modal.show"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform scale-100 transition-all duration-300 ease-out">
    <!-- Header with Status Color -->
    <div :class="{
            'bg-gradient-to-r from-green-600/20 to-green-500/10 border-green-500/30': subscription_success_modal.type === 'success',
            'bg-gradient-to-r from-red-600/20 to-red-500/10 border-red-500/30': subscription_success_modal.type === 'error'
        }" class="relative border-b p-6">
      <div class="flex items-center justify-start">
        <div class="flex items-center gap-4">
          <div :class="{
                        'bg-gradient-to-br from-green-500 to-green-600 shadow-green-500/25': subscription_success_modal.type === 'success',
                        'bg-gradient-to-br from-red-500 to-red-600 shadow-red-500/25': subscription_success_modal.type === 'error'
                    }" class="w-12 h-12 rounded-xl flex items-center justify-center shadow-xl">
            <svg v-if="subscription_success_modal.type === 'success'" class="w-6 h-6 text-white" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
            <svg v-else class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          <h3 :class="{
                        'text-green-400': subscription_success_modal.type === 'success',
                        'text-red-400': subscription_success_modal.type === 'error'
                    }" class="text-xl font-semibold">
            {{ subscription_success_modal.type === 'success' ? get_t('common.success') : get_t('common.error') }}
          </h3>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">
      <p class="text-gray-300 text-base leading-relaxed mb-6" v-html="subscription_success_modal.message"></p>

      <div class="flex justify-end">
        <button @click="hide_subscription_success_modal"
          class="group relative overflow-hidden bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-rose-500/25 hover:scale-105 active:scale-95">
          <span class="relative z-10">{{ get_t('common.ok') }}</span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Page Refresh Modal (Legacy, not used) -->
<div v-if="show_refresh_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform scale-100 transition-all duration-300 ease-out">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-blue-600/10 to-blue-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </div>
          <h3 class="text-xl font-bold text-white">{{ get_t('subscription.refresh_required') }}</h3>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 space-y-4">
      <p class="text-gray-300 leading-relaxed">
        {{ get_t('subscription.refresh_message') }}
      </p>
    </div>

    <!-- Actions -->
    <div class="bg-gray-800/50 border-t border-gray-600/30 p-6">
      <button @click="handle_page_refresh()"
        class="group relative overflow-hidden bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-blue-500/25 hover:scale-105 active:scale-95 w-full">
        <span class="relative z-10">{{ get_t('subscription.refresh_page') }}</span>
        <div
          class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
        </div>
      </button>
    </div>
  </div>
</div>

<!-- Password Reset Modal -->
<div v-if="password_reset_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-rose-600/10 to-rose-500/5 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-rose-500 to-rose-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-3.586l4.293-4.293a1 1 0 011.414 0l1.793 1.793A6 6 0 1121 9z" />
            </svg>
          </div>
          <h2 class="text-xl font-semibold text-white">{{ get_t('auth.forgot_password') }}</h2>
        </div>
        <button @click="hide_password_reset_modal"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">
      <!-- Form State -->
      <div v-if="!password_reset_sent" class="space-y-6">
        <div class="text-center">
          <p class="text-gray-300 leading-relaxed">{{ get_t('auth.password_reset_instructions') }}</p>
        </div>

        <form @submit.prevent="send_password_reset" class="space-y-5">
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-300">
              {{ get_t('auth.email') }}
            </label>
            <div class="relative">
              <input type="email" v-model="password_reset_email"
                class="w-full bg-gray-700/30 backdrop-blur-sm border border-gray-600/50 hover:border-gray-500/50 focus:border-rose-500/50 rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:ring-2 focus:ring-rose-500/20 transition-all duration-200"
                :placeholder="get_t('auth.email')" required>
              <div
                class="absolute inset-0 rounded-xl bg-gradient-to-r from-rose-500/0 via-rose-500/5 to-rose-500/0 opacity-0 focus-within:opacity-100 transition-opacity duration-300 pointer-events-none">
              </div>
            </div>
          </div>

          <button type="submit" :disabled="auth_loading"
            class="w-full group relative overflow-hidden bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white py-4 rounded-xl font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:shadow-rose-500/25 hover:scale-[1.02] active:scale-[0.98]">
            <span v-if="auth_loading" class="flex items-center justify-center gap-3">
              <div class="animate-spin rounded-full h-5 w-5 border-2 border-white/30 border-t-white"></div>
              <span>{{ get_t('status.loading') }}</span>
            </span>
            <span v-else class="relative z-10">
              {{ get_t('auth.send_reset_email') }}
            </span>
            <div
              class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
            </div>
          </button>
        </form>
      </div>

      <!-- Success State -->
      <div v-else class="text-center space-y-6">
        <div class="flex justify-center">
          <div
            class="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-2xl shadow-green-500/25">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>

        <div class="space-y-3">
          <h3 class="text-xl font-semibold text-green-400">{{ get_t('common.success') }}</h3>
          <p class="text-gray-300 leading-relaxed">{{ get_t('auth.password_reset_sent') }}</p>
        </div>

        <button @click="hide_password_reset_modal"
          class="group relative overflow-hidden bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-rose-500/25 hover:scale-105 active:scale-95">
          <span class="relative z-10">{{ get_t('common.ok') }}</span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Templates Browser Modal -->
<div v-if="show_templates_modal"
  class="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-[600]">
  <div
    class="relative bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl border border-gray-600/50 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[80vh] overflow-hidden">
    <!-- Header -->
    <div class="relative bg-gradient-to-r from-purple-600/20 to-blue-600/20 border-b border-gray-600/30 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center">
            <i data-lucide="layout-template" class="w-5 h-5 text-white"></i>
          </div>
          <h2 class="text-xl font-bold text-white">{{ get_t('welcome.all_templates') }}</h2>
        </div>
        <button @click="close_templates_browser"
          class="text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg p-2 transition-all duration-200">
          <i data-lucide="x" class="w-5 h-5"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 overflow-y-auto max-h-[60vh]">
      <div v-if="loading_templates" class="flex items-center justify-center py-12">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-400 mx-auto mb-4"></div>
          <p class="text-gray-400">{{ get_t('status.loading') }}...</p>
        </div>
      </div>

      <div v-else-if="templates.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div v-for="template in templates" :key="template.id"
          @click="is_template_premium(template.id) && !user_data.is_premium ? show_premium_modal('premium', get_t('premium.premium_required')) : load_template(template.id)"
          class="group bg-gradient-to-br from-gray-700/30 to-gray-800/30 rounded-xl p-5 border border-gray-600/30 hover:border-purple-500/50 transition-all duration-300 cursor-pointer hover:shadow-xl hover:shadow-purple-500/10 hover:scale-105 relative"
          :class="{ 'opacity-60': is_template_premium(template.id) && !user_data.is_premium }">
          <!-- Premium Badge -->
          <div v-if="is_template_premium(template.id)" class="absolute top-3 right-3 z-10">
            <div
              class="flex items-center justify-center w-6 h-6 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full shadow-lg">
              <i data-lucide="sparkles" class="w-3 h-3 text-white"></i>
            </div>
          </div>

          <!-- Premium Overlay (for non-premium users) -->
          <div v-if="is_template_premium(template.id) && !user_data.is_premium"
            class="absolute inset-0 bg-black/40 backdrop-blur-[1px] rounded-xl flex items-center justify-center z-20">
            <div class="text-center">
              <i data-lucide="lock" class="w-6 h-6 text-amber-400 mx-auto mb-1"></i>
              <p class="text-xs text-amber-400 font-medium">{{ get_t('premium.required') }}</p>
            </div>
          </div>

          <!-- Template preview -->
          <div class="mb-4 aspect-[3/4] bg-gray-600/30 rounded-lg flex items-center justify-center overflow-hidden">
            <div v-if="template.thumbnail" class="w-full h-full">
              <img :src="template.thumbnail" :alt="template.name" class="w-full h-full object-contain rounded-lg" />
            </div>
            <div v-else class="flex flex-col items-center justify-center text-gray-400">
              <i data-lucide="image" class="w-12 h-12 mb-3"></i>
              <span class="text-sm">{{ get_t('welcome.template_preview') }}</span>
            </div>
          </div>

          <!-- Template info -->
          <div class="space-y-3">
            <h3 class="font-semibold text-white group-hover:text-purple-300 transition-colors text-center">{{
              template.name }}</h3>
            <p class="text-sm text-gray-400 text-center line-clamp-2">{{ template.description ||
              get_t('welcome.template_preview') }}</p>
            <div class="flex items-center justify-between pt-2">
              <span class="text-xs text-gray-500">{{ template.created_at ? new
                Date(template.created_at).toLocaleDateString() : '' }}</span>
              <button
                class="px-3 py-1.5 text-xs bg-purple-600/20 text-purple-400 rounded-lg group-hover:bg-purple-600/30 transition-colors font-medium">
                {{ get_t('welcome.use_template') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Pricing Full Screen -->
<div v-if="show_pricing_modal"
  class="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 z-[200] overflow-y-auto">
  <!-- Close button - floating top right -->
  <button @click="hide_pricing()"
    class="fixed top-6 right-6 z-10 text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-full p-3 transition-all duration-200 backdrop-blur-sm bg-gray-800/50 border border-gray-600/30">
    <i data-lucide="x" class="w-6 h-6"></i>
  </button>

  <!-- Header Section -->
  <div class="relative pt-16 pb-8">
    <div class="container mx-auto px-6 text-center">
      <div class="inline-flex items-center gap-3 mb-6">
        <div
          class="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center">
          <i data-lucide="crown" class="w-8 h-8 text-white"></i>
        </div>
      </div>
      <h1 class="text-4xl md:text-5xl font-bold text-white mb-4">{{ get_t('pricing.title') }}</h1>
      <p class="text-xl text-gray-400 max-w-2xl mx-auto mb-8">{{ get_t('pricing.subtitle') }}</p>

      <!-- Billing Cycle Toggle -->
      <div class="inline-flex items-center bg-gray-800/60 rounded-2xl p-2 border border-gray-600/30 backdrop-blur-xl">
        <button @click="billing_cycle = 'monthly'"
          :class="billing_cycle === 'monthly' ? 'bg-gray-700 text-white shadow-lg' : 'text-gray-400 hover:text-gray-300'"
          class="px-6 py-3 rounded-xl font-medium transition-all duration-300">
          {{ get_t('pricing.monthly') }}
        </button>
        <button @click="billing_cycle = 'yearly'"
          :class="billing_cycle === 'yearly' ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-lg' : 'text-gray-400 hover:text-gray-300'"
          class="px-6 py-3 rounded-xl font-medium transition-all duration-300 relative">
          {{ get_t('pricing.yearly') }}
          <span v-if="billing_cycle !== 'yearly'"
            class="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">
            {{ get_t('pricing.save_money') }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Pricing Tiers Section -->
  <div class="container mx-auto px-6 pb-12">
    <div class="grid gap-6 mx-auto" :class="[
            available_tiers.length === 2 ? 'grid-cols-1 md:grid-cols-2 max-w-4xl' : 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3 max-w-7xl'
        ]">
      <div v-for="tier in available_tiers" :key="tier.id"
        class="relative bg-gradient-to-br from-gray-800/60 to-gray-900/60 backdrop-blur-xl rounded-2xl p-6 border transition-all duration-300 hover:scale-[1.02] flex flex-col"
        :class="{
                    'border-amber-500/50 shadow-2xl shadow-amber-500/20': tier.highlight && tier.key !== 'creator_pro',
                    'border-blue-500/50 shadow-2xl shadow-blue-500/20': tier.highlight && tier.key === 'creator_pro',
                    'border-gray-600/30 hover:border-gray-500/50': !tier.highlight
                }">
        <!-- Popular/Best Value badge -->
        <div v-if="tier.highlight" class="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <div class="px-6 py-2 rounded-full text-sm font-bold shadow-lg text-white"
            :class="tier.key === 'creator_pro' ? 'bg-gradient-to-r from-blue-500 to-blue-600' : 'bg-gradient-to-r from-amber-500 to-amber-600'">
            {{ tier.key === 'creator_pro' ? get_t('pricing.best_value') : get_t('pricing.popular') }}
          </div>
        </div>

        <!-- Tier header -->
        <div class="text-center mb-6">
          <h3 class="text-xl font-bold text-white mb-2">{{ tier.name }}</h3>
          <p class="text-gray-400 text-sm mb-4">{{ tier.description }}</p>
          <div class="flex items-baseline justify-center gap-1">
            <span class="text-3xl font-bold text-white">{{ tier.currency }}{{ tier.price }}</span>
            <span v-if="tier.price > 0" class="text-gray-400 text-sm">/{{ tier.period }}</span>
          </div>
          <!-- Show billing info for yearly plans -->
          <div v-if="tier.price > 0 && billing_cycle === 'yearly' && tier.yearly_total" class="mt-2">
            <p class="text-xs text-gray-500">{{ tier.currency }}{{ tier.yearly_total }} {{
              get_t('pricing.billed_yearly') }}</p>
          </div>

          <div v-else-if="tier.price > 0" class="mt-2">
            <p class="text-xs text-gray-500">{{ get_t('pricing.billed_monthly') }}</p>
          </div>
          <!-- Show alignment text for free tier -->
          <div v-if="tier.price === 0" class="mt-2">
            <p class="text-xs text-gray-500">{{ get_t('pricing.free.pricing_note') }}</p>
          </div>
        </div>

        <!-- Features -->
        <div class="space-y-3 mb-6 flex-grow">
          <div v-for="(feature, index) in tier.features" :key="typeof feature === 'string' ? feature : feature.text">
            <!-- Credits display (large, centered) -->
            <div v-if="feature.display_type === 'credits'" class="flex items-center justify-center py-3 mb-2">
              <div class="text-center">
                <div class="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                  {{ feature.text }} {{ get_t('credits.credits_unit') }}
                </div>
              </div>
            </div>

            <!-- Separator line -->
            <div v-else-if="feature.display_type === 'separator'" class="pt-4 pb-2">
              <div class="flex items-center gap-3 mb-3 w-full">
                <div class="flex-1 h-px bg-gradient-to-r from-transparent via-gray-600/50 to-transparent"></div>
                <span class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ feature.text }}</span>
                <div class="flex-1 h-px bg-gradient-to-r from-transparent via-gray-600/50 to-transparent"></div>
              </div>
            </div>

            <!-- Normal features -->
            <div v-else class="flex items-start gap-3">
              <div class="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5"
                :class="(typeof feature === 'object' && feature.enabled === false) ? 'bg-gray-500/20' : 'bg-green-500/20'">
                <i data-lucide="check" class="w-3 h-3"
                  :class="(typeof feature === 'object' && feature.enabled === false) ? 'text-gray-400' : 'text-green-400'"></i>
              </div>
              <span class="text-sm"
                :class="(typeof feature === 'object' && feature.enabled === false) ? 'text-gray-400' : 'text-gray-300'"
                :title="(typeof feature === 'object' && feature.enabled === false) ? get_t('pricing.coming_soon') : ''">
                {{ typeof feature === 'string' ? feature : feature.text }}
              </span>
            </div>
          </div>

          <!-- Limitations for free tier -->
          <div v-if="tier.limitations && tier.limitations.length > 0" class="pt-3 border-t border-gray-600/30">
            <div v-for="limitation in tier.limitations"
              :key="typeof limitation === 'string' ? limitation : limitation.text" class="flex items-start gap-3 mb-2">
              <div class="flex-shrink-0 w-5 h-5 bg-red-500/20 rounded-full flex items-center justify-center mt-0.5">
                <i data-lucide="x" class="w-3 h-3 text-red-400"></i>
              </div>
              <span class="text-sm text-gray-400">{{ typeof limitation === 'string' ? limitation : limitation.text
                }}</span>
            </div>
          </div>
        </div>

        <!-- CTA Button -->
        <button @click="get_tier_button_action(tier)"
          :disabled="tier.is_current || pricing_loading || tier.id === 'free'"
          class="w-full py-3 rounded-xl font-semibold text-sm transition-all duration-300 shadow-lg" :class="{
                        'bg-gray-600/50 text-gray-400 cursor-not-allowed': tier.is_current || tier.id === 'free',
                        'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white shadow-amber-500/25 hover:scale-[1.02] active:scale-[0.98]': !tier.is_current && tier.highlight && tier.key !== 'creator_pro' && tier.id !== 'free',
                        'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500 text-white shadow-blue-500/25 hover:scale-[1.02] active:scale-[0.98]': !tier.is_current && tier.highlight && tier.key === 'creator_pro' && tier.id !== 'free',
                        'bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600 text-white hover:scale-[1.02] active:scale-[0.98]': !tier.is_current && !tier.highlight && tier.id !== 'free'
                    }">
          <span v-if="pricing_loading" class="flex items-center justify-center gap-2">
            <div class="animate-spin rounded-full h-4 w-4 border-2 border-white/30 border-t-white"></div>
            Loading...
          </span>
          <span v-else>{{ get_tier_button_text(tier) }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Scroll indicator for credits section -->
  <div v-if="show_credit_packs" class="text-center pb-6">
    <button @click="scroll_to_credits"
      class="inline-flex flex-col items-center gap-2 text-gray-400 hover:text-gray-300 transition-colors cursor-pointer group">
      <span class="text-sm">{{ get_t('credits.scroll_for_credits') }}</span>
      <div class="animate-bounce group-hover:animate-pulse">
        <i data-lucide="chevron-down" class="w-6 h-6"></i>
      </div>
    </button>
  </div>

  <!-- AI Credits Section (only show if enabled) -->
  <div v-if="show_credit_packs"
    class="bg-gradient-to-b from-gray-800/30 to-gray-900/60 backdrop-blur-xl border-t border-gray-600/30 py-16">
    <div class="container mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-white mb-4">{{ get_t('credits.title') }}</h2>
        <p class="text-xl text-gray-400 max-w-2xl mx-auto">{{ get_t('credits.subtitle') }}</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        <div v-for="pack in translated_credit_packs" :key="pack.id"
          class="relative bg-gradient-to-br from-gray-800/60 to-gray-900/60 backdrop-blur-xl rounded-2xl p-6 border border-gray-600/30 hover:border-blue-500/50 transition-all duration-300 hover:scale-[1.05] flex flex-col">
          <!-- Popular badge -->
          <div v-if="pack.popular" class="absolute -top-3 left-1/2 transform -translate-x-1/2">
            <div class="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-1 rounded-full text-xs font-bold">
              {{ get_t('pricing.popular') }}
            </div>
          </div>

          <!-- Pack info -->
          <div class="text-center flex-grow flex flex-col">
            <h4 class="text-xl font-bold text-white mb-2">{{ pack.name }}</h4>
            <p class="text-gray-400 text-sm mb-4 flex-grow">{{ pack.description }}</p>
            <div class="mb-6">
              <div class="flex items-baseline justify-center gap-2 mb-3">
                <span class="text-3xl font-bold text-blue-400">{{ pack.credits }}</span>
                <span class="text-gray-400">credits</span>
              </div>
              <div class="text-2xl font-bold text-white">
                {{ pack.currency }}{{ pack.price }}
              </div>
            </div>
          </div>

          <!-- Buy button -->
          <button @click="purchase_credits(pack.id)" :disabled="pricing_loading"
            class="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white rounded-xl font-bold transition-all duration-300 shadow-xl hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50">
            {{ get_t('credits.buy_now') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>